var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmLandingPageNewBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 246,
    viewBox: "0 0 1440 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V268H1440V0Z",
    fill: "url(#paint0_radial_26527_261466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.567 50.8709L445.725 51.1491L450.113 52.5977L449.131 53.9066L443.856 53.0821L439.429 51.6772L440.567 50.8709Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.095 49.158L434.925 49.1183L440.641 50.8848L439.43 51.679L434.638 51.5485L429.929 49.9836L431.095 49.158Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M443.855 53.0834L449.13 53.908L453.41 55.6387L452.176 56.9886L446.777 55.8109L442.645 53.8776L443.855 53.0834Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.04 54.2731L438.416 54.0656L436.242 53.9415L433.99 52.6613L434.636 51.5464L439.428 51.6769L443.856 53.0818L442.04 54.2731Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M450.112 52.5975L455.465 52.4101L459.965 53.948L458.895 55.8358L453.41 55.6373L449.13 53.9064L450.112 52.5975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M453.408 55.638L458.893 55.8364L463.266 57.7852L461.926 59.8846L456.315 59.3232L452.174 56.9879L453.408 55.638Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M459.965 53.9494L465.483 53.5045L470.075 55.2662L468.933 57.6162L463.267 57.7858L458.894 55.837L459.965 53.9494Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M463.267 57.7855L468.933 57.6158L473.398 59.8303L471.982 62.5202L466.173 62.4559L461.928 59.8849L463.267 57.7855Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M470.077 55.2651L475.729 54.8108L480.406 56.8869L479.222 59.4986L473.4 59.8294L468.935 57.6149L470.077 55.2651Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M473.399 59.83L479.222 59.4987L483.79 61.9844L482.339 65.0189L476.351 65.2887L471.983 62.5199L473.399 59.83Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M480.403 56.8875L486.158 56.7133L491.288 59.449L490.225 62.1766L483.788 61.9844L479.22 59.499L480.403 56.8875Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M483.789 61.9857L490.227 62.1781L495.269 66.2101L494.092 69.4436L487.563 68.4506L482.338 65.0204L483.789 61.9857Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M491.288 59.4502L497.031 60.5043L501.494 64.8791L500.744 67.8279L495.268 66.2098L490.226 62.1781L491.288 59.4502Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M501.494 64.8793L506.047 67.122L509.729 72.7292L509.144 75.7644L504.754 73.1287L500.743 67.8282L501.494 64.8793Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M504.755 73.1278L509.145 75.7635L512.373 81.9855L511.459 85.2463L507.292 82.3514L503.775 76.4342L504.755 73.1278Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M509.729 72.7276L513.451 75.9123L516.572 82.3879L516.042 85.4081L512.372 81.9848L509.144 75.7628L509.729 72.7276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M516.574 82.388L519.786 86.2468L522.575 93.2339L522.026 96.1731L518.737 92.2183L516.044 85.4082L516.574 82.388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M518.734 92.2176L522.024 96.1725L524.437 103.237L523.406 106.184L520.076 102.258L517.791 95.3472L518.734 92.2176Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M522.572 93.2351L525.572 97.467L528.266 104.606L527.657 107.433L524.436 103.239L522.023 96.1743L522.572 93.2351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M528.264 104.604L531.33 108.868L534.184 115.792L533.558 118.522L530.023 114.29L527.656 107.431L528.264 104.604Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M247.248 -5.80649L251.707 -2.56047L254.871 1.76589L253.046 3.22783L247.961 0.230274L245.355 -4.49676L247.248 -5.80649Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M440.092 54.207L445.396 56.5347L449.299 59.4106L447.661 60.5859L442.213 57.8673L437.691 54.0246L440.092 54.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M446.776 55.8113L452.175 56.989L456.316 59.3242L454.823 60.9921L449.3 59.4124L445.397 56.5363L446.776 55.8113Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M449.301 59.4117L454.824 60.9915L458.846 64.0955L457.126 66.2456L451.461 64.3529L447.663 60.5869L449.301 59.4117Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M458.846 64.0956L464.59 64.9545L468.756 68.2032L466.987 71.1724L461.095 70.1256L457.126 66.2454L458.846 64.0956Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M466.175 62.4557L471.984 62.5195L476.351 65.2889L474.713 68.4139L468.757 68.2026L464.591 64.9539L466.175 62.4557Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M468.754 68.2033L474.711 68.4145L479.052 71.6795L477.28 75.2194L471.164 74.991L466.985 71.1724L468.754 68.2033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M479.052 71.6793L486.028 71.9069L491.329 76.4819L489.821 80.2087L482.726 79.2361L477.28 75.2193L479.052 71.6793Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M487.563 68.4495L494.092 69.4425L498.634 74.3937L497.355 77.9467L491.33 76.4818L486.029 71.9068L487.563 68.4495Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M498.635 74.3946L503.775 76.4348L507.292 82.352L506.117 85.8645L501.366 83.5242L497.356 77.9476L498.635 74.3946Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M501.364 83.524L506.115 85.8638L509.134 92.1454L507.826 95.7524L503.508 93.2198L500.024 87.2515L501.364 83.524Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M507.291 82.3517L511.458 85.2466L514.221 91.815L513.034 95.1829L509.135 92.1453L506.116 85.8641L507.291 82.3517Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M509.134 92.1441L513.033 95.1815L515.359 101.881L513.985 105.279L510.386 102.202L507.826 95.7511L509.134 92.1441Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M514.222 91.8131L517.795 95.3474L520.078 102.258L518.802 105.411L515.362 101.881L513.036 95.1813L514.222 91.8131Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M515.36 101.882L518.801 105.413L520.743 112.248L519.241 115.383L515.951 111.955L513.986 105.28L515.36 101.882Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M520.076 102.26L523.406 106.186L525.503 113.131L524.093 116.034L520.742 112.248L518.799 105.413L520.076 102.26Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M520.743 112.248L524.095 116.034L525.98 122.721L524.325 125.575L520.956 122.026L519.241 115.383L520.743 112.248Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M525.502 113.131C526.838 114.706 527.514 115.384 528.85 116.958L531.21 123.858L529.591 126.485L525.978 122.721L524.092 116.034L525.502 113.131Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M530.027 114.291L533.561 118.522L536.245 124.865L535.071 127.532L531.213 123.857L528.852 116.958L530.027 114.291Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M525.978 122.72L529.591 126.483L531.766 132.737L529.972 135.333L526.152 131.929L524.322 125.574L525.978 122.72Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M515.36 101.882L518.801 105.413L520.743 112.248L519.241 115.383L515.951 111.955L513.986 105.28L515.36 101.882Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M235.167 -10.6365L239.134 -6.73646L241.162 -1.62235L238.633 -0.0680899L233.909 -3.74611L232.503 -9.2163L235.167 -10.6365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M241.163 -1.62351L245.93 1.72901L249.056 6.30485L246.677 7.91863L240.999 4.91936L238.634 -0.0692432L241.163 -1.62351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M247.963 0.228828L253.048 3.22639L257.011 7.2965L255.077 8.84135L249.056 6.30514L245.931 1.72888L247.963 0.228828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M257.011 7.29872L270.227 11.4102L268.334 12.738L260.237 11.9136L255.076 8.84357L257.011 7.29872Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M260.237 11.9113L275.078 14.2773L272.744 15.5825L263.688 15.6563L257.935 13.4708L260.237 11.9113Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M426.246 46.12L429.929 49.9832L434.97 54.8076L432.908 55.3006L427.379 50.6302L424.153 45.6761L426.246 46.12Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M442.216 57.8693L440.401 58.6114L434.971 54.8072L429.929 49.9838L442.216 57.8693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M434.97 54.8061L440.401 58.6103L443.986 63.1209L441.95 64.5857L436.299 60.5887L432.908 55.2991L434.97 54.8061Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M443.984 63.1222L449.601 66.1184L453.384 70.7352L451.387 73.1145L445.563 69.9979L441.948 64.5872L443.984 63.1222Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M453.384 70.7351L459.216 72.8073L463.246 77.3078L461.321 80.4463L455.288 78.3777L451.386 73.1144L453.384 70.7351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M461.095 70.1274L466.987 71.1742L471.166 74.9928L469.311 78.3867L463.248 77.3087L459.218 72.8082L461.095 70.1274Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M463.247 77.307L469.31 78.3851L473.639 82.4958L471.835 86.1398L465.574 85.2367L461.322 80.4455L463.247 77.307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M471.165 74.9906L477.281 75.219L482.728 79.2351L481.032 83.0129L473.639 82.4949L469.31 78.3843L471.165 74.9906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M473.64 82.496L481.033 83.0138L486.743 87.8737L485.252 91.7252L477.735 90.5477L471.836 86.1398L473.64 82.496Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M482.727 79.2353L489.821 80.2083L494.554 85.4273L493.117 89.2855L486.741 87.8733L481.031 83.0129L482.727 79.2353Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M486.742 87.8744L493.117 89.2871L497.298 94.9324L496.006 98.8245L490.384 97.0569L485.251 91.7261L486.742 87.8744Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M494.556 85.428L500.026 87.2513L503.51 93.2195L502.176 97.0182L497.3 94.9315L493.118 89.2862L494.556 85.428Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M497.299 94.9315L502.175 97.0181L505.181 103.201L503.95 107.008L499.694 104.738L496.007 98.8235L497.299 94.9315Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M505.178 103.201L509.034 105.836L511.218 112.32L509.949 115.953L506.569 113.291L503.948 107.009L505.178 103.201Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M510.387 102.203L513.987 105.28L515.951 111.955L514.505 115.35L511.222 112.319L509.037 105.835L510.387 102.203Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M515.952 111.955L519.242 115.383L520.957 122.026L519.371 125.147L516.232 121.905L514.506 115.35L515.952 111.955Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M516.232 121.904L519.37 125.146L521.022 131.544L519.525 134.706L516.522 131.716L514.861 125.31L516.232 121.904Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M521.021 131.546L524.423 134.78L526.406 140.797L524.799 143.737L521.331 140.879L519.525 134.708L521.021 131.546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M235.167 -10.6365L239.134 -6.73646L241.162 -1.62235L238.633 -0.0680899L233.909 -3.74611L232.503 -9.2163L235.167 -10.6365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M453.384 70.7351L459.216 72.8073L463.246 77.3078L461.321 80.4463L455.288 78.3777L451.386 73.1144L453.384 70.7351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M471.165 74.9906L477.281 75.219L482.728 79.2351L481.032 83.0129L473.639 82.4949L469.31 78.3843L471.165 74.9906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M482.727 79.2353L489.821 80.2083L494.554 85.4273L493.117 89.2855L486.741 87.8733L481.031 83.0129L482.727 79.2353Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M225.602 -6.10418L230.574 -2.12878L232.148 3.25535L227.955 5.01885L222.245 1.18467L221.116 -4.42433L225.602 -6.10418Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M233.911 -3.74809L238.634 -0.0700762L240.999 4.91852L237.882 6.60668L232.149 3.25566L230.576 -2.12889L233.911 -3.74809Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M240.996 4.9206L246.675 7.91987L250.419 12.0588L247.497 13.7392L240.632 11.2955L237.879 6.60875L240.996 4.9206Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M240.634 11.2952L247.499 13.7389L252.044 16.8662L248.247 18.7395L240.116 17.1532L236.754 13.0607L240.634 11.2952Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M250.421 12.0573L257.934 13.4707L263.688 15.6562L260.726 17.3089L252.043 16.865L247.499 13.7378L250.421 12.0573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M263.689 15.6566L279.719 16.3027L276.657 17.7316L266.707 18.7174L260.727 17.3089L263.689 15.6566Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M266.705 18.7195L283.535 17.8242L279.473 19.6241L267.655 20.9957L262.795 20.6432L266.705 18.7195Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M401.359 21.8901L410.055 30.8582L407.291 30.065L401.225 25.0375L398.335 20.7428L401.359 21.8901Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M401.224 25.0356L407.29 30.0631L410.229 35.106L406.968 35.6495L400.506 31.1982L397.602 25.2948L401.224 25.0356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M410.053 30.8573L418.675 40.5734L416.101 40.3716L410.227 35.1069L407.289 30.0642L410.053 30.8573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M410.23 35.1074L416.105 40.3723L419.154 46.0198L416.192 47.0416L409.875 42.2683L406.97 35.6511L410.23 35.1074Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M418.678 40.5753L424.153 45.6766L427.379 50.6306L424.951 51.1781L419.153 46.0218L416.104 40.3738L418.678 40.5753Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M419.154 46.0202L424.953 51.177L428.179 57.2351L425.484 58.8506L419.226 54.0642L416.193 47.042L419.154 46.0202Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M428.178 57.235L433.998 61.9633L437.475 68.1789L435.035 70.417L428.759 65.9496L425.483 58.8504L428.178 57.235Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M436.298 60.5888L441.948 64.5859L445.563 69.9965L443.393 72.1866L437.475 68.1785L433.998 61.9635L436.298 60.5888Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M437.476 68.1794L443.395 72.1877L447.197 78.2458L445.028 81.042L438.666 77.2478L435.037 70.4177L437.476 68.1794Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M445.561 69.9977L451.386 73.1145L455.288 78.3777L453.271 81.2753L447.195 78.2459L443.392 72.1877L445.561 69.9977Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M447.197 78.2459L453.273 81.2749L457.478 86.802L455.606 89.9897L449.102 87.2403L445.026 81.0419L447.197 78.2459Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M457.476 86.8002L463.749 88.6318L468.427 93.1959L466.898 96.5075L460.207 95.1826L455.604 89.9884L457.476 86.8002Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M465.572 85.2371L471.833 86.1402L477.732 90.5481L476.206 94.2018L468.427 93.1973L463.749 88.6339L465.572 85.2371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M468.43 93.197L476.209 94.2015L482.574 99.2428L481.472 102.814L473.305 101.126L466.9 96.5087L468.43 93.197Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M482.574 99.2414L489.179 100.889L493.804 106.552L492.992 110.323L486.707 108.355L481.473 102.813L482.574 99.2414Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M490.383 97.0548L496.005 98.8224L499.692 104.737L498.65 108.608L493.802 106.552L489.176 100.889L490.383 97.0548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M493.803 106.553L498.651 108.61L501.947 114.698L501.287 118.541L496.53 116.298L492.991 110.324L493.803 106.553Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M501.948 114.699L505.573 117.092L507.95 123.424L507.344 127.249L503.736 124.769L501.288 118.542L501.948 114.699Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M506.569 113.292L509.949 115.954L511.889 122.399L510.854 126.057L507.947 123.424L505.57 117.093L506.569 113.292Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M507.947 123.422L510.855 126.054L512.733 132.453L512.121 136.209L509.246 133.57L507.342 127.248L507.947 123.422Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M511.89 122.398L514.859 125.31L516.519 131.716L515.406 135.197L512.733 132.454L510.856 126.055L511.89 122.398Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M512.732 132.456L515.404 135.199L517.226 141.497L516.585 145.17L513.985 142.494L512.121 136.213L512.732 132.456Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M517.226 141.496L520.13 144.187L522.361 150.221L521.707 153.84L518.877 151.294L516.584 145.17L517.226 141.496Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M216.046 -8.80909L221.115 -4.42207L222.244 1.18693L218.967 1.87677L214.181 -3.0861L212.489 -8.22668L216.046 -8.80909Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M214.183 -3.08497L218.968 1.87747L221.508 6.55502L219.698 6.32791L211.896 -3.69633L212.964 -3.30446L214.183 -3.08497Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M222.25 1.18639L227.959 5.02057L229.827 10.1404L227.324 10.1046L221.511 6.55377L218.972 1.87623L222.25 1.18639Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M309.19 14.761L326.523 11.8496L323.663 13.7133L306.687 15.9814L309.19 14.761Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M326.527 11.8503L337.842 9.93399L342.773 10.2305L339.577 12.7887L330.32 14.3302L323.663 13.7116L326.527 11.8503Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M342.774 10.2311L352.031 9.03908L357.406 10.8027L353.924 14.0956L345.325 14.8409L339.574 12.787L342.774 10.2311Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M355.536 7.46118L364.72 7.24529L369.383 8.77734L365.769 10.7503L357.405 10.8012L352.03 9.03757L355.536 7.46118Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M357.406 10.8029L365.77 10.752L369.951 14.4764L366.252 18.5378L358.565 18.0499L353.923 14.0958L357.406 10.8029Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M369.385 8.78007L377.401 10.1307L380.83 13.6232L377.14 16.0277L369.952 14.4775L365.772 10.753L369.385 8.78007Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M369.952 14.4769L377.139 16.0271L380.199 21.7299L376.163 26.3157L369.474 24.7471L366.253 18.5382L369.952 14.4769Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M380.831 13.6215L387.87 16.5681L390.908 21.4594L387.059 24.2721L380.201 21.7288L377.141 16.026L380.831 13.6215Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M380.198 21.7294L387.056 24.2722L389.776 31.0914L385.403 35.976L378.633 33.7171L376.161 26.3152L380.198 21.7294Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M390.905 21.4609L397.601 25.2967L400.505 31.2001L396.586 34.2984L389.777 31.0923L387.056 24.2736L390.905 21.4609Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M400.509 31.1997L406.971 35.6511L409.875 42.268L405.964 45.5619L399.128 41.9123L396.589 34.298L400.509 31.1997Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M399.127 41.9134L405.963 45.5624L408.458 53.653L403.642 58.8492L396.532 55.8009L394.501 46.9932L399.127 41.9134Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M408.457 53.6527L415.383 57.492L417.962 65.7373L413.02 71.0054L405.65 67.9156L403.641 58.8486L408.457 53.6527Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M419.224 54.0633L425.482 58.8496L428.759 65.949L425.046 69.4816L417.964 65.7361L415.384 57.491L419.224 54.0633Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M417.964 65.7371L425.045 69.4824L427.824 77.558L422.804 82.8851L415.121 80.0306L413.02 71.0057L417.964 65.7371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M428.762 65.9499L435.038 70.4173L438.666 77.2475L435.123 80.8888L427.826 77.5577L425.048 69.4827L428.762 65.9499Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M427.825 77.5583L435.123 80.8897L438.202 88.4679L433.148 93.8713L425.1 91.5648L422.806 82.885L427.825 77.5583Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M438.202 88.4678L445.769 91.0298L449.234 97.787L444.182 103.322L435.725 101.905L433.149 93.8712L438.202 88.4678Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M449.103 87.2402L455.607 89.9896L460.21 95.1843L457.115 99.1967L449.234 97.788L445.769 91.0297L449.103 87.2402Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M449.233 97.7855L457.114 99.1952L461.032 104.82L456.012 110.573L447.113 110.413L444.18 103.32L449.233 97.7855Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M460.209 95.1833L466.899 96.5074L473.304 101.125L470.227 105.46L461.032 104.82L457.113 99.1953L460.209 95.1833Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M473.302 101.125L481.47 102.814L486.703 108.356L483.45 112.853L475.185 111.681L470.226 105.46L473.302 101.125Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M475.188 111.681L483.454 112.854L486.894 119.285L482.406 124.905L473.938 124.333L470.207 117.513L475.188 111.681Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M486.703 108.356L492.988 110.323L496.528 116.297L493.549 120.734L486.89 119.285L483.451 112.854L486.703 108.356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M486.893 119.284L493.552 120.733L496.082 127.218L492.469 132.423L485.422 131.577L482.405 124.905L486.893 119.284Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M496.081 127.217L501.352 128.981L503.504 135.39L501.024 140.041L495.245 138.847L492.469 132.422L496.081 127.217Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M503.733 124.768L507.341 127.248L509.245 133.57L507.654 137.47L503.501 135.391L501.349 128.983L503.733 124.768Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M503.501 135.392L507.654 137.471L509.896 143.702L508.681 147.734L503.959 146.155L501.022 140.044L503.501 135.392Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M509.898 143.701L513.265 146.053L516.001 152.033L516.058 155.453L512.122 153.494L508.683 147.733L509.898 143.701Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M513.985 142.492L516.584 145.168L518.877 151.293L518.973 154.569L515.999 152.032L513.263 146.052L513.985 142.492Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M516.002 152.033L518.976 154.569L523.76 163.157L520.274 160.868L516.059 155.453L516.002 152.033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M279.666 20.1018L296.934 17.8633L295.011 19.0296L278.205 20.4925L279.666 20.1018Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M296.933 17.8632L314.016 15.6348L311.618 17.659L302.347 19.1462L295.011 19.0291L296.933 17.8632Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M302.349 19.1457L311.62 17.6589L318.387 18.6484L315.831 21.5429L307.009 22.3822L300.316 21.0055L302.349 19.1457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M314.017 15.6335L323.663 13.7119L330.316 14.3281L327.461 17.2747L318.386 18.6477L311.619 17.6582L314.017 15.6335Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M318.385 18.6471L327.461 17.2742L333.422 19.6035L330.376 23.5934L321.838 24.1176L315.83 21.5416L318.385 18.6471Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M333.423 19.6042L342.054 18.7561L347.008 22.8865L343.534 28.0289L335.51 27.8334L330.381 23.5965L333.423 19.6042Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M345.322 14.8389L353.925 14.096L358.562 18.0477L354.946 22.9812L347.008 22.8875L342.054 18.7567L345.322 14.8389Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M347.006 22.8868L354.944 22.9804L358.724 29.3948L354.897 35.7443L347.616 34.4025L343.532 28.0291L347.006 22.8868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M358.726 29.3948L365.52 30.6092L367.715 38.3519L363.367 45.3387L357.433 44.1591L354.899 35.7443L358.726 29.3948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M369.472 24.7468L376.16 26.3159L378.632 33.7173L374.153 39.9149L367.713 38.3519L365.518 30.6094L369.472 24.7468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M378.632 33.7164L385.403 35.9753L387.587 44.2302L382.669 50.6413L376.006 48.5561L374.153 39.9137L378.632 33.7164Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M376.006 48.556L382.669 50.6412L384.318 59.9055L378.991 67.3107L372.474 65.2636L371.128 55.8072L376.006 48.556Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M387.592 44.2306L394.503 46.9913L396.534 55.799L391.258 62.3356L384.323 59.906L382.674 50.6417L387.592 44.2306Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M396.53 55.8006L403.64 58.8482L405.65 67.9152L400.081 74.5156L392.82 71.9455L391.253 62.3372L396.53 55.8006Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M392.823 71.9451L400.084 74.5147L401.681 84.1885L395.668 91.6948L388.404 89.4534L387.123 79.4254L392.823 71.9451Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M401.68 84.1889L409.313 86.6601L411.045 96.1225L404.772 103.635L397.073 101.624L395.667 91.6947L401.68 84.1889Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M415.123 80.0287L422.806 82.8831L425.1 91.5636L419.1 98.2249L411.046 96.1221L409.315 86.6598L415.123 80.0287Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M411.043 96.1234L419.096 98.2265L421.053 107.198L414.564 114.733L406.393 113.212L404.77 103.636L411.043 96.1234Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M421.056 107.197L429.573 108.63L431.833 116.839L425.166 124.447L416.488 123.704L414.568 114.732L421.056 107.197Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M435.722 101.904L444.179 103.32L447.112 110.414L440.843 117.273L431.83 116.839L429.57 108.63L435.722 101.904Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M447.115 110.412L456.014 110.572L460.226 117.102L453.945 124.095L443.474 124.456L440.847 117.272L447.115 110.412Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M443.471 124.459L453.942 124.098L458.125 131.272L451.638 138.895L440.531 139.59L436.658 132.229L443.471 124.459Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M460.223 117.104L470.206 117.514L473.936 124.334L468.191 131.065L458.126 131.272L453.943 124.098L460.223 117.104Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M473.936 124.333L482.405 124.905L485.422 131.577L480.663 137.795L471.865 137.877L468.191 131.064L473.936 124.333Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M471.868 137.876L480.666 137.794L484.24 144.179L479.966 150.562L470.791 151.31L466.292 144.992L471.868 137.876Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M484.237 144.179L491.789 144.372L495.604 150.297L492.879 155.801L484.782 156.268L479.962 150.562L484.237 144.179Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M495.244 138.848L501.024 140.042L503.961 146.153L502 150.878L495.604 150.297L491.79 144.372L495.244 138.848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M495.606 150.298L502.002 150.879L506.326 156.348L505.264 160.907L498.222 160.941L492.881 155.802L495.606 150.298Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M503.963 146.153L508.685 147.732L512.124 153.493L511.716 157.389L506.327 156.347L502.002 150.878L503.963 146.153Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M506.325 156.346L511.715 157.389L516.755 162.446L517.338 166.075L511.258 165.563L505.263 160.905L506.325 156.346Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M516.758 162.446L521.355 163.982L527.251 168.713L529.335 171.508L524.059 170.383L517.341 166.075L516.758 162.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M245.626 17.9752L260.172 20.4434L245.004 17.075L245.626 17.9752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M260.173 20.4446L275.652 21.4121L274.273 22.0101L259.226 20.2213L260.173 20.4446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M275.653 21.4117L291.449 21.7656L289.581 23.3026L281.039 23.2348L274.274 22.0093L275.653 21.4117Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M281.039 23.2338L289.581 23.302L296.039 25.0742L293.599 27.2003L285.097 26.6284L279.018 24.4634L281.039 23.2338Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M291.448 21.7667L300.314 21.0061L307.008 22.3828L304.626 24.948L296.038 25.0763L289.58 23.3033L291.448 21.7667Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M296.039 25.0745L304.627 24.9467L310.547 27.7344L307.671 30.8414L299.289 30.1419L293.599 27.201L296.039 25.0745Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M307.009 22.3824L315.831 21.5431L321.844 24.1211L318.963 27.7877L310.547 27.7349L304.628 24.9476L307.009 22.3824Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M310.547 27.7345L318.963 27.7872L324.141 32.0447L320.862 36.2147L312.786 35.0156L307.672 30.8415L310.547 27.7345Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M324.139 32.0448L332.173 32.668L336.45 38.8644L332.811 44.1645L325.23 42.075L320.859 36.2148L324.139 32.0448Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M335.509 27.8331L343.534 28.0285L347.618 34.4023L343.893 40.469L336.451 38.8644L332.174 32.668L335.509 27.8331Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M336.452 38.8642L343.899 40.4707L347.132 49.1023L343.205 55.6046L336.312 52.1948L332.814 44.1639L336.452 38.8642Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M347.131 49.1019L351.093 50.8356L353.341 51.3495L354.625 60.0244L350.327 67.1946L345.172 65.2162L343.204 55.6043L347.131 49.1019Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M357.432 44.1573L363.366 45.3365L364.922 54.1214L360.288 61.6486L354.625 60.0234L353.336 51.3465L357.432 44.1573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M354.625 60.0237L360.288 61.6493L361.418 71.0335L356.772 78.4936L351.334 76.2395L350.327 67.1943L354.625 60.0237Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M364.922 54.1226L371.129 55.8067L372.475 65.2635L367.394 72.9991L361.418 71.0339L360.288 61.6498L364.922 54.1226Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M361.416 71.0351L367.392 72.9999L368.485 82.8529L363.58 90.4801L357.849 88.0433L356.77 78.4953L361.416 71.0351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M372.474 65.2632L378.992 67.3103L380.249 77.1805L374.807 85.0273L368.487 82.8515L367.394 72.9988L372.474 65.2632Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M368.487 82.8526L374.806 85.0284L375.974 95.1115L370.892 102.819L364.848 100.315L363.581 90.4801L368.487 82.8526Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M380.249 77.1813L387.12 79.425L388.401 89.453L382.665 97.3416L375.973 95.1121L374.806 85.0281L380.249 77.1813Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M375.976 95.1119L382.669 97.3415L384.006 107.42L378.815 115.149L372.436 112.721L370.895 102.82L375.976 95.1119Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M384.007 107.419L391.105 109.516L392.707 119.357L387.462 127.087L380.726 124.91L378.816 115.149L384.007 107.419Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M397.072 101.622L404.771 103.633L406.394 113.209L400.24 121.103L392.704 119.356L391.103 109.515L397.072 101.622Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M392.705 119.359L400.242 121.106L402.185 130.484L396.934 138.23L389.816 136.507L387.462 127.089L392.705 119.359Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M402.186 130.482L410.191 131.632L412.544 140.331L407.322 148.146L399.801 147.11L396.935 138.228L402.186 130.482Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M416.486 123.704L425.164 124.447L427.447 132.576L421.04 140.611L412.541 140.332L410.188 131.633L416.486 123.704Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M412.543 140.33L421.041 140.611L423.857 148.427L418.69 156.408L410.749 156.315L407.32 148.146L412.543 140.33Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M427.449 132.576L436.66 132.227L440.532 139.589L434.134 147.712L423.858 148.427L421.042 140.611L427.449 132.576Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M440.532 139.589L451.639 138.893L456.087 145.831L450.31 153.567L439.413 154.786L434.133 147.712L440.532 139.589Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M439.412 154.786L450.309 153.568L455.803 159.827L451.436 167.257L440.87 168.915L434.381 162.678L439.412 154.786Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M456.085 145.83L466.289 144.992L470.788 151.31L466.11 158.387L455.802 159.827L450.309 153.566L456.085 145.83Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M455.804 159.826L466.111 158.387L472.013 163.875L468.721 170.602L458.431 172.559L451.437 167.256L455.804 159.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M472.012 163.874L481.525 162.493L487.958 167.297L485.993 173.174L476.264 175.101L468.721 170.602L472.012 163.874Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M484.784 156.269L492.881 155.802L498.222 160.94L496.555 166.21L487.958 167.298L481.525 162.495L484.784 156.269Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M487.96 167.297L496.557 166.208L503.582 170.462L503.045 175.43L494.068 177.048L485.994 173.174L487.96 167.297Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M503.579 170.462L511.221 169.859L518.835 173.735L519.692 177.827L511.568 178.903L503.042 175.43L503.579 170.462Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M511.257 165.564L517.337 166.075L524.055 170.383L525.556 173.768L518.834 173.735L511.221 169.859L511.257 165.564Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M518.837 173.735L525.559 173.768L533.701 177.487L535.792 180.817L528.545 181.163L519.695 177.827L518.837 173.735Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M361.416 71.0351L367.392 72.9999L368.485 82.8529L363.58 90.4801L357.849 88.0433L356.77 78.4953L361.416 71.0351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M368.487 82.8526L374.806 85.0284L375.974 95.1115L370.892 102.819L364.848 100.315L363.581 90.4801L368.487 82.8526Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M455.804 159.826L466.111 158.387L472.013 163.875L468.721 170.602L458.431 172.559L451.437 167.256L455.804 159.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M472.012 163.874L481.525 162.493L487.958 167.297L485.993 173.174L476.264 175.101L468.721 170.602L472.012 163.874Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M195.381 -13.1409L203.075 -7.89432L207.07 -2.48681L202.473 -1.17829L193.617 -5.41841L190.519 -11.9632L195.381 -13.1409Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M206.141 -7.74162L217.593 2.02575L214.879 1.98637L207.072 -2.48661L203.078 -7.89455L206.141 -7.74162Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M207.073 -2.48707L214.88 1.98592L219.309 6.59647L214.86 8.01902L205.853 4.66627L202.477 -1.17854L207.073 -2.48707Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M219.309 6.59642L227.322 10.1053L231.897 13.837L227.721 15.1843L218.467 12.972L214.855 8.01656L219.309 6.59642Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 10.1405L242.426 16.1504L240.041 16.404L231.896 13.8369L227.321 10.1047L229.825 10.1405Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M242.423 16.1508L256.203 20.4395L253.766 21.0538L245.271 19.301L240.037 16.4048L242.423 16.1508Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M245.272 19.3004L253.766 21.0536L259.305 23.541L255.555 24.9476L245.983 24.0359L241.383 20.599L245.272 19.3004Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M256.208 20.4388L270.59 23.6621L267.985 24.7866L259.308 23.5405L253.77 21.0532L256.208 20.4388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M259.304 23.5402L267.981 24.7863L273.547 27.3223L269.825 28.9701L260.319 28.2053L255.554 24.9468L259.304 23.5402Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M270.589 23.6617L279.019 24.4639L285.098 26.6289L282.249 28.3859L273.551 27.3218L267.985 24.7858L270.589 23.6617Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M285.097 26.629L293.599 27.2008L299.293 30.1445L296.163 32.6366L287.601 31.4161L282.248 28.3864L285.097 26.629Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M287.602 31.4166L296.165 32.6371L301.112 36.6055L297.284 39.064L288.344 37.4994L283.842 33.4208L287.602 31.4166Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M301.11 36.6067L309.374 38.3324L313.764 43.6864L309.864 46.6735L301.428 44.1258L297.282 39.0652L301.11 36.6067Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M312.783 35.0178L320.859 36.2169L325.229 42.0771L321.566 46.2905L313.762 43.6869L309.372 38.3329L312.783 35.0178Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M313.763 43.6862L321.568 46.289L325.263 53.4861L321.327 57.0672L313.549 53.1057L309.864 46.6733L313.763 43.6862Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M325.262 53.4851L332.443 57.374L335.336 66.9105L331.435 71.1461L324.48 65.2838L321.326 57.0662L325.262 53.4851Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M336.314 52.194L343.207 55.6038L345.175 65.2153L341.166 71.3178L335.341 66.9094L332.449 57.3725L336.314 52.194Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M335.339 66.9105L341.164 71.3193L342.142 79.7581L338.376 84.5441L333.467 80.2866L331.438 71.1461L335.339 66.9105Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M342.141 79.7574L347.169 82.7371L348.395 91.6952L344.891 96.8415L340.038 92.3526L338.375 84.5434L342.141 79.7574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M351.332 76.2405L356.77 78.4954L357.85 88.043L353.639 94.7929L348.393 91.696L347.167 82.737L351.332 76.2405Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M348.396 91.6965L353.642 94.7942L355.217 104.069L352.076 109.439L347.216 104.904L344.892 96.8427L348.396 91.6965Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M357.852 88.0448L363.587 90.4835L364.849 100.317L360.675 107.204L355.216 104.069L353.641 94.7946L357.852 88.0448Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M364.849 100.318L370.893 102.822L372.435 112.723L368.381 119.674L362.702 116.603L360.676 107.205L364.849 100.318Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M362.701 116.602L368.381 119.673L370.941 129.004L368.777 134.555L363.746 130.434L360.011 122.094L362.701 116.602Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M370.945 129.005L376.857 131.881L380.026 140.968L378.447 146.552L373.274 142.864L368.78 134.556L370.945 129.005Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 124.913L387.461 127.09L389.815 136.507L386.182 143.492L380.024 140.969L376.856 131.882L380.724 124.913Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M380.024 140.967L386.183 143.49L390.023 152.163L389.072 157.798L383.737 154.673L378.445 146.551L380.024 140.967Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M390.023 152.164L396.442 154.146L401.002 162.254L400.71 168.001L395.202 165.551L389.073 157.798L390.023 152.164Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M399.801 147.11L407.321 148.146L410.75 156.315L407.695 163.482L401.003 162.255L396.442 154.146L399.801 147.11Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M410.749 156.316L418.691 156.409L423.925 163.666L420.957 171.03L413.008 170.894L407.693 163.483L410.749 156.316Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M413.011 170.893L420.96 171.03L428.364 177.312L428.147 183.6L421.295 183.244L413.392 176.86L413.011 170.893Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M423.926 163.665L434.383 162.678L440.872 168.914L437.873 176.156L428.361 177.312L420.957 171.028L423.926 163.665Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M440.872 168.915L451.437 167.257L458.431 172.56L455.919 179.385L445.893 181.342L437.873 176.156L440.872 168.915Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M445.891 181.341L455.918 179.383L464.514 183.644L464.017 189.72L454.908 191.761L445.308 187.649L445.891 181.341Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M464.515 183.645L474.585 181.312L483.657 184.874L483.533 190.561L474.07 193.046L464.018 189.721L464.515 183.645Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M476.265 175.101L485.995 173.173L494.067 177.048L493.407 182.54L483.658 184.873L474.586 181.312L476.265 175.101Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M494.067 177.049L503.044 175.431L511.57 178.904L511.967 183.669L502.799 185.675L493.406 182.541L494.067 177.049Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M502.799 185.676L511.967 183.67L521.482 186.689L522.357 191.522L513.29 193.661L503.18 190.918L502.799 185.676Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M511.569 178.903L519.692 177.828L528.543 181.165L529.903 185.282L521.481 186.688L511.966 183.669L511.569 178.903Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M521.481 186.686L529.903 185.28L539.301 188.537L540.529 193.088L532.046 194.557L522.355 191.519L521.481 186.686Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M165.404 -17.5444L175.186 -13.8464L177.971 -6.81057L170.834 -3.29033L160.216 -5.93436L157.525 -13.0945L165.404 -17.5444Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M181.709 -16.7259L190.52 -11.9638L193.619 -5.41946L187.526 -3.05037L177.971 -6.81001L175.185 -13.8458L181.709 -16.7259Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M193.621 -5.41877L202.477 -1.17822L205.852 4.66702L200.028 6.82479L190.635 3.287L187.528 -3.04925L193.621 -5.41877Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M190.635 3.28574L200.028 6.82353L203.365 12.4838L197.225 14.9627L187.414 11.9719L184.1 6.08843L190.635 3.28574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M203.363 12.4848L212.725 15.3808L216.494 20.113L210.462 22.6872L200.642 20.4157L197.224 14.9637L203.363 12.4848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M218.463 12.9708L227.717 15.1835L231.902 19.2013L226.291 21.8609L216.493 20.1117L212.724 15.3791L218.463 12.9708Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M231.907 19.2022L241.388 20.5987L245.993 24.0376L240.418 26.9553L230.387 25.9061L226.301 21.8643L231.907 19.2022Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M230.385 25.9068L240.415 26.956L244.601 30.6523L238.352 33.4649L228.095 32.4868L224.281 28.6041L230.385 25.9068Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M244.6 30.6519L254.725 31.3557L258.826 35.0428L252.401 37.9371L242.076 37.0943L238.351 33.4649L244.6 30.6519Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M260.321 28.2061L269.826 28.9709L274.545 32.4456L268.912 35.7798L258.824 35.0428L254.722 31.356L260.321 28.2061Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M258.826 35.0436L268.914 35.7806L272.792 39.7859L266.189 42.6963L255.907 41.6262L252.4 37.9379L258.826 35.0436Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M274.549 32.4457L283.842 33.4212L288.344 37.4998L282.7 40.9428L272.794 39.7852L268.916 35.7799L274.549 32.4457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M272.791 39.784L282.697 40.9416L286.244 45.5835L279.506 48.418L269.384 46.7438L266.189 42.694L272.791 39.784Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M288.343 37.4999L297.283 39.0645L301.429 44.1251L295.835 47.5774L286.246 45.5847L282.698 40.9428L288.343 37.4999Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M286.245 45.5838L295.834 47.5766L298.975 53.1691L292.185 55.8115L282.332 53.1244L279.506 48.4179L286.245 45.5838Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M298.975 53.1686L308.103 56.4382L310.797 63.3029L304.067 65.6009L294.603 61.4608L292.185 55.8114L298.975 53.1686Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M313.552 53.1048L321.331 57.0663L324.484 65.2839L319.314 68.3351L310.799 63.3035L308.105 56.4393L313.552 53.1048Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M310.799 63.3047L319.313 68.3363L321.542 76.8129L315.023 78.5743L306.08 72.4941L304.069 65.6027L310.799 63.3047Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M321.539 76.8111L328.871 82.8545L330.14 89.5757L324.418 91.0933L316.521 85.9368L315.019 78.573L321.539 76.8111Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M333.467 80.2869L338.376 84.5444L340.039 92.3537L336.465 94.6734L330.142 89.5766L328.874 82.8554L333.467 80.2869Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M330.139 89.5773L336.461 94.6742L338.339 101.998L333.417 103.888L325.942 98.0032L324.417 91.0954L330.139 89.5773Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M338.341 101.996L344.455 107.415L346.918 115.363L342.614 118.032L335.335 111.907L333.419 103.886L338.341 101.996Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M347.215 104.901L352.075 109.436L355.088 117.683L352.983 120.72L346.918 115.362L344.455 107.414L347.215 104.901Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M346.92 115.363L352.984 120.722L356.04 129.252L352.22 132.997L344.953 127.086L342.616 118.033L346.92 115.363Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M355.089 117.686L360.012 122.094L363.747 130.434L362.186 134.214L356.039 129.253L352.983 120.723L355.089 117.686Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M356.038 129.251L362.186 134.212L365.861 143.206L362.448 148.207L355.033 142.925L352.218 132.997L356.038 129.251Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M365.862 143.207L372.197 147.479L376.533 156.74L373.499 163.04L365.815 158.767L362.449 148.208L365.862 143.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M373.272 142.863L378.445 146.551L383.737 154.674L383.132 160.084L376.534 156.74L372.197 147.479L373.272 142.863Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M376.535 156.74L383.132 160.085L388.189 169.332L385.548 176.828L377.509 173.893L373.5 163.04L376.535 156.74Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M388.191 169.33L395.092 171.568L400.937 180.434L398.747 188.864L390.302 187.534L385.549 176.826L388.191 169.33Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M395.199 165.551L400.708 168.001L407.711 175.173L408.151 181.459L400.933 180.435L395.088 171.569L395.199 165.551Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M400.935 180.434L408.154 181.458L414.858 189.491L413.21 198.427L404.348 198.893L398.745 188.864L400.935 180.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M407.712 175.172L413.39 176.859L421.293 183.243L422.063 189.598L414.857 189.492L408.153 181.459L407.712 175.172Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M414.856 189.49L422.062 189.597L429.271 196.826L427.869 205.84L419.117 207.582L413.209 198.426L414.856 189.49Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M421.294 183.243L428.146 183.6L437.043 188.759L437.61 195.375L429.272 196.828L422.064 189.598L421.294 183.243Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M429.269 196.828L437.607 195.375L446.153 200.972L445.104 209.634L435.151 213.096L427.868 205.842L429.269 196.828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M437.042 188.758L445.309 187.65L454.909 191.761L455.459 198.269L446.155 200.972L437.61 195.375L437.042 188.758Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M446.155 200.971L455.46 198.269L464.96 202.526L464.405 210.508L453.859 214.935L445.107 209.633L446.155 200.971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M464.962 202.529L474.718 199.198L484.784 202.483L484.784 209.59L474.173 214.287L464.406 210.51L464.962 202.529Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M474.069 193.045L483.532 190.56L493.759 193.413L494.552 199.078L484.783 202.481L474.717 199.195L474.069 193.045Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M484.781 202.481L494.55 199.079L504.801 201.817L505.35 207.985L495.114 212.335L484.781 209.588L484.781 202.481Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M493.757 193.414L503.177 190.917L513.287 193.66L514.216 198.829L504.801 201.817L494.55 199.079L493.757 193.414Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M504.804 201.815L514.22 198.827L524.291 201.489L525.334 206.775L515.827 210.247L505.354 207.984L504.804 201.815Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M513.29 193.659L522.357 191.52L532.048 194.558L533.058 199.331L524.291 201.489L514.219 198.827L513.29 193.659Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M524.289 201.489L533.056 199.331L542.607 202.433L544.045 207.004L535.55 209.14L525.332 206.776L524.289 201.489Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M429.269 196.828L437.607 195.375L446.153 200.972L445.104 209.634L435.151 213.096L427.868 205.842L429.269 196.828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M446.155 200.971L455.46 198.269L464.96 202.526L464.405 210.508L453.859 214.935L445.107 209.633L446.155 200.971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4788 -27.6596L107.865 -27.2617L109.343 -18.4559L97.3445 -9.86691L82.7472 -9.15554L81.3486 -18.1836L94.4788 -27.6596Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M109.342 -18.457L122.391 -18.0181L124.57 -10.1128L113.791 -2.74343L99.6426 -2.05243L97.3437 -9.86801L109.342 -18.457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M146.463 -15.378L157.527 -13.0946L160.217 -5.93408L151.886 -1.14766L139.909 -2.35123L137.134 -9.3765L146.463 -15.378Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M139.905 -2.3522L151.882 -1.14822L155.104 5.11577L146.614 9.78797L133.87 9.46139L130.324 3.64986L139.905 -2.3522Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M160.214 -5.9341L170.833 -3.29007L173.904 3.17557L166.447 6.87093L155.105 5.11629L151.882 -1.14768L160.214 -5.9341Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M155.105 5.11721L166.447 6.87184L169.934 12.5838L162.362 16.1579L150.451 15.0163L146.615 9.78941L155.105 5.11721Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M173.906 3.17584L184.1 6.08855L187.414 11.9721L180.645 14.8884L169.936 12.5836L166.454 6.87361L173.906 3.17584Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M169.934 12.5849L180.643 14.8898L184.19 20.3626L177.291 23.2513L166.241 21.2143L162.363 16.1586L169.934 12.5849Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M187.414 11.9726L197.225 14.9634L200.644 20.4154L194.278 23.052L184.192 20.3614L180.645 14.8886L187.414 11.9726Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M200.643 20.4143L210.463 22.6858L214.192 27.1403L207.747 29.8171L197.685 27.9998L194.277 23.0509L200.643 20.4143Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M197.689 28.0012L207.75 29.8185L211.238 34.0121L204.367 36.8037L194.185 35.3972L190.96 30.7807L197.689 28.0012Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M214.193 27.1414L224.281 28.6038L228.095 32.4865L221.463 35.2048L211.235 34.0127L207.748 29.8182L214.193 27.1414Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M228.096 32.4857L238.353 33.4642L242.078 37.0936L235.205 39.8324L224.873 38.9452L221.464 35.2039L228.096 32.4857Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M224.871 38.9442L235.203 39.831L238.416 43.4155L231.073 46.1796L220.8 45.4241L217.784 41.7411L224.871 38.9442Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M238.417 43.4159L248.773 44.3295L251.709 48.0428L244.116 50.7064L233.862 49.802L231.074 46.18L238.417 43.4159Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M255.907 41.6261L266.189 42.6959L269.384 46.7456L262.017 49.3402L251.709 48.044L248.773 44.3307L255.907 41.6261Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M251.708 48.0432L262.016 49.339L264.624 53.4541L256.825 55.9227L246.646 54.53L244.115 50.7072L251.708 48.0432Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M264.622 53.4554L274.791 55.5029L277.059 60.2899L269.137 62.4381L259.094 60.1934L256.823 55.9239L264.622 53.4554Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M282.331 53.1256L292.184 55.8128L294.602 61.4621L286.991 63.4816L277.061 60.2888L274.793 55.5022L282.331 53.1256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M277.06 60.2878L286.99 63.4802L288.928 69.2025L281.009 70.8728L271.171 67.3866L269.138 62.436L277.06 60.2878Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M288.927 69.2044L298.526 73.981L300.174 80.9085L292.405 81.8953L282.86 76.7446L281.008 70.8747L288.927 69.2044Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M306.075 72.4914L315.018 78.5717L316.519 85.9355L309.331 86.85L300.174 80.9058L298.526 73.9787L306.075 72.4914Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M316.524 85.9365L324.421 91.0935L325.946 98.0013L319.565 99.3027L310.987 93.2218L309.335 86.851L316.524 85.9365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M310.985 93.2232L319.563 99.3045L321.357 107.275L314.784 109.013L305.984 101.923L303.851 94.1895L310.985 93.2232Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M325.943 98.0028L333.418 103.887L335.334 111.908L329.535 114.071L321.355 107.275L319.562 99.3042L325.943 98.0028Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M321.359 107.276L329.539 114.072L331.541 123.528L325.33 126.478L316.87 118.686L314.785 109.014L321.359 107.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M331.538 123.527L339.57 130.481L341.868 141.235L335.885 145.734L327.479 137.869L325.327 126.477L331.538 123.527Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M344.951 127.087L352.218 132.999L355.032 142.927L349.971 147.816L341.867 141.236L339.57 130.482L344.951 127.087Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M341.87 141.234L349.975 147.814L352.669 159.584L346.836 165.855L338.241 158.539L335.887 145.733L341.87 141.234Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M355.033 142.927L362.448 148.208L365.814 158.768L361.021 165.285L352.666 159.586L349.973 147.816L355.033 142.927Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M352.666 159.586L361.02 165.285L364.239 177.688L358.534 185.815L349.549 179.658L346.832 165.857L352.666 159.586Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M364.24 177.687L372.984 182.026L376.864 194.564L371.321 204.469L361.787 200.062L358.535 185.813L364.24 177.687Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M377.507 173.892L385.546 176.826L390.299 187.535L386.096 197.113L376.865 194.564L372.984 182.027L377.507 173.892Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M376.863 194.563L386.095 197.112L390.781 209.166L385.483 220.587L375.291 218.474L371.32 204.468L376.863 194.563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M390.301 187.535L398.746 188.865L404.349 198.893L400.559 209.562L390.785 209.167L386.099 197.113L390.301 187.535Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M390.784 209.167L400.557 209.561L406.187 220.405L401.262 232.877L390.357 233.526L385.485 220.588L390.784 209.167Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M406.187 220.404L415.816 218.682L421.851 227.67L417.602 239.972L406.598 243.682L401.261 232.877L406.187 220.404Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M419.117 207.584L427.869 205.842L435.153 213.095L432.448 223.765L421.851 227.671L415.816 218.683L419.117 207.584Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M421.851 227.67L432.448 223.765L440.477 230.155L437.171 241.6L424.888 247.561L417.601 239.972L421.851 227.67Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M440.477 230.156L451.934 224.752L461.436 229.027L459.205 239.253L446.408 246.444L437.171 241.601L440.477 230.156Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M453.858 214.938L464.403 210.51L474.171 214.286L473.115 222.978L461.436 229.028L451.933 224.753L453.858 214.938Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M461.438 229.027L473.119 222.978L483.569 225.712L482.447 234.52L469.786 242.005L459.208 239.254L461.438 229.027Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M483.566 225.711L494.936 219.779L505.836 221.602L505.779 228.948L493.781 235.907L482.443 234.519L483.566 225.711Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M495.114 212.335L505.349 207.984L515.823 210.248L516.467 216.452L505.835 221.601L494.935 219.778L495.114 212.335Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M505.835 221.602L516.465 216.453L527.358 218.03L528.267 224.002L517.342 229.729L505.777 228.949L505.835 221.602Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M527.361 218.029L536.915 214.234L547.386 216.255L549.128 221.049L539.588 224.946L528.27 224.001L527.361 218.029Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M465.572 85.2371L471.833 86.1402L477.732 90.5481L476.206 94.2018L468.427 93.1973L463.749 88.6339L465.572 85.2371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M282.331 53.1256L292.184 55.8128L294.602 61.4621L286.991 63.4816L277.061 60.2888L274.793 55.5022L282.331 53.1256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M364.24 177.687L372.984 182.026L376.864 194.564L371.321 204.469L361.787 200.062L358.535 185.813L364.24 177.687Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0224 -20.23L36.1743 -18.5158L36.2635 -7.57088L20.9415 2.40563L4.89298 1.09554L5.09403 -10.6968L21.0224 -20.23Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5561 -28.7843L66.189 -28.1369L66.5634 -17.8958L52.0429 -7.68668L36.262 -7.57377L36.1723 -18.5178L51.5561 -28.7843Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2609 -7.57213L52.0421 -7.68545L53.4439 1.58799L39.1218 11.243L22.3915 12.0152L20.9389 2.40439L36.2609 -7.57213Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5623 -17.8953L81.347 -18.1856L82.7456 -9.15761L69.3653 0.353243L53.4442 1.58642L52.0419 -7.6862L66.5623 -17.8953Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M53.45 1.59081L69.3669 0.355251L71.8982 8.03114L58.8069 16.7931L41.9738 18.8049L39.1236 11.2435L53.45 1.59081Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7467 -9.1558L97.344 -9.86717L99.643 -2.052L87.5492 6.31555L71.8975 8.03137L69.3667 0.354634L82.7467 -9.1558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8989 8.02972L87.5503 6.31432L90.9684 12.5887L79.2052 20.1068L62.7384 22.5887L58.8074 16.7921L71.8989 8.02972Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6405 -2.05193L113.789 -2.74294L116.814 3.96533L106.036 10.946L90.9652 12.5891L87.5467 6.31562L99.6405 -2.05193Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M116.815 3.96488L130.324 3.65008L133.866 9.45962L124.332 15.0119L110.067 16.1272L106.037 10.9456L116.815 3.96488Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M110.067 16.1296L124.332 15.0143L128.691 19.5235L119.387 24.3429L104.63 25.8898L99.5999 22.2653L110.067 16.1296Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M128.687 19.518L141.997 19.2862L146.373 23.6304L138.026 27.4001L124.422 27.7624L119.387 24.3394L128.687 19.518Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M150.453 15.0145L162.365 16.1561L166.244 21.2118L158.64 24.5414L146.38 23.6332L141.999 19.2866L150.453 15.0145Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M146.374 23.6304L158.638 24.5414L162.734 29.3401L155.067 32.5076L142.704 31.3318L138.027 27.4L146.374 23.6304Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M166.24 21.2119L177.29 23.2488L180.86 28.6056L173.789 31.5392L162.732 29.3403L158.637 24.542L166.24 21.2119Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M162.733 29.3411L173.79 31.5392L176.851 36.6798L169.491 39.842L158.872 37.7578L155.066 32.5085L162.733 29.3411Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M180.863 28.6052L190.958 30.7788L194.184 35.3949L187.116 38.3622L176.853 36.6791L173.792 31.5388L180.863 28.6052Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M176.853 36.6797L187.115 38.3629L190.155 42.7872L182.889 46.0665L172.523 44.8123L169.492 39.8419L176.853 36.6797Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M194.181 35.3967L204.367 36.8053L207.536 40.8139L200.363 43.8178L190.153 42.7881L187.113 38.3636L194.181 35.3967Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M207.539 40.8141L217.785 41.7426L220.801 45.4256L213.458 48.4405L203.293 47.787L200.365 43.8181L207.539 40.8141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M203.291 47.7858L213.456 48.4397L216.226 52.2078L208.943 55.6614L198.947 55.3158L196.036 51.1725L203.291 47.7858Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M220.799 45.4239L231.073 46.1794L233.86 49.8015L226.334 52.7757L216.226 52.2074L213.457 48.4389L220.799 45.4239Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M216.228 52.2076L226.335 52.7759L228.931 56.5844L221.626 60.0359L211.775 59.731L208.945 55.6608L216.228 52.2076Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M228.932 56.5853L238.965 57.3799L241.398 61.4575L234.124 64.809L224.411 64.2461L221.628 60.0368L228.932 56.5853Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M246.648 54.5308L256.827 55.9234L259.094 60.1909L251.326 62.8082L241.397 61.4584L238.964 57.3808L246.648 54.5308Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M259.095 60.1917L269.138 62.4359L271.171 67.3869L263.422 69.6247L253.637 67.3703L251.323 62.8066L259.095 60.1917Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M253.64 67.3713L263.42 69.6238L265.689 74.8827L258.794 77.6109L249.393 75.5643L246.488 70.4929L253.64 67.3713Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M265.69 74.8835L275.275 78.4198L277.599 84.578L271.129 86.7091L261.926 83.3856L258.79 77.6093L265.69 74.8835Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M282.861 76.7429L292.406 81.8936L294.385 88.4534L287.205 89.5559L277.6 84.5781L275.275 78.4199L282.861 76.7429Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M294.389 88.4558L303.853 94.1901L305.986 101.924L299.374 103.546L290.203 96.8241L287.21 89.5583L294.389 88.4558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M290.203 96.8238L299.373 103.546L302.007 113.19L296.396 115.879L287.981 108.184L284.286 98.862L290.203 96.8238Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M302.005 113.19L310.575 121.322L313.002 133.098L307.486 136.9L299.572 127.733L296.394 115.878L302.005 113.19Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M316.866 118.685L325.326 126.477L327.477 137.869L321.334 141.928L313 133.099L310.573 121.322L316.866 118.685Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M313.001 133.098L321.336 141.927L323.729 155.51L318.151 160.789L310.346 150.934L307.485 136.9L313.001 133.098Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M327.48 137.87L335.886 145.735L338.24 158.54L332.134 164.32L323.731 155.512L321.338 141.928L327.48 137.87Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M323.732 155.511L332.135 164.32L334.682 179.268L328.953 186.275L320.923 176.549L318.155 160.79L323.732 155.511Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M334.68 179.268L343.425 187.332L346.336 203.064L340.424 211.912L331.862 203.152L328.952 186.275L334.68 179.268Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M349.552 179.656L358.537 185.813L361.789 200.061L355.651 209.653L346.337 203.062L343.426 187.331L349.552 179.656Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M346.335 203.062L355.649 209.653L359.144 225.42L353.082 236.048L343.737 229.12L340.424 211.911L346.335 203.062Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M359.146 225.421L369.207 229.822L373.516 244.711L367.394 256.842L357.07 252.606L353.085 236.048L359.146 225.421Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M375.292 218.475L385.484 220.588L390.356 233.527L384.438 246.253L373.514 244.711L369.206 229.822L375.292 218.475Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M390.357 233.526L401.261 232.878L406.597 243.683L401.121 256.956L389.774 259.2L384.439 246.253L390.357 233.526Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M424.89 247.561L437.173 241.6L446.409 246.443L443.045 257.92L429.298 265.722L420.373 260.174L424.89 247.561Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M453.727 260.785L467.649 252.058L479.41 253.069L477.598 262.57L462.815 272.477L450.679 271.718L453.727 260.785Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M469.783 242.004L482.445 234.519L493.782 235.907L492.856 244.426L479.41 253.071L467.648 252.059L469.783 242.004Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M479.409 253.071L492.855 244.425L505.077 244.448L504.437 252.487L490.433 261.929L477.596 262.571L479.409 253.071Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M505.078 244.447L517.54 236.749L529.677 236.652L530.094 243.341L517.346 251.426L504.438 252.487L505.078 244.447Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M517.344 229.728L528.269 224.001L539.588 224.946L540.774 230.63L529.676 236.653L517.539 236.749L517.344 229.728Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M529.676 236.652L540.774 230.629L552.357 231.28L553.681 236.844L542.538 242.823L530.093 243.34L529.676 236.652Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89016 1.09433L20.9386 2.40445L22.3913 12.0152L7.85038 20.7237L-8.81644 19.648L-10.3098 9.547L4.89016 1.09433Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.80945 19.6524L7.85315 20.7257L11.0614 28.2694L-2.04961 34.8439L-18.7392 33.2276L-22.4918 25.9936L-8.80945 19.6524Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0615 28.2696L28.4405 27.0757L32.9656 32.4288L20.7127 38.6362L3.27908 39.3929L1.89766 38.8646L-2.05372 34.8417L11.0615 28.2696Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9701 18.8031L58.8071 16.7942L62.734 22.5883L50.3909 29.946L32.965 32.428L28.4397 27.0753L41.9701 18.8031Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9643 32.4261L50.3947 29.9461L55.7998 33.6291L44.5378 39.1055L27.0417 41.2159L25.5119 41.0298L20.7115 38.6335L32.9643 32.4261Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7377 22.5906L79.2044 20.1087L83.8635 24.5549L72.7487 30.7534L55.7997 33.6313L50.3946 29.9482L62.7377 22.5906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8621 24.5546L99.601 22.2636L104.631 25.8881L94.6583 30.9015L78.5819 33.4066L72.7475 30.7527L83.8621 24.5546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5814 33.4067L94.6578 30.9015L100.484 33.2598L91.0546 37.0876L74.9903 39.1469L68.2986 38.0178L78.5814 33.4067Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M104.631 25.8878L119.388 24.3409L124.423 27.7631L115.416 31.7708L100.486 33.259L94.6589 30.9012L104.631 25.8878Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 33.2599L115.417 31.7721L120.809 34.6484L112.018 37.975L97.2101 38.8165L91.0572 37.0878L100.487 33.2599Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M120.809 34.6468L134.414 34.7073L138.968 39.0156L130.532 42.32L117.212 41.2375L112.022 37.9758L120.809 34.6468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M142.703 31.3343L155.066 32.5104L158.872 37.7589L151.003 41.0617L138.965 39.0176L134.411 34.7089L142.703 31.3343Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M138.968 39.0159L151.006 41.06L154.184 46.6956L146.252 50.4353L134.384 48.0976L130.532 42.3202L138.968 39.0159Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M154.18 46.6985L165.046 48.3667L168.252 53.4411L160.967 57.6316L149.853 56.3055L146.249 50.4381L154.18 46.6985Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M172.521 44.8133L182.887 46.0676L185.874 50.5057L178.679 54.3097L168.253 53.4394L165.047 48.365L172.521 44.8133Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M168.251 53.4388L178.677 54.3091L181.898 59.0403L175.171 63.6706L164.698 63.1511L160.967 57.6294L168.251 53.4388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M185.876 50.5059L196.038 51.1735L198.945 55.3148L191.97 59.3474L181.901 59.0411L178.681 54.3098L185.876 50.5059Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M181.899 59.0419L191.969 59.3478L195.224 63.9423L189.016 68.9721L179.08 69.0355L175.173 63.6722L181.899 59.0419Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M198.947 55.3177L208.943 55.6633L211.773 59.7335L204.998 63.9347L195.223 63.9423L191.968 59.3478L198.947 55.3177Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M195.223 63.9417L204.998 63.9342L208.337 68.5865L202.658 73.9415L193.169 74.3555L189.016 68.9716L195.223 63.9417Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M208.34 68.5865L217.871 68.5348L221.379 73.4273L216.285 79.0034L207.162 79.5211L202.662 73.9415L208.34 68.5865Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M224.408 64.2477L234.121 64.8102L236.916 69.3555L230.691 73.615L221.377 73.4279L217.869 68.5353L224.408 64.2477Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M221.372 73.424L230.686 73.6111L234.474 78.9111L230.069 84.5741L221.251 84.943L216.282 79.0029L221.372 73.424Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M236.915 69.3548L246.485 70.4922L249.389 75.564L243.589 79.6419L234.473 78.9115L230.69 73.6139L236.915 69.3548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M234.474 78.91L243.59 79.6409L247.91 85.4696L244.232 91.1598L235.652 91.0311L230.069 84.5734L234.474 78.91Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M249.392 75.5649L258.793 77.6115L261.928 83.3878L256.715 87.1016L247.912 85.4714L243.592 79.6428L249.392 75.5649Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M261.928 83.387L271.132 86.7105L274.93 93.4412L270.432 96.6577L261.511 93.6693L256.715 87.1012L261.928 83.387Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M261.508 93.6693L270.429 96.6576L275.764 105.321L273.67 110.117L264.816 107.308L258.915 98.7661L261.508 93.6693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M274.928 93.4405L284.278 98.8592L287.978 108.183L283.809 111.519L275.764 105.32L270.43 96.657L274.928 93.4405Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M275.765 105.32L283.81 111.518L288.259 123.097L286.363 127.889L279.848 121.408L273.672 110.116L275.765 105.32Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M288.257 123.098L295.467 131.699L299.278 145.806L297.231 151.042L291.481 141.992L290.71 139.89L286.36 127.891L288.257 123.098Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M299.571 127.732L307.485 136.899L310.345 150.933L306.121 155.948L299.284 145.806L295.468 131.697L299.571 127.732Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M310.348 150.934L318.155 160.788L320.922 176.548L316.438 182.919L309.555 172.111L306.124 155.948L310.348 150.934Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M309.555 172.112L316.436 182.921L319.752 200.517L316.938 207.579L311.233 196.171L307.18 178.143L309.555 172.112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M320.917 176.546L328.951 186.275L331.863 203.152L327.052 211.069L319.752 200.515L316.436 182.919L320.917 176.546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M331.864 203.152L340.426 211.912L343.74 229.122L338.589 238.606L330.542 229.288L327.054 211.069L331.864 203.152Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M330.541 229.288L338.587 238.607L342.557 256.416L338.756 265.627L331.532 255.982L327.23 237.472L330.541 229.288Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M490.433 261.931L504.437 252.489L517.345 251.429L516.915 259.03L502.593 268.837L488.991 270.722L490.433 261.931Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M530.14 257.471L542.991 249.408L555.332 249.214L555.488 256.167L542.627 263.919L529.681 264.925L530.14 257.471Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.7406 33.2282L-2.05076 34.844L1.8964 38.8645L3.27781 39.3928L-10.6518 39.3021L-22.831 37.0853L-28.8978 33.4793L-18.7406 33.2282Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27911 39.3912L20.7128 38.6344L25.5133 41.0307L27.043 41.2168L-1.25555 41.1734L-6.70061 39.8292L3.27911 39.3912Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0371 41.2152L44.5371 39.1077L49.4155 40.4233L51.3047 40.5312L24.4589 42.8347L17.1213 42.1806L27.0371 41.2152Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M51.305 40.5309L68.3005 38.0173L74.9922 39.1465L65.1834 41.5889L41.4217 42.2131L51.305 40.5309Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M48.557 42.7717L65.1829 41.5902L71.7227 42.8555L61.9176 45.3688L45.6409 45.7075L38.8783 44.3334L48.557 42.7717Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7232 42.8551L87.5688 41.9258L93.2109 44.6113L83.4216 47.9186L67.916 47.818L61.9181 45.3684L71.7232 42.8551Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M97.21 38.8157L112.022 37.9766L117.212 41.2383L107.885 44.8018L93.2116 44.6102L87.5692 41.925L97.21 38.8157Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M117.21 41.238L130.531 42.3204L134.383 48.0977L125.57 51.8394L112.404 49.5531L107.884 44.8014L117.21 41.238Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41 49.5558L125.571 51.8397L129.416 58.4407L120.307 62.5658L106.772 59.7475L102.818 53.3739L112.41 49.5558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M134.385 48.0978L146.252 50.4355L149.856 56.3029L141.845 60.575L129.417 58.4404L125.571 51.8395L134.385 48.0978Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M129.414 58.4416L141.843 60.5753L145.685 66.6033L137.139 71.0146L124.186 69.1361L120.305 62.5667L129.414 58.4416Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M145.684 66.6026L157.477 67.8822L161.396 73.516L153.398 78.1514L140.94 76.9555L137.139 71.0139L145.684 66.6026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M164.701 63.1515L175.174 63.6709L179.081 69.0343L172.639 74.1787L161.397 73.5168L157.478 67.8826L164.701 63.1515Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M161.397 73.518L172.639 74.1804L176.712 79.607L169.261 84.4307L157.208 83.6684L153.399 78.1534L161.397 73.518Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M176.712 79.6066L187.508 79.8874L191.829 85.3119L184.915 90.3026L173.162 89.7286L169.261 84.4303L176.712 79.6066Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M193.172 74.3563L202.661 73.9422L207.161 79.5219L202.272 85.4303L191.83 85.3121L187.509 79.8876L193.172 74.3563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M191.829 85.31L202.271 85.4282L206.939 91.0671L200.56 96.2272L189.007 95.6086L184.916 90.3003L191.829 85.31Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M206.94 91.0683L217.142 91.243L222.265 97.3242L216.425 102.677L204.952 101.785L200.562 96.2284L206.94 91.0683Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M221.255 84.9437L230.072 84.5752L235.655 91.0328L232.328 97.7584L222.265 97.3245L217.138 91.2412L221.255 84.9437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M222.262 97.324L232.325 97.7579L237.917 104.616L232.789 110.223L221.225 108.731L216.423 102.677L222.262 97.324Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M235.651 91.0318L244.232 91.16L250.66 98.1484L248.185 105.635L237.917 104.615L232.324 97.7569L235.651 91.0318Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M247.913 85.4714L256.69 87.1253L261.512 93.6506L258.918 98.7664L250.662 98.1498L244.235 91.1614L247.913 85.4714Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M254.292 113.182L264.232 114.702L269.772 124.574L265.118 130.516L255.191 126.806L249.727 119.109L254.292 113.182Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M269.77 124.574L277.654 129.055L281.966 142.123L277.751 148.04L269.003 141.199L265.117 130.515L269.77 124.574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M264.817 107.307L273.671 110.117L279.848 121.409L277.655 129.055L269.771 124.573L264.236 114.758L264.817 107.307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M279.848 121.408L286.362 127.89L291.479 141.999L289.126 149.702L281.967 142.123L277.655 129.055L279.848 121.408Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M291.479 141.999L297.234 151.041L301.655 167.449L299.293 174.975L292.768 165.117L289.127 149.703L291.479 141.999Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M292.768 165.118L299.294 174.974L302.71 192.021L299.385 197.255L292.153 185.95L288.95 170.755L292.768 165.118Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M301.655 167.449L307.179 178.143L311.232 196.171L308.921 203.436L302.71 192.022L299.298 174.977L301.655 167.449Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M311.233 196.172L316.939 207.579L320.948 226.378L318.694 233.343L312.48 221.24L308.922 203.437L311.233 196.172Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M312.481 221.237L318.695 233.341L322.733 250.912L320.465 255.123L313.632 242.383L309.688 225.977L312.481 221.237Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M320.948 226.377L327.231 237.471L331.532 255.982L329.293 262.662L322.733 250.914L318.694 233.342L320.948 226.377Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.6243 42.4674L22.2188 44.3691L-5.67306 43.2583L-10.7999 42.0711L-1.6243 42.4674Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.81867 43.7227L12.6336 45.0715L19.2891 46.9102L9.11319 48.1304L-7.27886 46.2916L-13.5004 43.7055L-3.81867 43.7227Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2207 44.3709L38.8783 44.3324L45.6406 45.707L35.7001 47.5553L19.2873 46.9113L12.6321 45.0723L22.2207 44.3709Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2883 46.9112L35.7013 47.5548L41.7422 50.1719L31.1678 52.6096L14.8854 51.2581L9.11243 48.1314L19.2883 46.9112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6397 45.7052L61.9164 45.3664L67.9141 47.8164L57.7454 50.7144L41.7403 50.1701L35.6992 47.5535L45.6397 45.7052Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9164 47.8175L83.4262 47.9205L88.4412 52.0242L78.2235 55.7504L62.9686 54.6289L57.7475 50.7159L67.9164 47.8175Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9679 54.6274L78.2229 55.7488L82.4794 61.4097L71.651 65.6758L56.5121 63.6106L52.1598 58.1244L62.9679 54.6274Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4418 52.0229L102.818 53.3728L106.773 59.7468L96.7372 63.942L82.4805 61.4103L78.2242 55.749L88.4418 52.0229Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4799 61.4089L96.7363 63.941L100.626 71.1506L90.0233 75.6661L75.2483 72.8875L71.6515 65.675L82.4799 61.4089Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M106.773 59.7486L120.308 62.5669L124.189 69.1363L114.543 73.4996L100.628 71.1538L96.7376 63.9438L106.773 59.7486Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M100.628 71.1529L114.544 73.4991L118.239 79.8665L107.91 84.4124L93.6118 82.5891L90.0249 75.6685L100.628 71.1529Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M118.239 79.8661L131.684 81.4186L135.262 87.1478L125.19 91.6555L111.29 90.5006L107.909 84.412L118.239 79.8661Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M140.943 76.9545L153.401 78.1503L157.209 83.6653L148.317 88.17L135.261 87.1463L131.683 81.417L140.943 76.9545Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M135.259 87.147L148.316 88.1707L151.861 93.4831L142.043 97.9123L128.442 97.1387L125.188 91.6547L135.259 87.147Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M151.86 93.4853L164.631 94.2466L168.237 99.3762L158.666 103.708L145.263 103.04L142.041 97.9144L151.86 93.4853Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M173.162 89.7275L184.915 90.3016L189.007 95.6095L180.833 100.133L168.243 99.3778L164.632 94.2457L173.162 89.7275Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M168.24 99.3753L180.835 100.132L184.61 105.329L175.275 109.562L161.952 108.727L158.669 103.707L168.24 99.3753Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M189.005 95.6084L200.563 96.2293L204.953 101.785L197.138 106.328L184.61 105.33L180.836 100.134L189.005 95.6084Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M184.609 105.329L197.137 106.328L201.193 111.85L192.093 116.009L178.739 114.754L175.275 109.562L184.609 105.329Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M201.187 111.848L213.771 113.329L218.231 119.451L209.375 123.584L195.857 121.655L192.091 116.009L201.187 111.848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M221.225 108.731L232.789 110.224L238.211 117.01L230.992 121.641L218.232 119.45L213.772 113.327L221.225 108.731Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M218.232 119.452L230.993 121.642L236.003 128.661L227.399 132.835L213.576 129.982L209.377 123.584L218.232 119.452Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M238.212 117.009L249.726 119.108L255.191 126.806L248.494 131.664L236.004 128.66L230.993 121.642L238.212 117.009Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M237.918 104.616L248.187 105.636L254.291 113.182L249.726 119.109L238.212 117.01L232.79 110.223L237.918 104.616Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M236.005 128.661L248.496 131.665L252.261 140.258L244.23 144.449L231.758 140.148L227.401 132.835L236.005 128.661Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M252.255 140.255L262.841 145.969L266.114 157.411L258.943 161.396L247.642 154.266L244.229 144.448L252.255 140.255Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M269.006 141.199L277.754 148.04L281.096 161.361L275.624 165.849L266.116 157.41L262.843 145.969L269.006 141.199Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M266.114 157.412L275.622 165.851L278.803 179.393L272.632 182.987L262.279 173.549L258.943 161.397L266.114 157.412Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M281.097 161.361L288.952 170.754L292.155 185.948L287.487 189.988L278.805 179.391L275.625 165.849L281.097 161.361Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M292.153 185.948L299.386 197.254L302.799 213.505L299.008 216.972L290.92 204.87L287.485 189.988L292.153 185.948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M290.922 204.87L299.009 216.973L302.997 232.365L299.057 234.753L289.981 222.516L285.84 207.914L290.922 204.87Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M302.799 213.505L309.687 225.977L313.631 242.384L310.737 245.202L302.995 232.365L299.008 216.973L302.799 213.505Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M302.996 232.365L310.737 245.202L315.541 260.197L312.736 261.882L303.988 249.378L299.055 234.753L302.996 232.365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.7144 50.9578L3.76357 53.2959L8.50688 57.9447L-3.8215 61.0076L-20.5937 58.2298L-24.6765 52.7814L-12.7144 50.9578Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8873 51.2569L31.1697 52.6084L36.2962 56.7229L24.8302 59.9619L8.50782 57.9453L3.76477 53.296L14.8873 51.2569Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50563 57.9456L24.8278 59.9627L28.9998 65.6631L16.4784 69.8118L-0.0990026 67.2491L-3.82275 61.0084L8.50563 57.9456Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M36.295 56.7217L52.1607 58.1243L56.5131 63.6105L44.8973 67.8223L29.0007 65.6616L24.8289 59.9607L36.295 56.7217Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9986 65.6613L44.8952 67.822L48.4375 74.8194L35.9587 79.7545L19.8113 77.0113L16.4772 69.8099L28.9986 65.6613Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4411 74.824L63.7345 77.6759L67.2088 85.2926L54.9586 90.4619L38.997 87.9591L35.9581 79.7567L48.4411 74.824Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M75.249 72.8891L90.0241 75.6677L93.611 82.5884L82.32 87.3998L67.2115 85.292L63.733 77.673L75.249 72.8891Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2122 85.291L82.3205 87.3992L85.5344 94.0058L73.506 99.1697L58.04 97.7646L54.9617 90.4607L67.2122 85.291Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6125 82.5909L107.906 84.4118L111.286 90.5004L100.207 95.2571L85.5314 94.0065L82.3174 87.3999L93.6125 82.5909Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5326 94.0073L100.203 95.256L103.233 101.087L91.4221 106.177L76.3675 105.541L73.5039 99.1716L85.5326 94.0073Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 90.4996L125.19 91.6546L128.444 97.139L117.564 101.784L103.235 101.086L100.206 95.254L111.29 90.4996Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M128.443 97.1404L142.043 97.9139L145.265 103.039L134.575 107.54L120.493 107.094L117.563 101.786L128.443 97.1404Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M120.495 107.093L134.578 107.538L137.505 112.591L126.095 117.413L111.582 117.363L108.885 112.058L120.495 107.093Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M145.265 103.036L158.668 103.705L161.951 108.725L151.45 113.075L137.503 112.589L134.575 107.537L145.265 103.036Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M137.502 112.592L151.45 113.077L154.484 118.157L143.269 122.839L128.853 122.619L126.093 117.415L137.502 112.592Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M154.485 118.156L168.419 118.963L171.677 124.364L160.652 128.931L146.212 128.249L143.269 122.838L154.485 118.156Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M178.74 114.754L192.094 116.009L195.861 121.654L185.724 125.763L171.678 124.365L168.42 118.965L178.74 114.754Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M171.677 124.363L185.723 125.761L189.337 131.794L178.506 136.297L163.906 134.868L160.652 128.93L171.677 124.363Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M189.338 131.795L203.633 134.048L207.75 141.041L197.116 145.553L182.212 143.101L178.507 136.297L189.338 131.795Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M213.575 129.98L227.398 132.833L231.756 140.146L222.123 144.255L207.747 141.04L203.63 134.048L213.575 129.98Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M207.75 141.041L222.126 144.256L225.865 152.74L215.884 157.372L201.351 153.47L197.115 145.553L207.75 141.041Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M225.862 152.738L238.912 158.324L242.545 169.376L233.564 173.958L219.94 167.66L215.882 157.37L225.862 152.738Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M247.643 154.266L258.944 161.396L262.281 173.548L254.617 177.349L242.547 169.379L238.914 158.327L247.643 154.266Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M262.279 173.548L272.631 182.986L276.226 196.742L269.739 200.108L258.478 190.274L254.61 177.346L262.279 173.548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M258.478 190.273L269.739 200.107L274.114 214.2L267.51 218.155L255.284 208.523L250.635 194.613L258.478 190.273Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M276.226 196.741L285.836 207.913L289.977 222.514L284.748 225.319L274.115 214.2L269.74 200.107L276.226 196.741Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M274.117 214.2L284.75 225.319L289.855 239.826L284.529 243.3L272.805 232.86L267.508 218.154L274.117 214.2Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M289.856 239.826L300.029 251.539L306.048 265.66L301.99 268.619L290.636 258.077L284.53 243.3L289.856 239.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.5932 58.2307L-3.82102 61.0085L-0.0972926 67.2491L-13.7793 71.4454L-31.1199 68.3617L-34.1337 61.3236L-20.5932 58.2307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.9112 79.1659L6.19286 82.0774L8.96794 90.4926L-5.57014 96.2984L-23.6885 93.2115L-25.9009 84.4648L-10.9112 79.1659Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.6894 93.2112L-5.57106 96.2981L-2.94752 105.525L-16.043 112.754L-35.3633 108.228L-37.8986 99.5581L-23.6894 93.2112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8112 77.0126L35.9586 79.7558L38.9977 87.9577L25.6984 93.4943L8.96674 90.4922L6.19143 82.0774L19.8112 77.0126Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96626 90.4921L25.6982 93.4938L28.6499 101.682L14.6541 107.902C7.78383 106.999 3.92168 106.428 -2.94862 105.526C-3.93002 101.935 -4.5906 99.8892 -5.57199 96.2984L8.96626 90.4921Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.94176 139.015L-18.81 137.877L-24.4354 128.232L-13.1903 121.125C-5.58502 122.028 -1.76767 122.281 5.83756 123.183C7.16397 126.469 8.13019 128.439 9.4566 131.725L-1.94176 139.015Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6515 101.684L45.0326 103.416L47.7859 110.536L34.0941 116.864L17.1905 115.798L14.657 107.902L28.6515 101.684Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.94688 105.525L14.6559 107.901L17.1893 115.797L5.81614 123.125L-13.1911 121.125L-16.0424 112.755C-10.9283 109.931 -8.06101 108.349 -2.94688 105.525Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0377 97.7651L73.5037 99.1702L76.367 105.54L63.6522 111.22L47.7847 110.535L45.0316 103.415L58.0377 97.7651Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7842 110.536L63.6515 111.221L66.2772 117.536L52.9343 124.008L36.9202 124.059L34.0598 116.879L47.7842 110.536Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3687 105.54L91.4233 106.176L94.1555 111.874L81.7231 117.521L66.2798 117.535L63.6536 111.22L76.3687 105.54Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2774 117.535L81.7209 117.521L84.3094 123.321L71.4386 129.81L55.6039 130.517L52.9342 124.007L66.2774 117.535Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1556 111.872L108.883 112.057L111.579 117.362L99.4225 122.94L84.3118 123.319L81.7232 117.519L94.1556 111.872Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M84.312 123.321L99.4232 122.941L102.077 128.533L89.6429 135.129L74.232 136.111L71.4412 129.809L84.312 123.321Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M102.074 128.532L116.969 128.12L119.792 133.817L107.847 140.518L92.4338 141.466C91.301 139.01 90.7735 137.584 89.6407 135.128L102.074 128.532Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2298 136.111L89.6428 135.163L92.4336 141.465L81.062 147.816L65.0937 148.947L62.1818 142.854L74.2298 136.111Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M46.89 143.594L62.1818 142.855L65.0938 148.948L54.6157 154.919L37.7324 156.695L34.8205 150.602L46.89 143.594Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5942 151.5L34.8225 150.603L37.7344 156.696L27.2563 162.667L10.4842 164.506L7.32898 158.32L19.5942 151.5Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.51544 158.667L7.32959 158.32L10.4847 164.506L0.539644 170.013L-13.2105 170.708L-16.2896 164.262L-6.51544 158.667Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M55.605 130.518L71.4397 129.81L74.2305 136.112L62.1824 142.855L46.8906 143.594L44.0997 137.292L55.605 130.518Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 137.98L44.0998 137.292L46.8906 143.594L34.8212 150.602L19.5932 151.499L16.7371 145.181L28.3333 137.98Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948243 145.302L16.7386 145.18L19.5947 151.499L7.32954 158.32L-6.51549 158.667L-9.59463 152.221L0.948243 145.302Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9216 124.058L52.9357 124.007L55.6055 130.517L44.1002 137.292L28.3338 137.98L25.4776 131.661L36.9216 124.058Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46352 131.656L25.4769 131.661L28.333 137.979L16.7368 145.18L0.946467 145.302L-1.90969 138.983L9.46352 131.656Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.782 137.903L-1.90985 138.983L0.9463 145.302L-9.59658 152.221L-25.292 152.69L-30.5063 145.324L-18.782 137.903Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M128.853 122.618L143.268 122.839L146.212 128.25L134.595 133.691L119.793 133.818L116.97 128.122L128.853 122.618Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 133.817L134.595 133.69L137.716 139.828L126.103 146.575L111.06 147.06L107.848 140.518L119.792 133.817Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7182 154.276L99.6805 154.182L102.802 160.32L91.3854 166.942L76.2146 167.472L73.0021 160.93L84.7182 154.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1596 161.371L72.9984 160.93L76.2109 167.471L64.8054 174.302L49.5448 174.504L46.5431 168.082L58.1596 161.371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4366 141.466L107.85 140.519L111.063 147.061L99.647 154.164L84.7184 154.277L81.174 147.824L92.4366 141.466Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0957 148.949L81.1725 147.824L84.7164 154.277L73.0008 160.931L58.162 161.373L54.6176 154.92L65.0957 148.949Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7346 156.695L54.6174 154.92L58.1618 161.372L46.5459 168.084L30.8323 168.583L27.2565 162.667L37.7346 156.695Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4837 164.506L27.2557 162.667L30.832 168.583L19.7925 175.676L3.55615 175.544L0.538665 170.014L10.4837 164.506Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M111.061 147.06L126.104 146.596L129.804 153.997L118.482 159.877L102.769 160.376L99.6458 154.163L111.061 147.06Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M137.719 139.829L152.557 140.289L156.116 147.218L144.912 154.111L129.783 153.971L126.107 146.576L137.719 139.829Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M163.906 134.87L178.506 136.299L182.211 143.102L171.13 148.566L156.112 147.22L152.553 140.29L163.906 134.87Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M156.11 147.218L171.128 148.564L175.271 156.651L164.431 163.807L149.184 162.622L144.907 154.11L156.11 147.218Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 160.377L118.48 159.878L122.563 168.301L111.78 175.763L96.0973 175.725L91.3818 166.943L102.766 160.377Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2114 167.472L91.3822 166.942L96.0977 175.725L84.9029 182.676L69.4315 182.758L64.8058 174.303L76.2114 167.472Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5473 174.506L64.8079 174.304L69.4336 182.758L58.2625 189.619L42.7901 190.215L38.2164 181.746L49.5473 174.506Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7907 190.213L58.2632 189.617L62.6471 197.391L54.5288 204.221L38.3873 204.437L33.6855 196.189L42.7907 190.213Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7759 181.774L38.2151 181.746L42.789 190.215L33.6836 196.191L15.725 195.96L11.6257 189.229L22.7759 181.774Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02165 203.666L-10.2906 204.253L-15.1506 195.942L-3.81262 189.254L11.6266 189.226L15.7259 195.958L5.02165 203.666Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M122.564 168.299L138.605 169.65L143.801 179.538L133.44 187.24L116.286 184.424L111.781 175.761L122.564 168.299Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M116.284 184.425L133.438 187.241L138.82 196.967L128.339 204.802L110.992 201.985L105.331 190.959L116.284 184.425Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M110.994 201.985L128.34 204.802L134.693 216.336L125.55 224.931L109.674 220.603L102.33 210.265L110.994 201.985Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M109.675 220.603L125.55 224.931L132.957 236.184L125.569 244.31L108.289 240.357L100.944 230.019L109.675 220.603Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0983 175.725L111.781 175.763L116.285 184.426L105.333 190.96L89.4395 190.802L84.9035 182.676L96.0983 175.725Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4341 182.758L84.9054 182.676L89.4414 190.802L80.924 198.098L62.6475 197.393L58.2635 189.619L69.4341 182.758Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6463 197.392L80.9228 198.096L88.0776 207.739L78.8395 215.987L62.7028 214.151L54.5279 204.222L62.6463 197.392Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4391 190.8L105.332 190.958L110.993 201.984L102.329 210.265L88.0765 207.739L80.9217 198.096L89.4391 190.8Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M100.943 230.02L84.5217 227.142L78.8376 215.988L88.0759 207.74L102.329 210.266L109.673 220.603L100.943 230.02Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M175.279 156.654L190.62 159.105L195.198 169.002L184.824 176.504L169.505 173.85L164.435 163.805L175.279 156.654Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M149.144 162.607L164.431 163.808L169.506 173.904L159.476 181.517L143.798 179.54L138.603 169.652L149.144 162.607Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M143.799 179.539L159.477 181.515L164.91 192.925L155.724 201.018L138.82 196.967L133.437 187.24L143.799 179.539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M138.821 196.966L155.75 201.013L161.177 212.608L151.844 220.509L134.692 216.335L128.339 204.801L138.821 196.966Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M134.696 216.336L151.847 220.509L156.634 233.208L147.686 240.446L132.958 236.183L125.552 224.931L134.696 216.336Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M132.955 236.183L147.683 240.446L153.65 254.695L146.903 261.717L131.16 255.117L125.571 244.31L132.955 236.183Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M201.353 153.47L215.886 157.372L219.945 167.662L209.999 173.528L195.2 169.003L190.622 159.106L201.353 153.47Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M195.197 169.002L209.996 173.527L214.623 185.843L204.893 193.81L189.9 189.223L184.822 176.505L195.197 169.002Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M219.942 167.662L233.566 173.96L237.783 186.392L228.798 192.284L214.624 185.844L209.997 173.528L219.942 167.662Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M189.899 189.207L204.902 193.796L210.177 208.666L201.291 217.207L186.662 211.096L179.892 197.554L189.899 189.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M237.784 186.391L250.638 194.613L255.287 208.523L247.391 214.288L233.746 206.395L228.799 192.283L237.784 186.391Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M233.74 206.394L247.389 214.29L252.85 229.563L244.791 237.821L230.366 230.846L224.794 214.565L233.74 206.394Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M210.176 208.668L224.778 214.527L230.333 230.943L222.685 238.801L208.379 231.796L201.291 217.209L210.176 208.668Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M255.286 208.523L267.512 218.156L272.805 232.859L266.063 238.385L252.856 229.564L247.391 214.287L255.286 208.523Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M252.856 229.563L266.063 238.385L272.201 254.173L265.076 262.455L250.862 255.049L244.797 237.821L252.856 229.563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M208.284 231.725L222.684 238.801L231.42 257.08L223.741 265.475L206.663 255.768L199.036 240.892L208.284 231.725Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M184.864 233.115L199.037 240.892L206.664 255.767L198.874 264.099L182.61 255.897L175.593 241.931L184.864 233.115Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M237.784 186.391L250.638 194.613L255.287 208.523L247.391 214.288L233.746 206.395L228.799 192.283L237.784 186.391Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M186.615 211.088L201.289 217.209L208.283 231.725L199.035 240.892L184.863 233.116C182.037 227.61 181.18 225.825 178.354 220.319L186.615 211.088Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M164.913 192.925L179.891 197.556L186.616 211.087L178.355 220.317L161.179 212.609L155.727 201.018L164.913 192.925Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M161.178 212.609L178.354 220.318L184.864 233.115L175.593 241.931L156.632 233.208L151.845 220.51C155.49 217.424 157.533 215.695 161.178 212.609Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M156.631 233.208L175.59 241.931L182.607 255.897L173.559 264.839L153.646 254.694L147.682 240.446L156.631 233.208Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.8284 37.0828L0.320312 41.4746L-27.9002 37.7326L-31.9089 36.2135L-22.8284 37.0828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M330.944 5.44458L337.217 7.27562L341.896 11.8409L340.366 15.1522L333.676 13.8274L329.071 8.63174L330.944 5.44458Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M339.042 3.88211L345.299 4.78327L351.198 9.19094L349.675 12.8462L341.896 11.8417L337.216 7.27703L339.042 3.88211Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.26262 -11.8975L10.7434 -10.4332L14.8273 -3.92243L6.77123 0.277357L-8.24769 -1.5901L-12.0996 -7.85536L-2.26262 -11.8975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.24818 -1.58971L6.77074 0.277748L10.6929 7.06709L2.63682 11.2669L-15.2817 9.23338L-18.852 3.12817L-8.24818 -1.58971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.2818 9.23299L2.63668 11.2665L8.38171 17.4962L1.72581 21.8645L-23.6033 19.6945L-26.329 14.0694L-15.2818 9.23299Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M534.19 115.799L537.577 119.708L540.86 126.042L540.159 128.698L536.243 124.865L533.56 118.522L534.19 115.799Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M536.246 124.865L540.161 128.697L543.44 134.482L542.155 136.942L537.637 133.718L535.072 127.532L536.246 124.865Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M540.857 126.041L546.172 129.768L549.439 134.96L548.132 137.211L543.435 134.482L540.155 128.696L540.857 126.041Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M543.436 134.484L548.134 137.214L552.315 141.888L551.078 144.34L545.605 142.108L542.151 136.944L543.436 134.484Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M549.441 134.961L554.862 137.301L558.678 141.693L557.707 143.364L552.315 141.887L548.134 137.213L549.441 134.961Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M552.317 141.887L557.71 143.365L561.836 147.92L560.932 150.353L555.463 148.438L551.08 144.339L552.317 141.887Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M561.834 147.921L566.285 150.037L570.092 154.864L569.768 157.183L565.027 154.824L560.93 150.354L561.834 147.921Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M570.096 154.864L573.713 157.455L577.429 162.547L577.844 164.69L573.792 161.945L569.772 157.183L570.096 154.864Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M531.209 123.857L535.067 127.532L537.633 133.718L535.978 136.166L531.769 132.743L529.593 126.49L531.209 123.857Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M531.773 132.743L535.982 136.167L538.812 141.703L536.932 144.102L532.311 141.151L529.979 135.338L531.773 132.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M537.634 133.719L542.151 136.942L545.605 142.107L543.919 144.433L538.809 141.703L535.979 136.167L537.634 133.719Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M538.809 141.702L543.92 144.432L547.779 148.976L545.908 151.285L540.165 149.123L536.93 144.102L538.809 141.702Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M547.778 148.975L553.927 150.755L558.308 154.973L556.764 157.291L550.452 155.418L545.908 151.284L547.778 148.975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M555.46 148.437L560.93 150.353L565.027 154.823L563.977 157.087L558.308 154.975L553.926 150.756L555.46 148.437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M558.308 154.976L563.977 157.089L568.33 161.611L567.365 163.851L561.439 161.683L556.763 157.294L558.308 154.976Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M565.027 154.824L569.768 157.184L573.788 161.946L573.42 164.078L568.33 161.611L563.977 157.088L565.027 154.824Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M573.788 161.946L577.841 164.69L581.98 169.625L582.412 171.577L577.903 168.799L573.421 164.077L573.788 161.946Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M577.901 168.798L582.41 171.576L587.134 176.405L587.671 178.183L582.774 175.627L577.673 170.899L577.901 168.798Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M526.156 131.936L529.976 135.339L532.308 141.151L530.465 143.771L526.408 140.801L524.424 134.785L526.156 131.936Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M526.409 140.8L530.466 143.77L533.206 149.184L531.543 151.97L527.199 149.484L524.802 143.74L526.409 140.8Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M533.208 149.187L538.287 151.603L542.22 156.206L540.598 158.945L534.997 157.108L531.545 151.972L533.208 149.187Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M540.165 149.125L545.908 151.286L550.452 155.42L548.698 157.895L542.217 156.205L538.284 151.602L540.165 149.125Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M542.218 156.206L548.698 157.896L553.646 162.273L552.25 165.069L545.633 163.466L540.595 158.945L542.218 156.206Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M550.452 155.418L556.764 157.292L561.44 161.68L560.114 164.143L553.645 162.271L548.698 157.893L550.452 155.418Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M561.439 161.681L567.365 163.849L572.218 168.444L571.52 170.817L565.322 168.718L560.113 164.144L561.439 161.681Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M565.326 168.718L571.524 170.816L577.028 175.53L576.732 178.202L570.291 176.284L564.4 171.483L565.326 168.718Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M572.217 168.444L577.674 170.897L582.775 175.625L582.824 177.861L577.023 175.531L571.52 170.817L572.217 168.444Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M577.028 175.531L582.828 177.862L588.617 182.673L589.027 185.224L582.949 183.105L576.732 178.203L577.028 175.531Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M582.776 175.626L587.673 178.183L593.105 183.138L593.932 185.225L588.613 182.674L582.825 177.862L582.776 175.626Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M521.333 140.883L524.801 143.743L527.2 149.487L525.955 152.669L522.367 150.226L520.136 144.192L521.333 140.883Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M522.365 150.224L525.952 152.668L529.079 158.284L528.468 161.917L524.857 159.718L521.71 153.843L522.365 150.224Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M529.079 158.285L533.776 160.252L538.297 165.307L537.829 169.068L532.85 167.478L528.469 161.918L529.079 158.285Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M534.995 157.106L540.596 158.943L545.634 163.464L544.514 166.695L538.3 165.306L533.779 160.251L534.995 157.106Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M545.633 163.465L552.25 165.068L557.762 169.744L556.903 173.018L550.231 171.615L544.513 166.696L545.633 163.465Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M550.23 171.615L556.902 173.018L563.123 178.029L562.933 181.951L556.43 180.703L549.791 175.507L550.23 171.615Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M557.761 169.743L564.397 171.484L570.288 176.286L569.895 179.521L563.124 178.028L556.902 173.017L557.761 169.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M563.124 178.029L569.895 179.522L576.524 184.618L576.747 188.505L570.011 187.265L562.934 181.951L563.124 178.029Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M576.525 184.616L583.138 186.257L590.039 191.451L590.753 195.277L583.999 194.024L576.748 188.504L576.525 184.616Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M582.946 183.105L589.023 185.223L595.474 190.224L596.283 193.283L590.038 191.451L583.137 186.257L582.946 183.105Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M590.038 191.451L596.284 193.282L603.285 198.609L604.483 202.383L597.938 201.078L590.752 195.277L590.038 191.451Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M595.477 190.225L601.065 192.55L607.619 197.664L609 200.657L603.287 198.609L596.286 193.283L595.477 190.225Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M518.883 151.298L521.713 153.843L524.859 159.719L525.598 162.846L522.555 160.262L518.98 154.574L518.883 151.298Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M524.859 159.72L528.471 161.918L532.852 167.478L533.925 170.681L529.18 167.078L525.598 162.847L524.859 159.72Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M532.851 167.478L537.83 169.069L543.725 174.257L544.908 177.633L539.943 175.805L533.924 170.682L532.851 167.478Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M539.944 175.805L544.908 177.633L552.222 182.37L554.921 185.018L540.762 176.722L539.944 175.805Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M543.725 174.256L549.791 175.506L556.43 180.702L557.713 184.191L552.222 182.368L544.908 177.631L543.725 174.256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M552.222 182.368L557.713 184.191L565.38 189.225L567.914 192.253L553.892 184.139L552.222 182.368Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M556.432 180.703L562.934 181.951L570.012 187.264L571.217 191.048L565.381 189.226L557.714 184.192L556.432 180.703Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M570.012 187.263L576.749 188.504L584 194.025L585.029 198.217L578.973 196.463L571.217 191.047L570.012 187.263Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M578.973 196.463L585.029 198.218L592.658 204.07L594.542 208.252L589.118 205.968L581.21 200.025L578.973 196.463Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M583.998 194.024L590.753 195.277L597.939 201.078L598.771 205.728L592.656 204.07L585.027 198.217L583.998 194.024Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M597.941 201.08L604.486 202.385L611.39 208.523L612.077 213.61L606.095 212.04L598.773 205.729L597.941 201.08Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M606.094 212.039L612.075 213.609L618.952 220.368L620.262 225.778L614.882 223.871L607.646 216.861L606.094 212.039Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M618.95 220.369L624.572 221.895L630.897 229.06L632.119 234.932L627.037 233.22L620.26 225.78L618.95 220.369Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M630.899 229.059L635.903 230.626L641.605 238.118L642.858 244.38L638.593 242.696L632.12 234.931L630.899 229.059Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M520.278 160.871L523.765 163.16L531.336 170.735L527.254 168.717L521.357 163.986L520.278 160.871Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M527.257 168.717L541.486 177.41L529.341 171.511L527.257 168.717Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M575.968 197.631L581.211 200.024L589.118 205.967L591.879 209.676L575.968 197.631Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M587.138 206.733L599.575 216.446L602.448 220.592L587.138 206.733Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M589.115 205.966L594.54 208.25L602.163 214.748L604.475 219.224L599.573 216.444L591.877 209.674L589.115 205.966Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M599.573 216.446L604.476 219.225L611.827 226.589L614.229 231.581L609.704 228.378L599.573 216.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M602.165 214.75L607.647 216.86L614.883 223.87L616.803 229.101L611.829 226.589L604.477 219.226L602.165 214.75Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M611.826 226.59L616.801 229.101L623.772 236.944L625.794 242.737L621.168 239.914L614.228 231.582L611.826 226.59Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M623.776 236.943L628.694 239.117L635.281 247.284L637.083 253.753L632.451 251.423L625.798 242.736L623.776 236.943Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M627.04 233.218L632.122 234.93L638.596 242.696L639.979 249.089L635.281 247.284L628.694 239.118L627.04 233.218Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M524.062 170.385L529.338 171.511L536.788 175.641L539.61 178.264L533.706 177.489L525.563 173.77L524.062 170.385Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M533.71 177.491L539.613 178.266L548.174 182.09L551.219 184.857L544.802 184.328L535.801 180.821L533.71 177.491Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M586.308 206.567L601.223 221.092",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M609.705 228.379L614.23 231.581L621.17 239.914L623.411 245.562L619.085 242.046L609.705 228.379Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M619.083 242.047L623.41 245.563L629.916 254.842L631.829 261.198L627.488 257.521L619.083 242.047Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M539.31 188.539L546.907 187.96L555.911 191.851L557.236 196.333L549.497 196.872L540.538 193.09L539.31 188.539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M544.801 184.325L551.218 184.855L560.15 188.882L562.682 192.285L555.913 191.851L546.909 187.96L544.801 184.325Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M555.912 191.851L562.681 192.285L570.975 197.254L572.028 201.972L565.139 201.362L557.237 196.333L555.912 191.851Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M560.151 188.883L565.858 190.397L573.755 195.743L576.399 199.215L570.977 197.255L562.683 192.286L560.151 188.883Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M570.974 197.253L576.396 199.213L583.328 205.984L584.572 210.782L578.658 208.743L572.027 201.972L570.974 197.253Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M573.751 195.744L586.137 206.366L587.991 209.191L576.396 199.215L573.751 195.744Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M583.327 205.986L587.99 209.191L594.454 217.226L595.767 222.288L590.571 219.068L584.571 210.784L583.327 205.986Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M594.459 217.224L598.763 221.209L604.852 230.326L606.094 235.826L601.353 231.78L595.772 222.286L594.459 217.224Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M604.849 230.326L609.013 234.729L614.842 244.694L615.952 250.741L611.437 246.229L606.091 235.826L604.849 230.326Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M606.838 229.789L617.164 243.503L619.039 249.17L614.842 244.696L606.838 229.789Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M614.84 244.694L619.037 249.168L624.752 259.695L625.741 266.318L621.253 261.713L615.95 250.741L614.84 244.694Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M542.616 202.434L550.495 201.458L559.201 205.569L560.908 209.695L553.651 210.095L544.054 207.005L542.616 202.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M549.5 196.872L557.238 196.332L565.141 201.362L566.001 206.081L559.202 205.569L550.498 201.458L549.5 196.872Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2 205.568L565.999 206.08L573.54 211.833L575.365 215.891L569.537 214.19L560.907 209.694L559.2 205.568Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M573.542 211.835L579.451 213.838L586.438 221.066L588.454 225.227L575.367 215.893L573.542 211.835Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M578.658 208.744L584.572 210.783L590.572 219.067L591.576 224.333L586.438 221.067L579.45 213.839L578.658 208.744Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M586.436 221.067L591.575 224.333L600.258 236.993L588.451 225.226L586.436 221.067Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M601.35 231.781L606.09 235.827L611.437 246.23L612.857 251.642L602.563 237.146L601.35 231.781Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M542.616 202.434L550.495 201.458L559.201 205.569L560.908 209.695L553.651 210.095L544.054 207.005L542.616 202.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M559.2 205.568L565.999 206.08L573.54 211.833L575.365 215.891L569.537 214.19L560.907 209.694L559.2 205.568Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M535.561 209.141L544.056 207.005L553.652 210.096L555.612 214.309L547.398 216.255L536.928 214.234L535.561 209.141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M547.396 216.254L555.611 214.308L565.147 217.621L567.704 221.416L559.794 222.951L549.14 221.048L547.396 216.254Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M553.654 210.096L560.911 209.696L569.541 214.192L571.835 217.717L565.149 217.622L555.613 214.309L553.654 210.096Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M569.539 214.191L575.367 215.892L583.233 222.129L585.904 225.68L571.833 217.717L569.539 214.191Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M565.147 217.622L571.832 217.717L580.399 222.957L583.251 226.43L567.554 221.214L565.147 217.622Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M580.399 222.956L585.903 225.679L597.131 235.734L583.25 226.429L580.399 222.956Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M583.234 222.129L588.454 225.226L598.649 236.241L585.905 225.681L583.234 222.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M552.372 231.278L561.82 227.56L572.437 229.845L574.504 234.607L565.227 237.819L553.696 236.842L552.372 231.278Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M559.795 222.951L567.706 221.417L577.316 225.112L580.01 229L572.437 229.845L561.818 227.56L559.795 222.951Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M572.436 229.845L580.01 229.001L589.288 233.868L591.929 238.243L584.727 238.062L574.503 234.607L572.436 229.845Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M589.286 233.868L595.102 236.185L603.517 243.078L606.42 247.464L600.631 245.005L591.927 238.243L589.286 233.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M603.519 243.076L619.506 258.636L614.481 255.305L606.422 247.462L603.519 243.076Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M542.542 242.823L553.684 236.845L565.216 237.82L566.395 243.669L555.334 249.214L542.993 249.407L542.542 242.823Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M555.332 249.213L566.393 243.669L577.428 245.876L578.052 252.661L567.103 257.515L555.488 256.165L555.332 249.213Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M577.428 245.877L586.461 243.554L595.81 249.274L596.741 256.343L587.976 257.43L578.052 252.662L577.428 245.877Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M584.717 238.06L591.921 238.239L600.626 245L602.737 250.565L595.81 249.273L586.462 243.554L584.717 238.06Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M600.623 244.998L606.412 247.456L614.472 255.3L616.845 260.935L610.858 258.739L602.734 250.563L600.623 244.998Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M564.829 140.693L569.987 140.971L574.375 142.42L573.257 143.678L568.063 142.949L563.936 141.395L564.829 140.693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M567.133 143.905L563.185 144.254L558.68 141.693L559.566 141.456L564.078 141.427L568.061 142.95L567.133 143.905Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M568.06 142.949L573.254 143.678L577.801 145.521L576.267 146.873L570.953 145.705L567.131 143.903L568.06 142.949Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M574.371 142.422L579.723 142.235L584.223 143.772L583.152 145.66L577.8 145.523L573.253 143.68L574.371 142.422Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M577.802 145.522L583.155 145.659L587.527 147.607L586.188 149.707L580.577 149.145L576.268 146.873L577.802 145.522Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M584.226 143.772L589.745 143.327L594.336 145.088L593.195 147.438L587.528 147.608L583.156 145.659L584.226 143.772Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M587.529 147.608L593.195 147.438L597.66 149.653L596.244 152.342L590.435 152.278L586.189 149.707L587.529 147.608Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M594.334 145.087L599.987 144.633L604.664 146.709L603.48 149.321L597.658 149.652L593.192 147.437L594.334 145.087Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M597.657 149.654L603.48 149.323L608.048 151.809L606.596 154.843L600.608 155.113L596.241 152.344L597.657 149.654Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M604.661 146.71L610.416 146.536L615.545 149.271L614.483 151.999L608.046 151.807L603.477 149.321L604.661 146.71Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M615.55 149.27L621.293 150.325L625.756 154.699L625.005 157.648L619.53 156.03L614.488 151.998L615.55 149.27Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M619.528 156.033L625.003 157.651L629.013 162.952L628.034 166.258L622.893 164.217L618.351 159.267L619.528 156.033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M625.756 154.702L630.309 156.944L633.991 162.551L633.406 165.587L629.015 162.951L625.005 157.65L625.756 154.702Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M629.013 162.95L633.403 165.586L636.63 171.808L635.717 175.069L631.549 172.173L628.033 166.256L629.013 162.95Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M633.991 162.55L637.712 165.735L640.834 172.21L640.304 175.23L636.633 171.807L633.406 165.585L633.991 162.55Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M636.63 171.807L640.301 175.23L642.994 182.041L642.05 185.17L638.478 181.636L635.716 175.068L636.63 171.807Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M640.832 172.21L644.044 176.069L646.833 183.056L646.284 185.995L642.995 182.041L640.302 175.23L640.832 172.21Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M642.996 182.042L646.285 185.997L648.699 193.062L647.667 196.008L644.337 192.082L642.053 185.171L642.996 182.042Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M646.834 183.057L649.834 187.289L652.528 194.429L651.919 197.255L648.698 193.061L646.285 185.997L646.834 183.057Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M648.697 193.059L651.918 197.252L654.326 204.235L653.183 206.983L649.762 202.951L647.666 196.006L648.697 193.059Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M652.528 194.426L655.594 198.689L658.435 205.779L657.736 208.433L654.327 204.234L651.92 197.252L652.528 194.426Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M564.353 144.176L569.776 146.445L573.806 149.179L571.991 150.37L566.599 147.696L563.185 144.253L564.353 144.176Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M566.48 147.609L571.991 150.371L575.687 154.325L573.992 155.955L568.356 152.559L565.389 148.842L566.48 147.609Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M558.678 141.693L563.183 144.254L566.478 147.608L565.388 148.841L561.805 147.917L557.708 143.364L558.678 141.693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M570.956 145.707L576.27 146.875L580.578 149.146L579.085 150.814L573.807 149.18L569.659 146.359L570.956 145.707Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M573.804 149.179L579.082 150.814L583.104 153.918L581.384 156.068L575.685 154.324L571.989 150.371L573.804 149.179Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M583.104 153.918L588.848 154.777L593.014 158.025L591.245 160.995L585.353 159.948L581.384 156.068L583.104 153.918Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M590.433 152.278L596.242 152.342L600.609 155.111L598.971 158.236L593.015 158.025L588.849 154.776L590.433 152.278Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M593.016 158.026L598.972 158.237L603.313 161.502L601.542 165.042L595.426 164.813L591.247 160.995L593.016 158.026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M600.609 155.112L606.597 154.842L611.823 158.273L610.288 161.73L603.312 161.502L598.971 158.237L600.609 155.112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M611.821 158.272L618.35 159.265L622.892 164.216L621.613 167.769L615.588 166.304L610.287 161.729L611.821 158.272Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M615.589 166.304L621.614 167.769L625.625 173.346L624.284 177.073L618.814 175.25L614.081 170.031L615.589 166.304Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M625.626 173.346L630.377 175.686L633.396 181.968L632.088 185.575L627.77 183.042L624.286 177.074L625.626 173.346Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M631.549 172.174L635.716 175.069L638.478 181.637L637.292 185.005L633.393 181.968L630.374 175.686L631.549 172.174Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M633.396 181.968L637.295 185.006L639.621 191.705L638.247 195.104L634.648 192.026L632.088 185.575L633.396 181.968Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M639.618 191.704L643.058 195.235L645 202.07L643.499 205.205L640.209 201.778L638.244 195.103L639.618 191.704Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M644.338 192.082L647.668 196.008L649.765 202.953L648.354 205.856L645.003 202.071L643.061 195.235L644.338 192.082Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M645.001 202.069L648.352 205.854L650.238 212.541L648.582 215.396L645.214 211.846L643.499 205.204L645.001 202.069Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M649.764 202.951L653.184 206.984L655.362 213.742L653.778 216.447L650.239 212.541L648.354 205.854L649.764 202.951Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M575.685 154.325L581.385 156.068L585.354 159.947L583.641 162.552L577.644 160.625L573.99 155.955L575.685 154.325Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M587.506 167.129L593.569 168.207L597.898 172.318L596.096 175.929L589.895 174.998L585.516 170.286L587.506 167.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M577.648 160.626L583.645 162.552L587.497 167.111L585.52 170.288L580.571 167.845L576.192 163.133L577.648 160.626Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M595.427 164.813L601.543 165.041L606.989 169.057L605.294 172.835L597.901 172.317L593.572 168.207L595.427 164.813Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M597.898 172.318L605.29 172.836L611.001 177.696L609.509 181.548L602.086 180.447L596.096 175.931L597.898 172.318Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M606.989 169.06L614.083 170.033L618.816 175.252L617.378 179.11L611.003 177.698L605.293 172.837L606.989 169.06Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M610.999 177.695L617.375 179.107L621.556 184.753L620.264 188.645L614.642 186.877L609.508 181.546L610.999 177.695Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M621.561 184.753L626.437 186.84L629.443 193.023L628.212 196.83L623.956 194.56L620.269 188.646L621.561 184.753Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M627.77 183.04L632.088 185.572L634.648 192.023L633.298 195.656L629.442 193.022L626.436 186.839L627.77 183.04Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M629.44 193.024L633.296 195.658L635.48 202.142L634.21 205.775L630.83 203.114L628.21 196.831L629.44 193.024Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M635.48 202.141L638.763 205.171L640.489 211.726L639.118 215.132L636.15 212.22L634.21 205.775L635.48 202.141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M640.21 201.778L643.5 205.205L645.215 211.848L643.628 214.969L640.49 211.727L638.764 205.172L640.21 201.778Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M640.489 211.726L643.627 214.969L645.279 221.367L643.783 224.528L640.779 221.539L639.119 215.132L640.489 211.726Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M645.212 211.848L648.581 215.397L650.411 221.752L648.729 224.649L645.277 221.367L643.625 214.969L645.212 211.848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M640.782 221.538L643.785 224.528L645.591 230.699L644.497 233.822L641.441 231.344L639.668 225.018L640.782 221.538Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M592.687 183.019L600.467 184.024L606.831 189.065L605.73 192.636L597.563 190.948L591.158 186.331L592.687 183.019Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M602.088 180.446L609.511 181.546L614.645 186.877L613.438 190.711L606.834 189.063L600.469 184.022L602.088 180.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M589.897 175L596.098 175.93L602.089 180.447L600.429 183.95L593.06 183.096L587.675 178.183L589.897 175Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M606.832 189.064L613.437 190.711L618.062 196.374L617.249 200.145L610.964 198.178L605.73 192.635L606.832 189.064Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M618.061 196.376L622.909 198.432L626.205 204.521L625.545 208.364L620.788 206.121L617.248 200.147L618.061 196.376Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M623.954 194.56L628.211 196.83L630.831 203.113L629.832 206.914L626.208 204.519L622.912 198.431L623.954 194.56Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M626.206 204.521L629.831 206.914L632.207 213.246L631.602 217.072L627.994 214.591L625.546 208.364L626.206 204.521Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M632.209 213.244L635.117 215.877L636.994 222.276L636.383 226.032L633.508 223.392L631.604 217.069L632.209 213.244Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M636.152 212.22L639.121 215.132L640.781 221.539L639.667 225.019L636.995 222.276L635.117 215.878L636.152 212.22Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M636.994 222.276L639.666 225.019L641.44 231.344L640.787 235.049L638.247 232.314L636.383 226.032L636.994 222.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M641.438 231.345L644.493 233.823L646.733 240.284L645.96 243.55L642.905 241.072L640.785 235.05L641.438 231.345Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M610.965 198.178L617.25 200.145L620.79 206.119L617.811 210.556L611.152 209.107L607.712 202.676L610.965 198.178Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M620.788 206.118L625.545 208.362L627.994 214.589L625.61 218.804L620.34 217.04L617.81 210.555L620.788 206.118Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M627.994 214.59L631.602 217.071L633.506 223.393L631.916 227.293L627.763 225.214L625.611 218.805L627.994 214.59Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M633.507 223.393L636.381 226.032L638.247 232.314L637.524 235.874L634.158 233.523L631.916 227.292L633.507 223.393Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M632.209 213.244L635.117 215.877L636.994 222.276L636.383 226.032L633.508 223.392L631.604 217.069L632.209 213.244Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M660.405 214.945L664.348 218.296L667.698 224.305L666.413 226.765L661.975 223.604L659.184 217.302L660.405 214.945Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M654.387 204.313L657.735 208.435L660.404 214.945L659.184 217.302L655.361 213.743L653.145 206.935L654.387 204.313Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M658.435 205.782L662.387 209.402L665.138 215.971L664.349 218.296L660.406 214.945L657.736 208.435L658.435 205.782Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M665.137 215.969L669.059 218.987L673.141 224.402L672.441 227.055L667.698 224.304L664.348 218.295L665.137 215.969Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M667.698 224.304L672.395 227.034L676.533 231.601L675.339 234.161L669.867 231.929L666.412 226.764L667.698 224.304Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M676.532 231.601L681.987 233.315L686.094 237.743L685.19 240.176L679.721 238.26L675.338 234.161L676.532 231.601Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M682.477 230.541L686.63 232.206L690.404 237.315L690.398 239.905L686.097 237.742L681.989 233.314L682.477 230.541Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M673.141 224.402L677.991 227.159L682.477 230.541L681.988 233.314L676.533 231.6L672.442 227.056L673.141 224.402Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M686.092 237.743L690.394 239.906L693.808 243.7L692.233 245.768L689.26 244.632L685.188 240.176L686.092 237.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M661.977 223.604L659.186 217.302L655.364 213.742L653.789 216.454L655.948 222.396",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M661.975 223.603L666.413 226.763L669.867 231.928L668.18 234.254L663.07 231.524L660.24 225.988L661.975 223.603Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M663.067 231.525L668.178 234.255L672.037 238.798L670.166 241.107L664.423 238.945L661.188 233.924L663.067 231.525Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M672.04 238.797L678.189 240.577L682.57 244.796L681.025 247.114L674.714 245.24L670.17 241.107L672.04 238.797Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M679.722 238.26L685.191 240.175L689.288 244.645L688.238 246.909L682.569 244.797L678.188 240.578L679.722 238.26Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M682.568 244.798L688.237 246.91L692.59 251.433L691.666 253.597L685.669 251.671L681.023 247.116L682.568 244.798Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M672.04 238.797L678.189 240.577L682.57 244.796L681.025 247.114L674.714 245.24L670.17 241.107L672.04 238.797Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M650.558 230.707L654.725 233.594L657.465 239.008L655.802 241.794L651.458 239.308L649.061 233.564L650.558 230.707Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M656.569 230.973L661.19 233.924L664.426 238.946L662.545 241.423L657.466 239.008L654.726 233.593L656.569 230.973Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M657.466 239.007L662.545 241.423L666.478 246.026L664.856 248.765L659.255 246.928L655.803 241.793L657.466 239.007Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M666.48 246.026L672.96 247.716L677.908 252.093L676.511 254.889L669.895 253.286L664.857 248.765L666.48 246.026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M674.714 245.241L681.026 247.114L685.672 251.67L684.378 253.898L677.907 252.093L672.96 247.716L674.714 245.241Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M646.739 240.185L650.215 242.49L653.342 248.106L652.732 251.74L649.12 249.541L645.964 243.551L646.739 240.185Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M638.596 242.695L642.861 244.378L646.713 250.644L646.504 254.23L642.621 252.172L639.512 246.921L638.596 242.695Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M651.477 239.271L650.203 242.43L653.357 248.106L657.816 250.086L659.301 247.047",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M645.601 230.662L648.987 233.418L651.477 239.272L650.203 242.431L646.74 240.185L644.497 233.824L645.601 230.662Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M655.948 222.395L660.242 225.988L663.071 231.524L661.192 233.924L656.571 230.972L654.239 225.16L655.948 222.395Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M650.426 221.756L654.158 224.987L656.527 231.049L654.742 233.641L650.557 230.707L648.73 224.676L650.426 221.756Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M642.907 241.072L645.962 243.55L649.129 249.588L649.646 252.684L646.711 250.645L642.859 244.38L642.907 241.072Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M689.017 230.701L694.175 230.979L698.562 232.428L697.58 233.737L692.299 233.007L688.123 231.402L689.017 230.701Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M692.298 233.008L697.579 233.738L701.859 235.469L700.626 236.819L695.226 235.641L691.181 233.537L692.298 233.008Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M698.565 232.43L703.919 232.242L708.418 233.78L707.348 235.668L701.863 235.469L697.583 233.738L698.565 232.43Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M701.862 235.468L707.346 235.667L711.719 237.615L710.379 239.715L704.768 239.153L700.627 236.818L701.862 235.468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M708.418 233.78L713.936 233.335L718.528 235.096L717.386 237.447L711.72 237.616L707.347 235.667L708.418 233.78Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M732.243 241.909L738.667 241.955L743.721 246.04L742.544 249.273L736.016 248.281L730.79 244.85L732.243 241.909Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M743.721 246.039L749.036 247.669L753.092 252.939L752.227 256.264L747.086 254.224L742.544 249.272L743.721 246.039Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M739.213 239.509L744.445 240.804L749.488 244.962L749.039 247.67L743.708 246.015L738.67 241.954L739.213 239.509Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M728.848 236.649L733.733 236.929L739.246 239.509L738.667 241.953L732.244 241.908L727.709 239.33L728.848 236.649Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M749.486 244.963L752.624 246.006L758.208 252.514L757.596 255.501L753.092 252.941L749.036 247.671L749.486 244.963Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M689.043 233.208L693.147 235.17L697.752 239.242L696.034 240.517L690.403 237.316L688.115 234.162L689.043 233.208Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M691.811 238.115L696.034 240.515L699.904 244.17L698.197 245.82L693.811 243.698L690.397 239.905L691.811 238.115Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M697.754 239.241L703.277 240.822L707.299 243.925L705.579 246.075L699.914 244.183L696.036 240.516L697.754 239.241Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M707.295 243.926L713.039 244.784L717.205 248.033L715.436 251.003L709.544 249.956L705.575 246.076L707.295 243.926Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M717.207 248.033L723.164 248.245L727.505 251.509L725.733 255.05L719.617 254.821L715.438 251.002L717.207 248.033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M724.8 245.12L730.788 244.85L736.014 248.28L734.48 251.737L727.503 251.51L723.163 248.245L724.8 245.12Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M699.915 244.183L705.58 246.075L709.549 249.955L707.672 252.636L701.853 250.492L698.199 245.821L699.915 244.183Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M693.81 243.7L698.195 245.822L701.85 250.493L699.669 252.959L694.601 250.078L692.234 245.768L693.81 243.7Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M481.885 82.5721C481.725 82.2061 481.296 82.0375 480.926 82.1952C480.556 82.3532 480.386 82.7779 480.545 83.1437C480.705 83.5097 481.134 83.6783 481.504 83.5207C481.874 83.3626 482.044 82.9384 481.885 82.5721Z",
    stroke: "white"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M681.877 246.896C681.717 246.53 681.288 246.362 680.918 246.519C680.548 246.677 680.378 247.102 680.537 247.468C680.697 247.834 681.126 248.002 681.496 247.845C681.843 247.697 682.014 247.315 681.903 246.965L681.877 246.896Z",
    stroke: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M661.94 233.9C661.78 233.534 661.35 233.366 660.981 233.523C660.611 233.681 660.44 234.106 660.6 234.472C660.76 234.838 661.189 235.007 661.559 234.849C661.905 234.701 662.077 234.318 661.966 233.969L661.94 233.9Z",
    stroke: "white"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M688.424 231.758C688.264 231.392 687.835 231.223 687.465 231.381C687.095 231.539 686.925 231.963 687.084 232.329C687.244 232.695 687.673 232.864 688.043 232.706C688.413 232.549 688.583 232.123 688.424 231.758Z",
    stroke: "white"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M482.076 102.991C482.119 102.619 481.871 102.281 481.51 102.202L481.436 102.19C481.061 102.147 480.719 102.393 480.639 102.75L480.627 102.823C480.584 103.194 480.833 103.532 481.193 103.611L481.267 103.623L481.342 103.628C481.687 103.633 481.99 103.397 482.064 103.063L482.076 102.991Z",
    stroke: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M517.057 145.218C517.173 144.862 516.995 144.482 516.656 144.336L516.586 144.31L516.587 144.309C516.227 144.195 515.843 144.372 515.695 144.707L515.669 144.776C515.546 145.155 515.757 145.562 516.14 145.684L516.14 145.683C516.5 145.798 516.883 145.622 517.031 145.287L517.057 145.218Z",
    stroke: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M497.987 94.991C498.103 94.6354 497.925 94.2557 497.586 94.1093L497.516 94.0831C497.157 93.969 496.773 94.145 496.625 94.4799L496.599 94.549L496.598 94.5491C496.475 94.9282 496.686 95.335 497.07 95.4572L497.07 95.4567C497.429 95.5711 497.813 95.3951 497.961 95.0601L497.987 94.991Z",
    stroke: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M523.921 106.044C523.85 105.651 523.471 105.39 523.075 105.46C522.678 105.53 522.415 105.905 522.485 106.297C522.556 106.69 522.935 106.951 523.332 106.881C523.728 106.811 523.992 106.436 523.921 106.044Z",
    stroke: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M540.772 148.939C540.612 148.573 540.182 148.405 539.813 148.562C539.443 148.72 539.272 149.145 539.432 149.511C539.592 149.877 540.021 150.045 540.391 149.888C540.737 149.74 540.909 149.357 540.798 149.008L540.772 148.939Z",
    stroke: "white"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M469.053 130.752C468.893 130.386 468.464 130.217 468.094 130.375C467.724 130.533 467.554 130.958 467.713 131.323C467.873 131.689 468.302 131.858 468.672 131.7C469.019 131.552 469.19 131.17 469.079 130.821L469.053 130.752Z",
    stroke: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M543.721 206.644C543.561 206.278 543.132 206.11 542.762 206.267C542.392 206.426 542.222 206.85 542.381 207.216C542.541 207.582 542.97 207.751 543.34 207.593C543.71 207.435 543.88 207.01 543.721 206.644Z",
    stroke: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M577.244 184.65C577.084 184.284 576.655 184.116 576.285 184.273C575.915 184.431 575.745 184.856 575.905 185.222C576.064 185.588 576.494 185.756 576.863 185.599C577.233 185.441 577.404 185.016 577.244 184.65Z",
    stroke: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M601.252 183.871C601.092 183.505 600.663 183.336 600.293 183.494C599.923 183.652 599.753 184.077 599.912 184.442C600.072 184.809 600.501 184.977 600.871 184.819C601.218 184.671 601.389 184.289 601.278 183.94L601.252 183.871Z",
    stroke: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M562.033 161.58C561.873 161.214 561.444 161.045 561.074 161.203C560.704 161.361 560.534 161.786 560.694 162.152C560.853 162.518 561.283 162.686 561.653 162.528C562.022 162.371 562.193 161.946 562.033 161.58Z",
    stroke: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M535.916 177.8C535.756 177.435 535.327 177.266 534.957 177.424C534.587 177.582 534.417 178.006 534.576 178.372C534.736 178.738 535.166 178.907 535.535 178.749C535.905 178.591 536.076 178.166 535.916 177.8Z",
    stroke: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M566.643 205.805C566.483 205.439 566.053 205.27 565.684 205.428C565.314 205.586 565.143 206.01 565.303 206.376C565.463 206.742 565.892 206.911 566.262 206.753C566.609 206.605 566.78 206.223 566.669 205.874L566.643 205.805Z",
    stroke: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M628.334 238.652C628.174 238.286 627.745 238.118 627.375 238.275C627.005 238.433 626.835 238.858 626.994 239.224C627.154 239.59 627.584 239.758 627.953 239.601C628.323 239.443 628.494 239.018 628.334 238.652Z",
    stroke: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M554.166 236.271C554.006 235.905 553.577 235.737 553.207 235.894C552.837 236.052 552.667 236.477 552.826 236.843C552.986 237.209 553.416 237.377 553.785 237.22C554.132 237.072 554.304 236.69 554.192 236.34L554.166 236.271Z",
    stroke: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M524.854 201.469C524.694 201.103 524.264 200.934 523.895 201.092C523.525 201.25 523.354 201.674 523.514 202.04C523.674 202.406 524.103 202.575 524.473 202.417C524.82 202.269 524.991 201.887 524.88 201.538L524.854 201.469Z",
    stroke: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M322.135 141.553C321.975 141.187 321.546 141.018 321.176 141.176C320.806 141.334 320.636 141.758 320.795 142.124C320.955 142.49 321.384 142.659 321.754 142.501C322.101 142.353 322.272 141.971 322.161 141.622L322.135 141.553Z",
    stroke: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M540.017 224.9C539.858 224.534 539.428 224.366 539.059 224.523C538.689 224.681 538.518 225.106 538.678 225.472C538.838 225.838 539.267 226.006 539.637 225.849C539.984 225.701 540.155 225.318 540.044 224.969L540.017 224.9Z",
    stroke: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M506.33 228.447C506.171 228.081 505.741 227.913 505.372 228.07C505.002 228.228 504.831 228.653 504.991 229.019C505.151 229.385 505.579 229.554 505.95 229.396C506.296 229.248 506.467 228.865 506.357 228.516L506.33 228.447Z",
    stroke: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M484.103 225.447C483.944 225.081 483.514 224.913 483.145 225.07C482.775 225.228 482.605 225.653 482.764 226.019C482.924 226.385 483.353 226.553 483.723 226.396C484.093 226.238 484.263 225.813 484.103 225.447Z",
    stroke: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M200.018 240.783C199.858 240.417 199.428 240.248 199.059 240.406C198.689 240.564 198.518 240.989 198.678 241.355C198.838 241.721 199.267 241.89 199.637 241.732C199.984 241.584 200.155 241.201 200.044 240.852L200.018 240.783Z",
    stroke: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M204.947 193.656C204.787 193.29 204.358 193.122 203.988 193.279C203.618 193.437 203.448 193.862 203.608 194.228C203.767 194.594 204.197 194.763 204.567 194.605C204.913 194.457 205.085 194.074 204.973 193.725L204.947 193.656Z",
    stroke: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M155.725 195.881C155.565 195.515 155.136 195.346 154.766 195.504C154.396 195.662 154.226 196.086 154.385 196.452C154.545 196.818 154.974 196.987 155.344 196.829C155.691 196.681 155.862 196.299 155.751 195.95L155.725 195.881Z",
    stroke: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M465.029 183.48C464.87 183.114 464.44 182.946 464.071 183.104C463.701 183.262 463.531 183.686 463.69 184.052C463.85 184.418 464.279 184.587 464.649 184.429C464.995 184.281 465.167 183.898 465.056 183.55L465.029 183.48Z",
    stroke: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M465.064 202.767C464.905 202.402 464.476 202.233 464.106 202.391C463.736 202.549 463.566 202.973 463.725 203.339C463.885 203.705 464.314 203.874 464.684 203.716C465.03 203.568 465.202 203.186 465.091 202.837L465.064 202.767Z",
    stroke: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M468.947 170.246C468.788 169.88 468.358 169.711 467.989 169.869C467.619 170.027 467.448 170.452 467.608 170.818C467.768 171.184 468.197 171.352 468.567 171.194C468.937 171.036 469.107 170.612 468.947 170.246Z",
    stroke: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M485.463 155.613C485.303 155.247 484.874 155.079 484.504 155.236C484.134 155.394 483.964 155.819 484.123 156.185C484.283 156.551 484.712 156.719 485.082 156.562C485.429 156.414 485.6 156.031 485.489 155.682L485.463 155.613Z",
    stroke: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M494.045 120.549C493.885 120.183 493.456 120.014 493.086 120.172C492.716 120.33 492.546 120.754 492.705 121.12C492.865 121.486 493.295 121.655 493.664 121.497C494.034 121.339 494.204 120.915 494.045 120.549Z",
    stroke: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M461.162 117.004C461.002 116.638 460.573 116.469 460.203 116.627C459.833 116.785 459.663 117.21 459.823 117.575C459.982 117.941 460.412 118.11 460.781 117.952C461.151 117.794 461.321 117.37 461.162 117.004Z",
    stroke: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M494.69 177.111C494.53 176.745 494.1 176.577 493.731 176.734C493.361 176.892 493.19 177.317 493.35 177.683C493.51 178.049 493.939 178.217 494.309 178.06C494.679 177.902 494.849 177.477 494.69 177.111Z",
    stroke: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M441.33 139.57C441.17 139.204 440.741 139.036 440.371 139.193C440.001 139.351 439.831 139.776 439.99 140.142C440.15 140.508 440.579 140.677 440.949 140.519C441.319 140.361 441.489 139.936 441.33 139.57Z",
    stroke: "white"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M432.51 116.639C432.35 116.273 431.921 116.104 431.551 116.262C431.181 116.42 431.011 116.844 431.17 117.21C431.33 117.576 431.759 117.745 432.129 117.587C432.499 117.429 432.669 117.005 432.51 116.639Z",
    stroke: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M438.967 88.1327C438.807 87.7667 438.378 87.5981 438.008 87.7557C437.638 87.9138 437.468 88.3384 437.627 88.7042C437.787 89.0703 438.216 89.2393 438.586 89.0812C438.956 88.9232 439.126 88.4989 438.967 88.1327Z",
    stroke: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M429.608 65.6151C429.448 65.2491 429.018 65.0805 428.649 65.2381C428.279 65.3962 428.108 65.8209 428.268 66.1867C428.428 66.5527 428.857 66.7217 429.227 66.5636C429.597 66.4056 429.767 65.9813 429.608 65.6151Z",
    stroke: "white"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M396.854 55.8046C396.694 55.4385 396.264 55.27 395.895 55.4276C395.525 55.5857 395.354 56.0103 395.514 56.3761C395.674 56.7421 396.103 56.9111 396.473 56.7531C396.843 56.595 397.013 56.1708 396.854 55.8046Z",
    stroke: "white"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M370.729 14.3964C370.569 14.0303 370.139 13.8618 369.77 14.0194C369.4 14.1775 369.229 14.6021 369.389 14.9679C369.549 15.3339 369.978 15.5029 370.348 15.3449C370.718 15.1868 370.888 14.7626 370.729 14.3964Z",
    stroke: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M344.463 27.7597C344.303 27.3936 343.874 27.225 343.504 27.3827C343.134 27.5407 342.964 27.9654 343.123 28.3312C343.283 28.6972 343.712 28.8662 344.082 28.7082C344.452 28.5501 344.622 28.1259 344.463 27.7597Z",
    stroke: "white"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M365.819 53.7655C365.659 53.3995 365.229 53.2309 364.86 53.3885C364.49 53.5466 364.319 53.9713 364.479 54.3371C364.639 54.7031 365.068 54.8721 365.438 54.714C365.808 54.556 365.978 54.1317 365.819 53.7655Z",
    stroke: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M367.768 72.6249C367.608 72.2589 367.179 72.0903 366.809 72.2479C366.439 72.406 366.269 72.8306 366.428 73.1964C366.588 73.5625 367.017 73.7315 367.387 73.5734C367.757 73.4153 367.927 72.9911 367.768 72.6249Z",
    stroke: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M384.697 107.215C384.538 106.849 384.108 106.68 383.739 106.838C383.369 106.996 383.198 107.42 383.358 107.786C383.518 108.152 383.947 108.321 384.317 108.163C384.687 108.005 384.857 107.581 384.697 107.215Z",
    stroke: "white"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M402.08 130.408C401.92 130.042 401.491 129.873 401.121 130.031C400.751 130.189 400.581 130.614 400.74 130.98C400.9 131.346 401.329 131.515 401.699 131.357C402.069 131.199 402.239 130.774 402.08 130.408Z",
    stroke: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M402.182 83.8671C402.022 83.501 401.593 83.3325 401.223 83.4901C400.853 83.6482 400.683 84.0728 400.842 84.4386C401.002 84.8046 401.431 84.9736 401.801 84.8156C402.171 84.6575 402.341 84.2333 402.182 83.8671Z",
    stroke: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M494.959 199.011C494.8 198.646 494.37 198.477 494 198.635C493.63 198.793 493.46 199.218 493.62 199.583C493.78 199.949 494.209 200.118 494.579 199.96C494.925 199.812 495.096 199.43 494.985 199.081L494.959 199.011Z",
    stroke: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M519.717 177.469C519.557 177.103 519.128 176.934 518.758 177.092C518.388 177.25 518.218 177.674 518.377 178.04C518.537 178.406 518.966 178.575 519.336 178.417C519.683 178.269 519.854 177.887 519.743 177.538L519.717 177.469Z",
    stroke: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M612.408 212.957C612.248 212.591 611.819 212.422 611.449 212.58C611.079 212.738 610.909 213.163 611.069 213.528C611.228 213.894 611.658 214.063 612.028 213.905C612.398 213.747 612.568 213.323 612.408 212.957Z",
    stroke: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M572.861 229.867C572.702 229.501 572.272 229.332 571.903 229.49C571.533 229.648 571.362 230.073 571.522 230.439C571.682 230.805 572.111 230.973 572.481 230.816C572.851 230.658 573.021 230.233 572.861 229.867Z",
    stroke: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M582.711 148.34L582.675 148.276C582.472 147.961 582.064 147.854 581.733 148.017L581.668 148.053C581.349 148.253 581.241 148.658 581.407 148.985L581.443 149.049C581.645 149.365 582.054 149.472 582.385 149.308L582.45 149.272C582.768 149.072 582.877 148.668 582.711 148.34Z",
    stroke: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M273.21 183.086C273.047 182.719 272.618 182.55 272.251 182.709C271.879 182.866 271.71 183.292 271.869 183.657C272.027 184.022 272.456 184.191 272.828 184.034C273.199 183.877 273.368 183.452 273.21 183.086Z",
    stroke: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M275.9 2.65388C275.742 2.2888 275.313 2.12022 274.941 2.27691C274.569 2.43401 274.401 2.85965 274.559 3.22472C274.721 3.59219 275.151 3.76077 275.518 3.60169C275.867 3.45491 276.038 3.07255 275.927 2.72352L275.9 2.65388Z",
    stroke: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M293.178 16.3615C293.02 15.9964 292.591 15.8278 292.219 15.9845C291.848 16.1416 291.679 16.5672 291.837 16.9323C292 17.2998 292.429 17.4684 292.796 17.3093C293.168 17.1522 293.337 16.7265 293.178 16.3615Z",
    stroke: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M266.822 42.431C266.663 42.066 266.234 41.8974 265.862 42.0545C265.495 42.2136 265.322 42.6368 265.485 43.0043C265.643 43.3694 266.072 43.5379 266.44 43.3788C266.811 43.2217 266.984 42.7989 266.822 42.431Z",
    stroke: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M287.408 63.0072C287.249 62.6421 286.82 62.4736 286.448 62.6307C286.081 62.7897 285.908 63.213 286.071 63.5805C286.229 63.9455 286.658 64.1145 287.026 63.955C287.397 63.7983 287.57 63.3751 287.408 63.0072Z",
    stroke: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M300.759 80.5816C300.601 80.2165 300.172 80.0479 299.8 80.205C299.433 80.3641 299.26 80.7874 299.423 81.1548C299.581 81.5199 300.01 81.6885 300.377 81.5294C300.726 81.3826 300.898 81.0002 300.786 80.6516L300.759 80.5816Z",
    stroke: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M301.802 44.0075C301.644 43.642 301.215 43.4735 300.843 43.6306C300.476 43.7897 300.303 44.2129 300.465 44.5804C300.624 44.9454 301.053 45.1144 301.42 44.9549C301.791 44.7982 301.964 44.375 301.802 44.0075Z",
    stroke: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92 186.307C292.962 185.935 292.715 185.598 292.352 185.518L292.28 185.506C291.906 185.464 291.562 185.709 291.483 186.067L291.47 186.139C291.428 186.51 291.675 186.847 292.038 186.928L292.11 186.939L292.185 186.944C292.53 186.949 292.835 186.714 292.906 186.379L292.92 186.307Z",
    stroke: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M222.513 35.4907C222.625 35.1329 222.447 34.7534 222.111 34.6082L222.042 34.5827C221.682 34.4681 221.299 34.6448 221.15 34.9788L221.121 35.047C221.001 35.428 221.209 35.833 221.593 35.955C221.952 36.0696 222.336 35.8925 222.485 35.5584L222.513 35.4907Z",
    stroke: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M303.441 213.298C303.371 212.906 302.991 212.644 302.596 212.715C302.197 212.783 301.934 213.159 302.004 213.551C302.078 213.945 302.455 214.204 302.854 214.136C303.248 214.065 303.511 213.69 303.441 213.298Z",
    stroke: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M200.834 6.58774C200.674 6.2217 200.245 6.05314 199.875 6.21079C199.505 6.36885 199.335 6.7935 199.494 7.15929C199.654 7.52532 200.084 7.69391 200.453 7.53626C200.8 7.38829 200.972 7.00593 200.86 6.6569L200.834 6.58774Z",
    stroke: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M198.397 27.9454C198.239 27.5804 197.81 27.4118 197.438 27.5685C197.067 27.7256 196.898 28.1512 197.056 28.5163C197.219 28.8838 197.648 29.0523 198.015 28.8933C198.387 28.7362 198.555 28.3105 198.397 27.9454Z",
    stroke: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M125.322 14.7027C125.164 14.3376 124.734 14.1691 124.363 14.3257C123.996 14.4852 123.823 14.9085 123.985 15.276C124.143 15.641 124.573 15.8096 124.94 15.6505C125.289 15.5037 125.46 15.1214 125.349 14.7723L125.322 14.7027Z",
    stroke: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M121.116 34.5021C120.958 34.137 120.528 33.9684 120.157 34.1251C119.789 34.2846 119.617 34.7079 119.779 35.0753C119.937 35.4404 120.367 35.609 120.734 35.4499C121.105 35.2928 121.274 34.8672 121.116 34.5021Z",
    stroke: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M106.809 10.8368C106.651 10.4718 106.221 10.3032 105.85 10.4598C105.483 10.6193 105.31 11.0422 105.472 11.41C105.63 11.7751 106.06 11.9437 106.431 11.7866C106.799 11.6275 106.971 11.2043 106.809 10.8368Z",
    stroke: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5758 42.6441C36.4176 42.279 35.9883 42.1105 35.6169 42.2671C35.2452 42.4242 35.0766 42.8499 35.2348 43.215C35.3972 43.5824 35.8263 43.7514 36.1937 43.5919C36.5426 43.4451 36.7141 43.0628 36.6027 42.7138L36.5758 42.6441Z",
    stroke: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4036 0.130283C70.2455 -0.23479 69.8161 -0.403366 69.4447 -0.246681C69.0773 -0.0871811 68.9045 0.336061 69.0669 0.703531C69.2251 1.0686 69.6544 1.23718 70.0216 1.0781C70.3932 0.920993 70.5658 0.498171 70.4036 0.130283Z",
    stroke: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M56.694 63.3439C56.5358 62.9788 56.1064 62.8102 55.735 62.9669C55.3634 63.124 55.1948 63.5497 55.353 63.9147C55.5154 64.2822 55.9447 64.4508 56.3119 64.2917C56.6833 64.135 56.8521 63.709 56.694 63.3439Z",
    stroke: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M265.21 53.1642C265.047 52.7967 264.618 52.6282 264.251 52.7872C263.879 52.9443 263.71 53.3699 263.869 53.735C264.027 54.1001 264.456 54.2687 264.828 54.112C265.199 53.9549 265.368 53.5297 265.21 53.1642Z",
    stroke: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M159.784 38.3419C159.626 37.9769 159.196 37.8083 158.825 37.965C158.457 38.1245 158.285 38.5477 158.447 38.9152C158.605 39.2802 159.035 39.4488 159.402 39.2897C159.773 39.1326 159.942 38.707 159.784 38.3419Z",
    stroke: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M216.991 157.233C216.833 156.867 216.403 156.699 216.032 156.856C215.66 157.013 215.492 157.438 215.65 157.803C215.812 158.171 216.242 158.339 216.609 158.18C216.98 158.023 217.149 157.598 216.991 157.233Z",
    stroke: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M229.44 192.045C229.282 191.68 228.853 191.511 228.481 191.668C228.109 191.825 227.941 192.251 228.099 192.616C228.261 192.983 228.691 193.152 229.058 192.993C229.43 192.836 229.598 192.41 229.44 192.045Z",
    stroke: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M253.424 228.979C253.266 228.614 252.837 228.445 252.466 228.602C252.094 228.759 251.925 229.184 252.083 229.549C252.246 229.917 252.675 230.086 253.042 229.926C253.414 229.769 253.583 229.344 253.424 228.979Z",
    stroke: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M290.674 240.166C290.516 239.801 290.087 239.632 289.716 239.789C289.344 239.946 289.175 240.372 289.333 240.737C289.496 241.104 289.925 241.273 290.292 241.114C290.664 240.957 290.833 240.531 290.674 240.166Z",
    stroke: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M169.768 173.106C169.61 172.741 169.181 172.572 168.809 172.729C168.438 172.886 168.269 173.311 168.427 173.676C168.59 174.044 169.019 174.212 169.386 174.053C169.758 173.896 169.926 173.471 169.768 173.106Z",
    stroke: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M123.034 167.623C122.876 167.258 122.446 167.09 122.075 167.246C121.703 167.403 121.535 167.829 121.693 168.194C121.855 168.561 122.285 168.73 122.652 168.571C123.023 168.414 123.192 167.988 123.034 167.623Z",
    stroke: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M111.628 201.336C111.469 200.971 111.04 200.802 110.669 200.959C110.297 201.116 110.128 201.542 110.287 201.907C110.449 202.274 110.878 202.443 111.245 202.284C111.617 202.127 111.786 201.701 111.628 201.336Z",
    stroke: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M81.944 147.594C81.7858 147.229 81.3564 147.06 80.985 147.217C80.6134 147.374 80.4448 147.8 80.603 148.165C80.7654 148.532 81.1947 148.701 81.5619 148.542C81.9335 148.385 82.1021 147.959 81.944 147.594Z",
    stroke: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M69.44 182.649C69.2819 182.283 68.8525 182.115 68.4811 182.272C68.1095 182.429 67.9409 182.854 68.0991 183.219C68.2615 183.587 68.6908 183.755 69.058 183.596C69.4296 183.439 69.5982 183.014 69.44 182.649Z",
    stroke: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M139.232 32.2045C139.074 31.8394 138.644 31.6709 138.273 31.8275C137.905 31.987 137.733 32.4103 137.895 32.7778C138.053 33.1428 138.483 33.3114 138.85 33.1523C139.221 32.9952 139.394 32.5724 139.232 32.2045Z",
    stroke: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M183.639 45.631C183.481 45.2659 183.052 45.0973 182.68 45.254C182.313 45.4135 182.14 45.8368 182.303 46.2042C182.461 46.5693 182.89 46.7379 183.257 46.5788C183.629 46.4217 183.797 45.9961 183.639 45.631Z",
    stroke: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M132.534 81.4884C132.376 81.1233 131.946 80.9548 131.575 81.1114C131.203 81.2686 131.035 81.6942 131.193 82.0593C131.355 82.4267 131.785 82.5953 132.152 82.4362C132.523 82.2791 132.692 81.8539 132.534 81.4884Z",
    stroke: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M175.638 63.2729C175.48 62.9078 175.051 62.7392 174.679 62.8959C174.312 63.055 174.139 63.4786 174.302 63.8457C174.459 64.2112 174.889 64.3798 175.256 64.2203C175.628 64.0636 175.8 63.6403 175.638 63.2729Z",
    stroke: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M146.163 6.74427C146.005 6.3792 145.575 6.21062 145.204 6.36731C144.836 6.52681 144.664 6.95005 144.826 7.31752C144.984 7.68259 145.413 7.85117 145.781 7.69208C146.152 7.53498 146.321 7.10935 146.163 6.74427Z",
    stroke: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M178.879 136.098L178.843 136.034C178.64 135.718 178.231 135.611 177.9 135.775L177.835 135.81C177.517 136.011 177.41 136.416 177.574 136.742L177.61 136.807C177.813 137.122 178.222 137.23 178.553 137.066L178.618 137.03C178.937 136.83 179.043 136.424 178.879 136.098Z",
    stroke: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M142.453 60.4725L142.417 60.4088C142.213 60.0928 141.804 59.9853 141.474 60.1491L141.412 60.1874C141.09 60.3852 140.983 60.7907 141.147 61.1169L141.187 61.1834C141.387 61.497 141.796 61.6041 142.126 61.4403L142.192 61.4048C142.51 61.2042 142.621 60.8011 142.453 60.4725Z",
    stroke: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M179.188 114.082L179.152 114.019C178.948 113.703 178.54 113.595 178.209 113.759L178.143 113.795C177.825 113.996 177.718 114.401 177.883 114.727L177.919 114.79C178.122 115.106 178.531 115.214 178.861 115.05L178.927 115.015C179.245 114.814 179.352 114.409 179.188 114.082Z",
    stroke: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4104 123.345C84.4965 122.955 84.2494 122.569 83.8564 122.483C83.4637 122.396 83.0745 122.642 82.9883 123.031C82.898 123.419 83.1454 123.804 83.5381 123.891C83.935 123.98 84.3242 123.735 84.4104 123.345Z",
    stroke: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M36.555 79.6078L36.5191 79.5441C36.3156 79.2281 35.9068 79.1206 35.5762 79.2844L35.5105 79.3203C35.192 79.5209 35.0858 79.926 35.2498 80.2522L35.2857 80.3159C35.4893 80.6318 35.8979 80.7393 36.2286 80.5755L36.2941 80.5401C36.6125 80.3394 36.719 79.9339 36.555 79.6078Z",
    stroke: "white"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M115.625 128.602L115.589 128.538C115.386 128.222 114.977 128.115 114.646 128.278L114.581 128.314C114.263 128.515 114.156 128.921 114.32 129.246L114.356 129.31C114.56 129.626 114.968 129.733 115.299 129.57L115.364 129.534C115.683 129.334 115.789 128.928 115.625 128.602Z",
    stroke: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M120.977 62.6878L120.941 62.6241C120.737 62.3082 120.329 62.2007 119.998 62.3644L119.932 62.4003C119.594 62.6154 119.493 63.0604 119.707 63.3964C119.911 63.7123 120.32 63.8194 120.65 63.6556L120.716 63.6202C121.034 63.4195 121.141 63.014 120.977 62.6878Z",
    stroke: "white"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5772 94.5359C26.7519 94.177 26.5975 93.7475 26.2317 93.5757C25.8658 93.4043 25.4334 93.5596 25.2589 93.9181C25.0884 94.2794 25.2426 94.7093 25.6086 94.8808C25.9701 95.0502 26.4066 94.8972 26.5772 94.5359Z",
    stroke: "white"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1644 87.2386L83.1285 87.1749C82.9249 86.859 82.5162 86.7514 82.1855 86.9152L82.1199 86.9511C81.8017 87.1514 81.6952 87.5568 81.8592 87.883L81.8948 87.9471C82.0984 88.2631 82.5073 88.3702 82.838 88.2064L82.9035 88.171C83.2219 87.9703 83.3283 87.5648 83.1644 87.2386Z",
    stroke: "white"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M118.055 101.524L118.019 101.46C117.816 101.144 117.407 101.037 117.076 101.2L117.01 101.236C116.692 101.437 116.586 101.842 116.75 102.168L116.785 102.232C116.989 102.548 117.398 102.655 117.729 102.492L117.794 102.456C118.113 102.255 118.219 101.85 118.055 101.524Z",
    stroke: "white"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0667 110.006L48.0308 109.942C47.8273 109.627 47.4185 109.519 47.0879 109.683L47.0222 109.719C46.704 109.919 46.5976 110.324 46.7615 110.651L46.7972 110.715C47.0007 111.031 47.4097 111.138 47.7403 110.974L47.8058 110.939C48.1242 110.738 48.2307 110.332 48.0667 110.006Z",
    stroke: "white"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M243.063 169.252L243.027 169.189C242.823 168.873 242.415 168.765 242.084 168.929L242.018 168.965C241.7 169.165 241.594 169.571 241.758 169.897L241.793 169.961C241.997 170.277 242.406 170.384 242.736 170.22L242.802 170.185C243.12 169.984 243.227 169.578 243.063 169.252Z",
    stroke: "white"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M144.647 123.188C144.733 122.798 144.486 122.412 144.093 122.326C143.7 122.239 143.311 122.484 143.22 122.872C143.134 123.262 143.382 123.647 143.774 123.734C144.167 123.821 144.556 123.575 144.647 123.188Z",
    stroke: "white"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M168.969 98.8421L168.933 98.7784C168.73 98.4625 168.321 98.355 167.99 98.5187L167.925 98.5546C167.606 98.7549 167.5 99.1604 167.664 99.4865L167.7 99.5507C167.903 99.8666 168.312 99.9737 168.643 99.8099L168.708 99.7745C169.027 99.5738 169.133 99.1683 168.969 98.8421Z",
    stroke: "white"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M241.751 61.4643C241.593 61.0992 241.164 60.9306 240.792 61.0873C240.425 61.2468 240.252 61.67 240.415 62.0375C240.573 62.4026 241.002 62.5712 241.369 62.4121C241.741 62.2554 241.914 61.8317 241.751 61.4643Z",
    stroke: "white"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M299.862 103.373C299.704 103.008 299.274 102.84 298.903 102.996C298.531 103.153 298.363 103.579 298.521 103.944C298.683 104.311 299.113 104.48 299.48 104.321C299.852 104.164 300.02 103.739 299.862 103.373Z",
    stroke: "white"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M311.588 92.8419C311.43 92.4769 311.001 92.3083 310.63 92.465C310.258 92.6221 310.089 93.0477 310.248 93.4128C310.41 93.7802 310.839 93.9488 311.206 93.7897C311.578 93.6326 311.746 93.2074 311.588 92.8419Z",
    stroke: "white"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M275.378 93.3123L275.342 93.2486C275.139 92.9327 274.73 92.8252 274.4 92.9889L274.338 93.0272C274.016 93.2251 273.909 93.6306 274.073 93.9567L274.113 94.0233C274.312 94.3368 274.721 94.4439 275.052 94.2801L275.117 94.2447C275.436 94.044 275.547 93.6409 275.378 93.3123Z",
    stroke: "white"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M278.395 147.77L278.359 147.706C278.155 147.39 277.747 147.283 277.416 147.446L277.35 147.482C277.032 147.683 276.925 148.089 277.09 148.414L277.126 148.478C277.329 148.794 277.738 148.901 278.068 148.738L278.134 148.702C278.452 148.502 278.559 148.096 278.395 147.77Z",
    stroke: "white"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M233.838 110.291C233.924 109.901 233.677 109.516 233.284 109.429C232.891 109.343 232.502 109.588 232.412 109.975C232.326 110.365 232.573 110.751 232.966 110.837C233.358 110.924 233.748 110.679 233.838 110.291Z",
    stroke: "white"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M207.348 90.7018L207.312 90.6377C207.109 90.3218 206.7 90.2147 206.369 90.3784L206.303 90.4143C205.985 90.6146 205.874 91.0177 206.043 91.3463L206.079 91.41C206.282 91.7259 206.691 91.833 207.021 91.6696L207.087 91.6337C207.405 91.4335 207.512 91.028 207.348 90.7018Z",
    stroke: "white"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M248.102 153.809L248.066 153.745C247.862 153.429 247.454 153.322 247.123 153.486L247.057 153.521C246.739 153.722 246.632 154.128 246.797 154.453L246.833 154.517C247.036 154.833 247.445 154.94 247.775 154.777L247.841 154.741C248.159 154.541 248.266 154.135 248.102 153.809Z",
    stroke: "white"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M264.941 114.185L264.905 114.122C264.701 113.806 264.293 113.698 263.962 113.862L263.901 113.9C263.558 114.113 263.457 114.558 263.676 114.896C263.875 115.21 264.284 115.317 264.614 115.153L264.68 115.118C264.998 114.917 265.109 114.514 264.941 114.185Z",
    stroke: "white"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M230.589 85.1241C230.76 84.7628 230.606 84.3333 230.24 84.1615C229.878 83.9925 229.441 84.1454 229.271 84.5063C229.096 84.8652 229.251 85.2951 229.617 85.4666C229.982 85.6384 230.415 85.483 230.589 85.1241Z",
    stroke: "white"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M203.765 73.6873L203.729 73.6236C203.526 73.3077 203.117 73.2002 202.786 73.3639L202.725 73.4022C202.402 73.6001 202.296 74.0056 202.46 74.3317L202.5 74.3983C202.699 74.7118 203.108 74.8189 203.439 74.6551L203.504 74.6197C203.823 74.419 203.933 74.0159 203.765 73.6873Z",
    stroke: "white"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M201.239 43.8528C201.329 43.4649 201.083 43.0775 200.691 42.9895C200.295 42.8987 199.907 43.1432 199.816 43.531C199.725 43.9189 199.972 44.3063 200.364 44.3943C200.759 44.4851 201.148 44.2406 201.239 43.8528Z",
    stroke: "white"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M259.55 77.1033L259.514 77.0396C259.311 76.7237 258.902 76.6162 258.571 76.78L258.51 76.8182C258.187 77.0165 258.081 77.4216 258.245 77.7478L258.285 77.8143C258.484 78.1278 258.893 78.2349 259.224 78.0711L259.289 78.0357C259.608 77.835 259.718 77.4319 259.55 77.1033Z",
    stroke: "white"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M214.016 129.444L213.98 129.38C213.776 129.064 213.368 128.957 213.037 129.12L212.971 129.156C212.653 129.356 212.547 129.762 212.711 130.088L212.746 130.152C212.95 130.468 213.359 130.575 213.69 130.411L213.755 130.376C214.073 130.175 214.18 129.77 214.016 129.444Z",
    stroke: "white"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M288.883 123.178L288.847 123.114C288.644 122.798 288.235 122.691 287.904 122.855L287.839 122.891C287.52 123.091 287.414 123.496 287.578 123.822L287.614 123.887C287.817 124.203 288.226 124.31 288.557 124.146L288.622 124.11C288.941 123.91 289.047 123.504 288.883 123.178Z",
    stroke: "white"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M311.262 121.923C311.348 121.533 311.101 121.148 310.708 121.061C310.315 120.974 309.926 121.22 309.84 121.61C309.75 121.997 309.997 122.382 310.39 122.469C310.787 122.558 311.176 122.313 311.262 121.923Z",
    stroke: "white"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M378.255 -8.20838L382.642 -5.57417L385.871 0.648858L384.959 3.91033L380.79 1.01477L377.272 -4.90341L378.255 -8.20838Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M383.227 -8.6078L386.951 -5.42118L390.073 1.05444L389.542 4.07415L385.871 0.650611L382.642 -5.57242L383.227 -8.6078Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M390.071 1.05449L393.282 4.91276L396.069 11.8985L395.522 14.8392L392.233 10.884L389.54 4.07421L390.071 1.05449Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M392.233 10.8851L395.523 14.8402L397.933 21.9035L396.906 24.8519L393.576 20.9264L391.291 14.015L392.233 10.8851Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M396.07 11.8982L399.07 16.1301L401.767 23.2706L401.157 26.0969L397.934 21.9021L395.524 14.8389L396.07 11.8982Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M352.548 -9.65836L359.527 -9.42926L364.829 -4.85381L363.317 -1.12921L356.225 -2.10033L350.778 -6.11743L352.548 -9.65836Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M364.828 -4.8539L370.853 -3.38906L374.866 2.18947L373.526 5.91721L368.056 4.09393L363.32 -1.12693L364.828 -4.8539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M374.865 2.18829L379.615 4.52738L382.635 10.8099L381.326 14.4164L377.009 11.8841L373.525 5.91602L374.865 2.18829Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M380.789 1.01675L384.957 3.91231L387.718 10.4795L386.531 13.8469L382.634 10.811L379.613 4.52892L380.789 1.01675Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M387.715 10.4779L391.289 14.0125L393.574 20.9239L392.294 24.075L388.857 20.5466L386.528 13.8453L387.715 10.4779Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M326.883 -10.6011L332.714 -8.52979L336.746 -4.02814L334.823 -0.888905L328.789 -2.95797L324.885 -8.2223L326.883 -10.6011Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M336.746 -4.02751L342.806 -2.95061L347.138 1.16128L345.331 4.80386L339.073 3.90267L334.822 -0.888276L336.746 -4.02751Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M347.139 1.16133L354.533 1.68003L360.242 6.53928L358.752 10.3912L351.231 9.21154L345.333 4.80391L347.139 1.16133Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M356.227 -2.09896L363.318 -1.12734L368.051 4.09113L366.617 7.9515L360.241 6.53913L354.528 1.67698L356.227 -2.09896Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M310.978 -13.1553L316.896 -9.14775L320.698 -3.09022L318.529 -0.293092L312.168 -4.08703L308.54 -10.9168L310.978 -13.1553Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M319.06 -11.339L324.884 -8.22263L328.788 -2.95826L326.769 -0.0620147L320.693 -3.09112L316.891 -9.14868L319.06 -11.339Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M320.693 -3.09035L326.769 -0.0612923L330.974 5.46582L329.101 8.65302L322.598 5.90436L318.524 -0.293264L320.693 -3.09035Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M291.463 -15.5992L298.543 -11.8548L301.324 -3.77814L296.302 1.54776L288.621 -1.3057L286.52 -10.3309L291.463 -15.5992Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M302.26 -15.3869L308.538 -10.9184L312.166 -4.08861L308.622 -0.44781L301.325 -3.77919L298.548 -11.8533L302.26 -15.3869Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M301.323 -3.7769L308.621 -0.445522L311.702 7.13391L306.647 12.5363L298.597 10.2294L296.302 1.54858L301.323 -3.7769Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M312.163 -4.08752L318.525 -0.293585L322.599 5.90409L319.265 9.69388L311.7 7.13283L308.619 -0.446599L312.163 -4.08752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M322.602 5.90411L329.105 8.65273L333.71 13.8485L330.613 17.8599L322.732 16.4509L319.269 9.69386L322.602 5.90411Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M257.818 -21.429L264.753 -18.999L266.319 -9.39073L260.619 -1.91089L253.749 -4.15319L252.492 -14.0234L257.818 -21.429Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M266.322 -9.3911L273.585 -6.82071L275.181 2.85259L269.168 10.3589L261.285 8.60455L260.622 -1.91127L266.322 -9.3911Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M279.149 -13.4216L286.519 -10.3309L288.62 -1.3057L282.813 5.32495L275.179 2.85348L273.583 -6.81982L279.149 -13.4216Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M288.619 -1.30502L296.301 1.54844L298.596 10.2296L292.597 16.8911L284.541 14.7877L282.811 5.32605L288.619 -1.30502Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M585.353 159.948L591.245 160.995L595.424 164.813L593.568 168.207L587.506 167.129L583.641 162.552L585.353 159.948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8316 168.582L46.5452 168.083L49.5469 174.504L38.216 181.745L22.7768 181.773L19.7925 175.675L30.8316 168.582Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55694 175.542L19.7933 175.674L22.7775 181.772L11.6273 189.227L-3.81191 189.255L-6.89106 182.809L3.55694 175.542Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7257 195.96L33.6844 196.19L38.3862 204.438L28.6404 211.517L9.56196 212.704L5.02151 203.667L15.7257 195.96Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3852 204.438L54.5266 204.223L62.7015 214.152L53.6864 222.526L37.1652 221.353L28.6393 211.518L38.3852 204.438Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7827 236.559L59.3615 233.681L53.6774 222.527L62.7039 214.152L78.8405 215.987L84.5132 227.142L75.7827 236.559Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5015 243.319L34.0802 240.441L28.3961 229.286L37.1664 221.353L53.6874 222.527L59.3713 233.681L50.5015 243.319Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7358 257.129L56.3146 254.251L50.6305 243.097L59.3724 233.68L75.7937 236.558L83.0101 247.116L72.7358 257.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2072 249.868L83.0079 247.115L75.7916 236.557L84.5229 227.142L100.944 230.02L108.289 240.357L99.2072 249.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1954 269.814L83.1548 268.381L74.5678 255.522L83.0118 247.116L99.2101 249.867L108.566 259.294L99.1954 269.814Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M108.287 240.356L125.564 244.308L131.156 255.116L122.943 261.599L108.562 259.294L99.2052 249.867L108.287 240.356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.2102 170.71L0.536958 170.014L3.55479 175.544L-6.89354 182.811C-13.2976 182.714 -16.9487 182.648 -23.3528 182.552L-25.5703 177.183L-13.2102 170.71Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M994.359 50.8709L989.2 51.1491L984.812 52.5977L985.795 53.9066L991.07 53.0821L995.497 51.6772L994.359 50.8709Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.83 49.156L999.996 49.1163L994.281 50.8828L995.491 51.677L1000.28 51.5465L1004.99 49.9816L1003.83 49.156Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M991.067 53.0834L985.792 53.908L981.512 55.6387L982.746 56.9886L988.145 55.8109L992.277 53.8776L991.067 53.0834Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M992.882 54.2731L996.506 54.0656L998.68 53.9415L1000.93 52.6613L1000.29 51.5464L995.493 51.6769L991.066 53.0818L992.882 54.2731Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M984.81 52.5975L979.457 52.4101L974.957 53.948L976.027 55.8358L981.512 55.6373L985.792 53.9064L984.81 52.5975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M981.514 55.638L976.029 55.8364L971.656 57.7852L972.996 59.8846L978.607 59.3232L982.748 56.9879L981.514 55.638Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M974.957 53.9494L969.439 53.5045L964.847 55.2662L965.989 57.6162L971.655 57.7858L976.028 55.837L974.957 53.9494Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M971.655 57.7855L965.989 57.6158L961.524 59.8303L962.94 62.5202L968.748 62.4559L972.994 59.8849L971.655 57.7855Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M964.845 55.2651L959.193 54.8108L954.516 56.8869L955.699 59.4986L961.522 59.8294L965.987 57.6149L964.845 55.2651Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M961.522 59.83L955.7 59.4987L951.132 61.9844L952.583 65.0189L958.571 65.2887L962.939 62.5199L961.522 59.83Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M954.519 56.8875L948.764 56.7133L943.634 59.449L944.697 62.1766L951.134 61.9844L955.702 59.499L954.519 56.8875Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M951.133 61.9837L944.695 62.1762L939.653 66.2081L940.83 69.4416L947.358 68.4486L952.584 65.0185L951.133 61.9837Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M943.638 59.4483L937.895 60.5024L933.431 64.8771L934.182 67.826L939.658 66.2078L944.7 62.1761L943.638 59.4483Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M933.428 64.8773L928.874 67.12L925.193 72.7273L925.778 75.7624L930.168 73.1267L934.179 67.8262L933.428 64.8773Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M930.167 73.1278L925.777 75.7635L922.549 81.9855L923.463 85.2463L927.63 82.3514L931.147 76.4342L930.167 73.1278Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M925.196 72.7276L921.475 75.9123L918.353 82.3879L918.883 85.4081L922.554 81.9848L925.782 75.7628L925.196 72.7276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M918.351 82.388L915.139 86.2468L912.351 93.2339L912.9 96.1731L916.189 92.2183L918.881 85.4082L918.351 82.388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M916.188 92.2176L912.898 96.1725L910.485 103.237L911.516 106.184L914.846 102.258L917.13 95.3472L916.188 92.2176Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M912.35 93.2351L909.35 97.467L906.656 104.606L907.264 107.433L910.486 103.239L912.899 96.1743L912.35 93.2351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M906.657 104.604L903.592 108.868L900.738 115.792L901.364 118.522L904.898 114.29L907.266 107.431L906.657 104.604Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.67 -5.80649L1183.21 -2.56047L1180.05 1.76589L1181.88 3.22783L1186.96 0.230274L1189.57 -4.49676L1187.67 -5.80649Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M994.83 54.207L989.525 56.5347L985.623 59.4106L987.261 60.5859L992.709 57.8673L997.231 54.0246L994.83 54.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M988.15 55.8093L982.75 56.987L978.609 59.3223L980.103 60.9901L985.626 59.4105L989.529 56.5343L988.15 55.8093Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M985.621 59.4097L980.098 60.9896L976.076 64.0935L977.795 66.2436L983.461 64.351L987.259 60.585L985.621 59.4097Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M976.076 64.0956L970.332 64.9545L966.166 68.2032L967.935 71.1724L973.827 70.1256L977.796 66.2454L976.076 64.0956Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M968.746 62.4557L962.938 62.5195L958.571 65.2889L960.209 68.4139L966.165 68.2026L970.331 64.9539L968.746 62.4557Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M966.172 68.2033L960.215 68.4145L955.874 71.6795L957.646 75.2194L963.762 74.991L967.94 71.1724L966.172 68.2033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M955.87 71.6773L948.894 71.905L943.593 76.48L945.101 80.2067L952.196 79.2342L957.642 75.2173L955.87 71.6773Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M947.358 68.4495L940.83 69.4425L936.287 74.3937L937.567 77.9467L943.591 76.4818L948.893 71.9068L947.358 68.4495Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M936.291 74.3946L931.15 76.4348L927.634 82.352L928.809 85.8645L933.56 83.5242L937.57 77.9476L936.291 74.3946Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M933.557 83.522L928.807 85.8618L925.788 92.1434L927.096 95.7504L931.414 93.2178L934.898 87.2495L933.557 83.522Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M927.631 82.3498L923.463 85.2446L920.701 91.813L921.887 95.1809L925.787 92.1433L928.806 85.8622L927.631 82.3498Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M925.788 92.1441L921.889 95.1815L919.563 101.881L920.937 105.279L924.536 102.202L927.096 95.7511L925.788 92.1441Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M920.7 91.8131L917.127 95.3474L914.844 102.258L916.12 105.411L919.56 101.881L921.886 95.1813L920.7 91.8131Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M919.562 101.882L916.121 105.413L914.179 112.248L915.681 115.383L918.971 111.955L920.936 105.28L919.562 101.882Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M914.846 102.258L911.516 106.184L909.419 113.129L910.829 116.032L914.18 112.247L916.123 105.411L914.846 102.258Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M914.183 112.248L910.831 116.034L908.946 122.721L910.601 125.575L913.969 122.026L915.685 115.383L914.183 112.248Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M909.419 113.129C908.084 114.704 907.408 115.382 906.072 116.956L903.712 123.856L905.331 126.483L908.944 122.719L910.83 116.032L909.419 113.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M904.895 114.291L901.361 118.522L898.677 124.865L899.851 127.532L903.709 123.857L906.069 116.958L904.895 114.291Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M908.944 122.72L905.331 126.483L903.156 132.737L904.95 135.333L908.77 131.929L910.6 125.574L908.944 122.72Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M919.562 101.882L916.121 105.413L914.179 112.248L915.681 115.383L918.971 111.955L920.936 105.28L919.562 101.882Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.75 -10.6365L1195.79 -6.73646L1193.76 -1.62235L1196.29 -0.0680899L1201.01 -3.74611L1202.42 -9.2163L1199.75 -10.6365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.76 -1.62351L1189 1.72901L1185.87 6.30485L1188.25 7.91863L1193.93 4.91936L1196.29 -0.0692432L1193.76 -1.62351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.96 0.228828L1181.87 3.22639L1177.91 7.2965L1179.85 8.84135L1185.87 6.30514L1188.99 1.72888L1186.96 0.228828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.91 7.29676L1164.7 11.4082L1166.59 12.7361L1174.68 11.9116L1179.85 8.84161L1177.91 7.29676Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.68 11.9113L1159.84 14.2773L1162.18 15.5825L1171.23 15.6563L1176.99 13.4708L1174.68 11.9113Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.68 46.12L1005 49.9832L999.956 54.8076L1002.02 55.3006L1007.55 50.6302L1010.77 45.6761L1008.68 46.12Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M992.706 57.8673L994.521 58.6095L999.951 54.8053L1004.99 49.9818L992.706 57.8673Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M999.956 54.8061L994.525 58.6103L990.939 63.1209L992.976 64.5857L998.626 60.5887L1002.02 55.2991L999.956 54.8061Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M990.938 63.1222L985.321 66.1184L981.538 70.7352L983.535 73.1145L989.359 69.9979L992.974 64.5872L990.938 63.1222Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M981.538 70.7351L975.706 72.8073L971.676 77.3078L973.601 80.4463L979.634 78.3777L983.535 73.1144L981.538 70.7351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M973.827 70.1254L967.935 71.1723L963.756 74.9909L965.611 78.3848L971.674 77.3067L975.704 72.8062L973.827 70.1254Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M971.675 77.307L965.612 78.3851L961.283 82.4958L963.087 86.1398L969.348 85.2367L973.6 80.4455L971.675 77.307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M963.756 74.9906L957.64 75.219L952.194 79.2351L953.89 83.0129L961.283 82.4949L965.612 78.3843L963.756 74.9906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M961.281 82.496L953.889 83.0138L948.179 87.8737L949.67 91.7252L957.187 90.5477L963.086 86.1398L961.281 82.496Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M952.199 79.2353L945.105 80.2083L940.371 85.4273L941.809 89.2855L948.184 87.8733L953.895 83.0129L952.199 79.2353Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M948.18 87.8725L941.805 89.2851L937.624 94.9305L938.915 98.8225L944.538 97.055L949.671 91.7241L948.18 87.8725Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M940.366 85.428L934.896 87.2513L931.412 93.2195L932.746 97.0182L937.622 94.9315L941.804 89.2862L940.366 85.428Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M937.627 94.9315L932.751 97.0181L929.745 103.201L930.975 107.008L935.232 104.738L938.919 98.8235L937.627 94.9315Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M929.743 103.201L925.888 105.836L923.704 112.32L924.973 115.953L928.353 113.291L930.974 107.009L929.743 103.201Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M924.538 102.203L920.939 105.28L918.974 111.955L920.421 115.35L923.704 112.319L925.888 105.835L924.538 102.203Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M918.969 111.953L915.68 115.381L913.965 122.024L915.551 125.145L918.69 121.903L920.416 115.348L918.969 111.953Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M918.69 121.904L915.552 125.146L913.9 131.544L915.397 134.706L918.4 131.716L920.061 125.31L918.69 121.904Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M913.905 131.546L910.503 134.78L908.52 140.797L910.127 143.737L913.595 140.879L915.401 134.708L913.905 131.546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.75 -10.6365L1195.79 -6.73646L1193.76 -1.62235L1196.29 -0.0680899L1201.01 -3.74611L1202.42 -9.2163L1199.75 -10.6365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M981.538 70.7351L975.706 72.8073L971.676 77.3078L973.601 80.4463L979.634 78.3777L983.535 73.1144L981.538 70.7351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M963.756 74.9906L957.64 75.219L952.194 79.2351L953.89 83.0129L961.283 82.4949L965.612 78.3843L963.756 74.9906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M952.199 79.2353L945.105 80.2083L940.371 85.4273L941.809 89.2855L948.184 87.8733L953.895 83.0129L952.199 79.2353Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.32 -6.10418L1204.35 -2.12878L1202.77 3.25535L1206.97 5.01885L1212.68 1.18467L1213.81 -4.42433L1209.32 -6.10418Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.01 -3.74809L1196.29 -0.0700762L1193.92 4.91852L1197.04 6.60668L1202.77 3.25566L1204.35 -2.12889L1201.01 -3.74809Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.93 4.9206L1188.25 7.91987L1184.5 12.0588L1187.42 13.7392L1194.29 11.2955L1197.04 6.60875L1193.93 4.9206Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.29 11.2933L1187.42 13.737L1182.88 16.8642L1186.67 18.7375L1194.81 17.1512L1198.17 13.0588L1194.29 11.2933Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.5 12.0573L1176.99 13.4707L1171.23 15.6562L1174.2 17.3089L1182.88 16.865L1187.42 13.7378L1184.5 12.0573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.23 15.6566L1155.2 16.3027L1158.27 17.7316L1168.22 18.7174L1174.19 17.3089L1171.23 15.6566Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.22 18.7176L1151.39 17.8223L1155.45 19.6221L1167.27 20.9938L1172.13 20.6412L1168.22 18.7176Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.56 21.8881L1024.87 30.8562L1027.63 30.0631L1033.7 25.0356L1036.59 20.7409L1033.56 21.8881Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.7 25.0356L1027.63 30.0631L1024.69 35.106L1027.95 35.6495L1034.42 31.1982L1037.32 25.2948L1033.7 25.0356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.87 30.8573L1016.25 40.5734L1018.82 40.3716L1024.69 35.1069L1027.63 30.0642L1024.87 30.8573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.69 35.1074L1018.82 40.3723L1015.77 46.0198L1018.73 47.0416L1025.05 42.2683L1027.95 35.6511L1024.69 35.1074Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.24 40.5753L1010.77 45.6766L1007.54 50.6306L1009.97 51.1781L1015.77 46.0218L1018.82 40.3738L1016.24 40.5753Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.77 46.0202L1009.97 51.177L1006.74 57.2351L1009.44 58.8506L1015.7 54.0642L1018.73 47.042L1015.77 46.0202Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.74 57.235L1000.92 61.9633L997.447 68.1789L999.887 70.417L1006.16 65.9496L1009.44 58.8504L1006.74 57.235Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M998.628 60.5888L992.978 64.5859L989.363 69.9965L991.532 72.1866L997.451 68.1785L1000.93 61.9635L998.628 60.5888Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M997.446 68.1774L991.527 72.1857L987.724 78.2438L989.894 81.0401L996.256 77.2459L999.885 70.4157L997.446 68.1774Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M989.36 69.9977L983.536 73.1145L979.634 78.3777L981.65 81.2753L987.727 78.2459L991.53 72.1877L989.36 69.9977Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M987.729 78.2439L981.652 81.2729L977.448 86.8001L979.319 89.9878L985.823 87.2383L989.899 81.04L987.729 78.2439Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M977.446 86.7983L971.173 88.6299L966.494 93.194L968.024 96.5056L974.715 95.1806L979.318 89.9864L977.446 86.7983Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M969.35 85.2371L963.089 86.1402L957.19 90.5481L958.715 94.2018L966.495 93.1973L971.173 88.6339L969.35 85.2371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M966.496 93.197L958.717 94.2015L952.352 99.2428L953.454 102.814L961.621 101.126L968.026 96.5087L966.496 93.197Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M952.347 99.2414L945.743 100.889L941.117 106.552L941.93 110.323L948.215 108.355L953.449 102.813L952.347 99.2414Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M944.539 97.0548L938.917 98.8224L935.229 104.737L936.272 108.608L941.12 106.552L945.746 100.889L944.539 97.0548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M941.119 106.553L936.271 108.61L932.975 114.698L933.635 118.541L938.392 116.298L941.931 110.324L941.119 106.553Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M932.974 114.697L929.349 117.09L926.972 123.422L927.578 127.247L931.186 124.767L933.634 118.54L932.974 114.697Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M928.353 113.292L924.973 115.954L923.033 122.399L924.068 126.057L926.975 123.424L929.352 117.093L928.353 113.292Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M926.978 123.422L924.071 126.054L922.193 132.453L922.805 136.209L925.679 133.57L927.584 127.248L926.978 123.422Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M923.036 122.398L920.067 125.31L918.406 131.716L919.52 135.197L922.192 132.454L924.07 126.055L923.036 122.398Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M922.189 132.454L919.518 135.197L917.696 141.495L918.337 145.168L920.937 142.492L922.801 136.211L922.189 132.454Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M917.696 141.494L914.792 144.185L912.561 150.219L913.215 153.838L916.045 151.292L918.338 145.168L917.696 141.494Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.88 -8.81104L1213.81 -4.42403L1212.68 1.18498L1215.96 1.87481L1220.74 -3.08805L1222.43 -8.22863L1218.88 -8.81104Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.74 -3.08692L1215.95 1.87552L1213.41 6.55307L1215.22 6.32596L1223.03 -3.69828L1221.96 -3.30641L1220.74 -3.08692Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.68 1.18639L1206.97 5.02057L1205.1 10.1404L1207.6 10.1046L1213.41 6.55377L1215.95 1.87623L1212.68 1.18639Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.73 14.7591L1108.4 11.8477L1111.26 13.7113L1128.23 15.9795L1125.73 14.7591Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.39 11.8483L1097.08 9.93204L1092.15 10.2285L1095.34 12.7868L1104.6 14.3282L1111.26 13.7096L1108.39 11.8483Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.15 10.2311L1082.89 9.03908L1077.52 10.8027L1081 14.0956L1089.6 14.8409L1095.35 12.787L1092.15 10.2311Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.39 7.46118L1070.2 7.24529L1065.54 8.77734L1069.15 10.7503L1077.52 10.8012L1082.89 9.03757L1079.39 7.46118Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.52 10.8029L1069.15 10.752L1064.97 14.4764L1068.67 18.5378L1076.36 18.0499L1081 14.0958L1077.52 10.8029Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.54 8.77812L1057.52 10.1287L1054.1 13.6212L1057.79 16.0258L1064.97 14.4755L1069.15 10.7511L1065.54 8.77812Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.97 14.4769L1057.78 16.0271L1054.72 21.7299L1058.76 26.3157L1065.45 24.7471L1068.67 18.5382L1064.97 14.4769Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.09 13.6215L1047.05 16.5681L1044.01 21.4594L1047.86 24.2721L1054.72 21.7288L1057.78 16.026L1054.09 13.6215Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.72 21.7294L1047.87 24.2722L1045.15 31.0914L1049.52 35.976L1056.29 33.7171L1058.76 26.3152L1054.72 21.7294Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.02 21.4609L1037.32 25.2967L1034.42 31.2001L1038.34 34.2984L1045.14 31.0923L1047.87 24.2736L1044.02 21.4609Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.41 31.1997L1027.95 35.6511L1025.05 42.268L1028.96 45.5619L1035.79 41.9123L1038.33 34.298L1034.41 31.1997Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.8 41.9134L1028.96 45.5624L1026.47 53.653L1031.28 58.8492L1038.39 55.8009L1040.43 46.9932L1035.8 41.9134Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.46 53.6508L1019.54 57.4901L1016.96 65.7353L1021.9 71.0035L1029.27 67.9136L1031.28 58.8467L1026.46 53.6508Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.7 54.0633L1009.44 58.8496L1006.17 65.949L1009.88 69.4816L1016.96 65.7361L1019.54 57.491L1015.7 54.0633Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.96 65.7371L1009.88 69.4824L1007.1 77.558L1012.12 82.8851L1019.8 80.0306L1021.91 71.0057L1016.96 65.7371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.16 65.948L999.884 70.4154L996.256 77.2455L999.798 80.8869L1007.1 77.5558L1009.87 69.4808L1006.16 65.948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.1 77.5583L999.803 80.8897L996.724 88.4679L1001.78 93.8713L1009.83 91.5648L1012.12 82.885L1007.1 77.5583Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M996.724 88.4678L989.157 91.0298L985.692 97.787L990.744 103.322L999.201 101.905L1001.78 93.8712L996.724 88.4678Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M985.819 87.2382L979.315 89.9877L974.711 95.1824L977.807 99.1948L985.688 97.786L989.153 91.0277L985.819 87.2382Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M985.689 97.7855L977.808 99.1952L973.889 104.82L978.91 110.573L987.809 110.413L990.742 103.32L985.689 97.7855Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M974.717 95.1833L968.027 96.5074L961.622 101.125L964.698 105.46L973.894 104.82L977.813 99.1953L974.717 95.1833Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M961.62 101.125L953.452 102.814L948.218 108.356L951.472 112.853L959.737 111.681L964.696 105.46L961.62 101.125Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M959.738 111.681L951.472 112.854L948.032 119.285L952.519 124.905L960.988 124.333L964.719 117.513L959.738 111.681Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M948.219 108.356L941.933 110.323L938.394 116.297L941.372 120.734L948.032 119.285L951.471 112.854L948.219 108.356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M948.033 119.284L941.374 120.733L938.844 127.218L942.456 132.423L949.504 131.577L952.52 124.905L948.033 119.284Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M938.841 127.217L933.57 128.981L931.418 135.39L933.898 140.041L939.677 138.847L942.452 132.422L938.841 127.217Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M931.189 124.768L927.581 127.248L925.677 133.57L927.268 137.47L931.421 135.391L933.573 128.983L931.189 124.768Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M931.421 135.392L927.268 137.471L925.026 143.702L926.241 147.734L930.962 146.155L933.9 140.044L931.421 135.392Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M925.028 143.701L921.661 146.053L918.925 152.033L918.867 155.453L922.804 153.494L926.243 147.733L925.028 143.701Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M920.937 142.492L918.337 145.168L916.045 151.293L915.948 154.569L918.923 152.032L921.659 146.052L920.937 142.492Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M918.924 152.033L915.949 154.569L911.165 163.157L914.652 160.868L918.867 155.453L918.924 152.033Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.26 20.1018L1137.99 17.8633L1139.91 19.0296L1156.72 20.4925L1155.26 20.1018Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.99 17.8613L1120.91 15.6328L1123.3 17.657L1132.58 19.1442L1139.91 19.0272L1137.99 17.8613Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.58 19.1457L1123.31 17.6589L1116.54 18.6484L1119.09 21.5429L1127.92 22.3822L1134.61 21.0055L1132.58 19.1457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.91 15.6316L1111.26 13.71L1104.61 14.3262L1107.46 17.2728L1116.54 18.6458L1123.31 17.6562L1120.91 15.6316Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.54 18.6471L1107.46 17.2742L1101.5 19.6035L1104.55 23.5934L1113.08 24.1176L1119.09 21.5416L1116.54 18.6471Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.5 19.6042L1092.87 18.7561L1087.91 22.8865L1091.39 28.0289L1099.41 27.8334L1104.54 23.5965L1101.5 19.6042Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.6 14.8369L1081 14.0941L1076.36 18.0458L1079.98 22.9792L1087.92 22.8856L1092.87 18.7547L1089.6 14.8369Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.92 22.8868L1079.98 22.9804L1076.2 29.3948L1080.03 35.7443L1087.31 34.4025L1091.39 28.0291L1087.92 22.8868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.2 29.3948L1069.41 30.6092L1067.21 38.3519L1071.56 45.3387L1077.49 44.1591L1080.03 35.7443L1076.2 29.3948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.45 24.7448L1058.76 26.314L1056.29 33.7153L1060.77 39.9129L1067.21 38.35L1069.4 30.6075L1065.45 24.7448Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.29 33.7164L1049.52 35.9753L1047.34 44.2302L1052.25 50.6413L1058.92 48.5561L1060.77 39.9137L1056.29 33.7164Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.92 48.556L1052.25 50.6412L1050.6 59.9055L1055.93 67.3107L1062.45 65.2636L1063.79 55.8072L1058.92 48.556Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.33 44.2306L1040.42 46.9913L1038.39 55.799L1043.66 62.3356L1050.6 59.906L1052.25 50.6417L1047.33 44.2306Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.39 55.8006L1031.28 58.8482L1029.27 67.9152L1034.84 74.5156L1042.1 71.9455L1043.67 62.3372L1038.39 55.8006Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.1 71.9431L1034.84 74.5128L1033.24 84.1866L1039.25 91.6929L1046.52 89.4515L1047.8 79.4234L1042.1 71.9431Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.25 84.1869L1025.61 86.6581L1023.88 96.1205L1030.15 103.633L1037.85 101.622L1039.26 91.6928L1033.25 84.1869Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.8 80.0287L1012.12 82.8831L1009.82 91.5636L1015.82 98.2249L1023.88 96.1221L1025.61 86.6598L1019.8 80.0287Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.88 96.1214L1015.83 98.2246L1013.87 107.196L1020.36 114.731L1028.53 113.21L1030.15 103.634L1023.88 96.1214Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.87 107.197L1005.35 108.63L1003.09 116.839L1009.76 124.447L1018.44 123.704L1020.36 114.732L1013.87 107.197Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M999.2 101.904L990.743 103.32L987.81 110.414L994.078 117.273L1003.09 116.839L1005.35 108.63L999.2 101.904Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M987.806 110.412L978.908 110.572L974.696 117.102L980.976 124.095L991.448 124.456L994.075 117.272L987.806 110.412Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M991.451 124.457L980.98 124.097L976.797 131.27L983.284 138.893L994.391 139.588L998.263 132.227L991.451 124.457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M974.702 117.104L964.72 117.514L960.989 124.334L966.735 131.065L976.8 131.272L980.983 124.098L974.702 117.104Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M960.985 124.333L952.517 124.905L949.5 131.577L954.259 137.795L963.057 137.877L966.731 131.064L960.985 124.333Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M963.054 137.876L954.256 137.794L950.682 144.179L954.956 150.562L964.131 151.31L968.63 144.992L963.054 137.876Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M950.685 144.179L943.133 144.372L939.318 150.297L942.043 155.801L950.14 156.268L954.96 150.562L950.685 144.179Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M939.682 138.848L933.902 140.042L930.965 146.153L932.926 150.878L939.321 150.297L943.136 144.372L939.682 138.848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M939.32 150.296L932.924 150.877L928.599 156.346L929.662 160.905L936.704 160.939L942.045 155.8L939.32 150.296Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M930.958 146.151L926.237 147.73L922.798 153.491L923.206 157.387L928.595 156.345L932.919 150.876L930.958 146.151Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M928.596 156.344L923.207 157.387L918.167 162.445L917.584 166.073L923.664 165.561L929.659 160.903L928.596 156.344Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M918.164 162.446L913.567 163.982L907.671 168.713L905.587 171.508L910.863 170.383L917.581 166.075L918.164 162.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.3 17.9752L1174.75 20.4434L1189.92 17.075L1189.3 17.9752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.75 20.4426L1159.27 21.4102L1160.65 22.0081L1175.7 20.2193L1174.75 20.4426Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.27 21.4117L1143.48 21.7656L1145.34 23.3026L1153.89 23.2348L1160.65 22.0093L1159.27 21.4117Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.88 23.2338L1145.34 23.302L1138.88 25.0742L1141.32 27.2003L1149.82 26.6284L1155.9 24.4634L1153.88 23.2338Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.47 21.7647L1134.61 21.0042L1127.91 22.3809L1130.3 24.9461L1138.88 25.0743L1145.34 23.3013L1143.47 21.7647Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.88 25.0726L1130.29 24.9447L1124.38 27.7324L1127.25 30.8395L1135.63 30.14L1141.32 27.1991L1138.88 25.0726Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.91 22.3805L1119.09 21.5411L1113.08 24.1191L1115.96 27.7857L1124.37 27.733L1130.29 24.9457L1127.91 22.3805Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.38 27.7345L1115.96 27.7872L1110.78 32.0447L1114.06 36.2147L1122.14 35.0156L1127.25 30.8415L1124.38 27.7345Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.78 32.0448L1102.75 32.668L1098.47 38.8644L1102.11 44.1645L1109.69 42.075L1114.06 36.2148L1110.78 32.0448Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.41 27.8331L1091.39 28.0285L1087.3 34.4023L1091.03 40.469L1098.47 38.8644L1102.75 32.668L1099.41 27.8331Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.47 38.8642L1091.03 40.4707L1087.79 49.1023L1091.72 55.6046L1098.61 52.1948L1102.11 44.1639L1098.47 38.8642Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.79 49.0999L1083.83 50.8336L1081.58 51.3475L1080.3 60.0224L1084.59 67.1927L1089.75 65.2142L1091.72 55.6023L1087.79 49.0999Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.49 44.1573L1071.56 45.3365L1070 54.1214L1074.63 61.6486L1080.3 60.0234L1081.59 51.3465L1077.49 44.1573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.3 60.0237L1074.63 61.6493L1073.5 71.0335L1078.15 78.4936L1083.59 76.2395L1084.6 67.1943L1080.3 60.0237Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M1070 54.1226L1063.8 55.8067L1062.45 65.2635L1067.53 72.9991L1073.51 71.0339L1074.64 61.6498L1070 54.1226Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.51 71.0351L1067.53 72.9999L1066.44 82.8529L1071.34 90.4801L1077.07 88.0433L1078.15 78.4953L1073.51 71.0351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.45 65.2632L1055.93 67.3103L1054.67 77.1805L1060.12 85.0273L1066.43 82.8515L1067.53 72.9988L1062.45 65.2632Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.43 82.8526L1060.12 85.0284L1058.95 95.1115L1064.03 102.819L1070.07 100.315L1071.34 90.4801L1066.43 82.8526Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.67 77.1813L1047.8 79.425L1046.52 89.453L1052.26 97.3416L1058.95 95.1121L1060.12 85.0281L1054.67 77.1813Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 95.1119L1052.26 97.3415L1050.92 107.42L1056.11 115.149L1062.49 112.721L1064.03 102.82L1058.95 95.1119Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 107.419L1043.82 109.516L1042.22 119.357L1047.46 127.087L1054.2 124.91L1056.11 115.149L1050.92 107.419Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.85 101.622L1030.15 103.633L1028.53 113.209L1034.68 121.103L1042.22 119.356L1043.82 109.515L1037.85 101.622Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.22 119.357L1034.68 121.104L1032.74 130.482L1037.99 138.228L1045.11 136.505L1047.46 127.087L1042.22 119.357Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.74 130.482L1024.73 131.632L1022.38 140.331L1027.6 148.146L1035.12 147.11L1037.99 138.228L1032.74 130.482Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.44 123.704L1009.76 124.447L1007.47 132.576L1013.88 140.611L1022.38 140.332L1024.73 131.633L1018.44 123.704Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.38 140.33L1013.88 140.611L1011.07 148.427L1016.23 156.408L1024.17 156.315L1027.6 148.146L1022.38 140.33Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.48 132.574L998.266 132.226L994.393 139.587L1000.79 147.71L1011.07 148.425L1013.88 140.609L1007.48 132.574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M994.394 139.589L983.287 138.893L978.839 145.831L984.616 153.567L995.513 154.786L1000.79 147.712L994.394 139.589Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M995.51 154.786L984.613 153.568L979.119 159.827L983.486 167.257L994.052 168.915L1000.54 162.678L995.51 154.786Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M978.837 145.83L968.633 144.992L964.134 151.31L968.812 158.387L979.12 159.827L984.613 153.566L978.837 145.83Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M979.118 159.826L968.81 158.387L962.909 163.875L966.201 170.602L976.49 172.559L983.484 167.256L979.118 159.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M962.91 163.874L953.397 162.493L946.964 167.297L948.929 173.174L958.657 175.101L966.201 170.602L962.91 163.874Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M950.137 156.267L942.041 155.8L936.7 160.938L938.366 166.208L946.964 167.296L953.397 162.493L950.137 156.267Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M946.962 167.297L938.365 166.208L931.34 170.462L931.877 175.43L940.854 177.048L948.927 173.174L946.962 167.297Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M931.343 170.462L923.7 169.859L916.087 173.735L915.23 177.827L923.354 178.903L931.88 175.43L931.343 170.462Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M923.665 165.564L917.585 166.075L910.867 170.383L909.366 173.768L916.088 173.735L923.701 169.859L923.665 165.564Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M916.085 173.735L909.363 173.768L901.221 177.487L899.13 180.817L906.377 181.163L915.227 177.827L916.085 173.735Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.51 71.0351L1067.53 72.9999L1066.44 82.8529L1071.34 90.4801L1077.07 88.0433L1078.15 78.4953L1073.51 71.0351Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.43 82.8526L1060.12 85.0284L1058.95 95.1115L1064.03 102.819L1070.07 100.315L1071.34 90.4801L1066.43 82.8526Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M979.118 159.826L968.81 158.387L962.909 163.875L966.201 170.602L976.49 172.559L983.484 167.256L979.118 159.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M962.91 163.874L953.397 162.493L946.964 167.297L948.929 173.174L958.657 175.101L966.201 170.602L962.91 163.874Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.54 -13.1409L1231.85 -7.89432L1227.85 -2.48681L1232.45 -1.17829L1241.3 -5.41841L1244.4 -11.9632L1239.54 -13.1409Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.78 -7.74357L1217.33 2.02379L1220.04 1.98441L1227.85 -2.48857L1231.84 -7.89651L1228.78 -7.74357Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.85 -2.48902L1220.05 1.98397L1215.62 6.59452L1220.07 8.01706L1229.07 4.66432L1232.45 -1.1805L1227.85 -2.48902Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.61 6.59447L1207.6 10.1034L1203.03 13.8351L1207.2 15.1824L1216.45 12.9701L1220.07 8.01461L1215.61 6.59447Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.1 10.1405L1192.5 16.1504L1194.89 16.404L1203.03 13.8369L1207.6 10.1047L1205.1 10.1405Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.5 16.1488L1178.72 20.4375L1181.16 21.0519L1189.65 19.2991L1194.88 16.4029L1192.5 16.1488Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.65 19.3004L1181.16 21.0536L1175.62 23.541L1179.37 24.9476L1188.94 24.0359L1193.54 20.599L1189.65 19.3004Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.72 20.4388L1164.34 23.6621L1166.94 24.7866L1175.62 23.5405L1181.16 21.0532L1178.72 20.4388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.62 23.5402L1166.94 24.7863L1161.38 27.3223L1165.1 28.9701L1174.6 28.2053L1179.37 24.9468L1175.62 23.5402Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.34 23.6617L1155.91 24.4639L1149.83 26.6289L1152.68 28.3859L1161.37 27.3218L1166.94 24.7858L1164.34 23.6617Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.83 26.629L1141.33 27.2008L1135.63 30.1445L1138.76 32.6366L1147.32 31.4161L1152.68 28.3864L1149.83 26.629Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.32 31.4166L1138.76 32.6371L1133.81 36.6055L1137.64 39.064L1146.58 37.4994L1151.08 33.4208L1147.32 31.4166Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.81 36.6067L1125.55 38.3324L1121.16 43.6864L1125.06 46.6735L1133.49 44.1258L1137.64 39.0652L1133.81 36.6067Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.14 35.0159L1114.06 36.215L1109.69 42.0751L1113.36 46.2885L1121.16 43.6849L1125.55 38.331L1122.14 35.0159Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.16 43.6862L1113.36 46.289L1109.66 53.4861L1113.6 57.0672L1121.38 53.1057L1125.06 46.6733L1121.16 43.6862Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.66 53.4851L1102.48 57.374L1099.59 66.9105L1103.49 71.1461L1110.44 65.2838L1113.6 57.0662L1109.66 53.4851Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.61 52.194L1091.72 55.6038L1089.75 65.2153L1093.76 71.3178L1099.58 66.9094L1102.47 57.3725L1098.61 52.194Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.58 66.9105L1093.76 71.3193L1092.78 79.7581L1096.55 84.5441L1101.46 80.2866L1103.48 71.1461L1099.58 66.9105Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.78 79.7574L1087.75 82.7371L1086.53 91.6952L1090.03 96.8415L1094.88 92.3526L1096.55 84.5434L1092.78 79.7574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.59 76.2405L1078.15 78.4954L1077.07 88.043L1081.28 94.7929L1086.53 91.696L1087.75 82.737L1083.59 76.2405Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.53 91.6946L1081.28 94.7923L1079.71 104.067L1082.85 109.437L1087.71 104.902L1090.03 96.8408L1086.53 91.6946Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.07 88.0448L1071.34 90.4835L1070.07 100.317L1074.25 107.204L1079.71 104.069L1081.28 94.7946L1077.07 88.0448Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.07 100.316L1064.03 102.82L1062.49 112.721L1066.54 119.672L1072.22 116.601L1074.25 107.203L1070.07 100.316Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.22 116.602L1066.54 119.673L1063.98 129.004L1066.14 134.555L1071.18 130.434L1074.91 122.094L1072.22 116.602Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.98 129.003L1058.07 131.879L1054.9 140.966L1056.48 146.55L1061.65 142.862L1066.15 134.554L1063.98 129.003Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.2 124.911L1047.46 127.088L1045.11 136.505L1048.74 143.49L1054.9 140.967L1058.07 131.88L1054.2 124.911Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.9 140.967L1048.74 143.49L1044.9 152.163L1045.85 157.798L1051.19 154.673L1056.48 146.551L1054.9 140.967Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.9 152.164L1038.48 154.146L1033.92 162.254L1034.22 168.001L1039.72 165.551L1045.85 157.798L1044.9 152.164Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.12 147.11L1027.6 148.146L1024.17 156.315L1027.23 163.482L1033.92 162.255L1038.48 154.146L1035.12 147.11Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.18 156.316L1016.24 156.409L1011 163.666L1013.97 171.03L1021.92 170.894L1027.23 163.483L1024.18 156.316Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.91 170.893L1013.96 171.03L1006.56 177.312L1006.77 183.6L1013.63 183.244L1021.53 176.86L1021.91 170.893Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M1011 163.665L1000.54 162.678L994.05 168.914L997.049 176.156L1006.56 177.312L1013.96 171.028L1011 163.665Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M994.05 168.915L983.485 167.257L976.491 172.56L979.003 179.385L989.029 181.342L997.049 176.156L994.05 168.915Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M989.031 181.341L979.003 179.383L970.408 183.644L970.905 189.72L980.014 191.761L989.614 187.649L989.031 181.341Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M970.406 183.643L960.337 181.31L951.265 184.872L951.389 190.559L960.852 193.044L970.904 189.719L970.406 183.643Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M958.656 175.101L948.927 173.173L940.855 177.048L941.515 182.54L951.264 184.873L960.336 181.312L958.656 175.101Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M940.859 177.049L931.882 175.431L923.355 178.904L922.959 183.669L932.127 185.675L941.519 182.541L940.859 177.049Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M932.123 185.676L922.955 183.67L913.439 186.689L912.565 191.522L921.632 193.661L931.742 190.918L932.123 185.676Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M923.353 178.903L915.23 177.828L906.379 181.165L905.019 185.282L913.441 186.688L922.956 183.669L923.353 178.903Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M913.441 186.686L905.019 185.28L895.621 188.537L894.393 193.088L902.876 194.557L912.567 191.519L913.441 186.686Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.52 -17.5444L1259.74 -13.8464L1256.95 -6.81057L1264.09 -3.29033L1274.71 -5.93436L1277.4 -13.0945L1269.52 -17.5444Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.22 -16.7259L1244.41 -11.9638L1241.31 -5.41946L1247.4 -3.05037L1256.96 -6.81001L1259.74 -13.8458L1253.22 -16.7259Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.31 -5.41877L1232.45 -1.17822L1229.07 4.66702L1234.9 6.82479L1244.29 3.287L1247.4 -3.04925L1241.31 -5.41877Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.29 3.28574L1234.89 6.82353L1231.56 12.4838L1237.7 14.9627L1247.51 11.9719L1250.82 6.08843L1244.29 3.28574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.56 12.4828L1222.2 15.3788L1218.43 20.111L1224.46 22.6853L1234.28 20.4138L1237.7 14.9617L1231.56 12.4828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.46 12.9708L1207.2 15.1835L1203.02 19.2013L1208.63 21.8609L1218.43 20.1117L1222.2 15.3791L1216.46 12.9708Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.01 19.2022L1193.53 20.5987L1188.93 24.0376L1194.5 26.9553L1204.53 25.9061L1208.62 21.8643L1203.01 19.2022Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.54 25.9068L1194.51 26.956L1190.32 30.6523L1196.57 33.4649L1206.83 32.4868L1210.64 28.6041L1204.54 25.9068Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.33 30.6499L1180.2 31.3537L1176.1 35.0409L1182.53 37.9352L1192.85 37.0923L1196.57 33.463L1190.33 30.6499Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.6 28.2061L1165.1 28.9709L1160.38 32.4456L1166.01 35.7798L1176.1 35.0428L1180.2 31.356L1174.6 28.2061Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.1 35.0436L1166.01 35.7806L1162.13 39.7859L1168.73 42.6963L1179.02 41.6262L1182.52 37.9379L1176.1 35.0436Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.37 32.4437L1151.08 33.4192L1146.58 37.4979L1152.22 40.9408L1162.13 39.7832L1166.01 35.7779L1160.37 32.4437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.13 39.784L1152.22 40.9416L1148.68 45.5835L1155.42 48.418L1165.54 46.7438L1168.73 42.694L1162.13 39.784Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.58 37.4979L1137.64 39.0625L1133.49 44.1232L1139.09 47.5755L1148.68 45.5827L1152.22 40.9409L1146.58 37.4979Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.68 45.5838L1139.09 47.5766L1135.95 53.1691L1142.74 55.8115L1152.59 53.1244L1155.42 48.4179L1148.68 45.5838Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.95 53.1686L1126.82 56.4382L1124.13 63.3029L1130.86 65.6009L1140.32 61.4608L1142.74 55.8114L1135.95 53.1686Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.37 53.1028L1113.59 57.0643L1110.44 65.2819L1115.61 68.3332L1124.12 63.3015L1126.82 56.4373L1121.37 53.1028Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.12 63.3047L1115.61 68.3363L1113.38 76.8129L1119.9 78.5743L1128.84 72.4941L1130.85 65.6027L1124.12 63.3047Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.38 76.8111L1106.05 82.8545L1104.78 89.5757L1110.5 91.0933L1118.4 85.9368L1119.9 78.573L1113.38 76.8111Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.46 80.2869L1096.55 84.5444L1094.89 92.3537L1098.46 94.6734L1104.78 89.5766L1106.05 82.8554L1101.46 80.2869Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.78 89.5754L1098.46 94.6722L1096.58 101.996L1101.51 103.886L1108.98 98.0013L1110.51 91.0934L1104.78 89.5754Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.58 101.996L1090.47 107.415L1088 115.363L1092.31 118.032L1099.59 111.907L1101.5 103.886L1096.58 101.996Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.71 104.901L1082.85 109.436L1079.84 117.683L1081.94 120.72L1088.01 115.362L1090.47 107.414L1087.71 104.901Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.01 115.363L1081.94 120.722L1078.89 129.252L1082.71 132.997L1089.97 127.086L1092.31 118.033L1088.01 115.363Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.83 117.684L1074.91 122.092L1071.17 130.432L1072.74 134.212L1078.88 129.251L1081.94 120.721L1079.83 117.684Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.88 129.251L1072.74 134.212L1069.06 143.206L1072.47 148.207L1079.89 142.925L1082.7 132.997L1078.88 129.251Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.06 143.207L1062.73 147.479L1058.39 156.74L1061.43 163.04L1069.11 158.767L1072.48 148.208L1069.06 143.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.65 142.863L1056.48 146.551L1051.19 154.674L1051.79 160.084L1058.39 156.74L1062.72 147.479L1061.65 142.863Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.39 156.74L1051.79 160.085L1046.73 169.332L1049.37 176.828L1057.41 173.893L1061.42 163.04L1058.39 156.74Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.73 169.33L1039.83 171.568L1033.99 180.434L1036.17 188.864L1044.62 187.534L1049.37 176.826L1046.73 169.33Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.72 165.551L1034.21 168.001L1027.21 175.173L1026.77 181.459L1033.99 180.435L1039.83 171.569L1039.72 165.551Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.99 180.434L1026.77 181.458L1020.07 189.491L1021.72 198.427L1030.58 198.893L1036.18 188.864L1033.99 180.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.21 175.172L1021.54 176.859L1013.63 183.243L1012.86 189.598L1020.07 189.492L1026.77 181.459L1027.21 175.172Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.07 189.49L1012.86 189.597L1005.65 196.826L1007.05 205.84L1015.81 207.582L1021.71 198.426L1020.07 189.49Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.63 183.241L1006.78 183.598L997.883 188.757L997.315 195.373L1005.65 196.826L1012.86 189.596L1013.63 183.241Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.65 196.826L997.315 195.373L988.769 200.97L989.818 209.632L999.771 213.094L1007.05 205.84L1005.65 196.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M997.88 188.756L989.613 187.648L980.013 191.759L979.463 198.267L988.766 200.97L997.312 195.373L997.88 188.756Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M988.771 200.971L979.466 198.269L969.965 202.526L970.521 210.508L981.067 214.935L989.819 209.633L988.771 200.971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M969.964 202.527L960.208 199.196L950.141 202.481L950.142 209.588L960.753 214.285L970.52 210.508L969.964 202.527Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M960.853 193.043L951.39 190.558L941.163 193.412L940.37 199.076L950.139 202.479L960.205 199.193L960.853 193.043Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M950.141 202.481L940.372 199.079L930.121 201.817L929.572 207.985L939.808 212.335L950.141 209.588L950.141 202.481Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M941.164 193.412L931.745 190.916L921.634 193.658L920.706 198.827L930.121 201.815L940.372 199.077L941.164 193.412Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M930.118 201.815L920.702 198.827L910.63 201.489L909.588 206.775L919.095 210.247L929.568 207.984L930.118 201.815Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M921.632 193.659L912.565 191.52L902.874 194.558L901.864 199.331L910.631 201.489L920.702 198.827L921.632 193.659Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M910.636 201.489L901.87 199.331L892.319 202.433L890.881 207.004L899.376 209.14L909.594 206.776L910.636 201.489Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.65 196.826L997.315 195.373L988.769 200.97L989.818 209.632L999.771 213.094L1007.05 205.84L1005.65 196.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M988.771 200.971L979.466 198.269L969.965 202.526L970.521 210.508L981.067 214.935L989.819 209.633L988.771 200.971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.44 -27.6596L1327.06 -27.2617L1325.58 -18.4559L1337.58 -9.86691L1352.17 -9.15554L1353.57 -18.1836L1340.44 -27.6596Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.58 -18.457L1312.54 -18.0181L1310.36 -10.1128L1321.14 -2.74343L1335.28 -2.05243L1337.58 -9.86801L1325.58 -18.457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.46 -15.378L1277.4 -13.0946L1274.71 -5.93408L1283.04 -1.14766L1295.02 -2.35123L1297.79 -9.3765L1288.46 -15.378Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.02 -2.3522L1283.04 -1.14822L1279.82 5.11577L1288.31 9.78797L1301.05 9.46139L1304.6 3.64986L1295.02 -2.3522Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.71 -5.9341L1264.09 -3.29007L1261.02 3.17557L1268.47 6.87093L1279.82 5.11629L1283.04 -1.14768L1274.71 -5.9341Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.82 5.11721L1268.47 6.87184L1264.99 12.5838L1272.56 16.1579L1284.47 15.0163L1288.31 9.78941L1279.82 5.11721Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.02 3.17584L1250.83 6.08855L1247.51 11.9721L1254.28 14.8884L1264.99 12.5836L1268.47 6.87361L1261.02 3.17584Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.99 12.5849L1254.28 14.8898L1250.73 20.3626L1257.63 23.2513L1268.68 21.2143L1272.56 16.1586L1264.99 12.5849Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.51 11.9707L1237.7 14.9614L1234.28 20.4135L1240.65 23.0501L1250.73 20.3594L1254.28 14.8866L1247.51 11.9707Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.28 20.4143L1224.46 22.6858L1220.73 27.1403L1227.18 29.8171L1237.24 27.9998L1240.64 23.0509L1234.28 20.4143Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.23 28.0012L1227.17 29.8185L1223.68 34.0121L1230.55 36.8037L1240.74 35.3972L1243.96 30.7807L1237.23 28.0012Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.73 27.1414L1210.64 28.6038L1206.83 32.4865L1213.46 35.2048L1223.69 34.0127L1227.17 29.8182L1220.73 27.1414Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.83 32.4857L1196.57 33.4642L1192.85 37.0936L1199.72 39.8324L1210.05 38.9452L1213.46 35.2039L1206.83 32.4857Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.06 38.9442L1199.72 39.831L1196.51 43.4155L1203.85 46.1796L1214.13 45.4241L1217.14 41.7411L1210.06 38.9442Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.51 43.4159L1186.15 44.3295L1183.21 48.0428L1190.81 50.7064L1201.06 49.802L1203.85 46.18L1196.51 43.4159Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.02 41.6242L1168.73 42.6939L1165.54 46.7437L1172.91 49.3382L1183.21 48.0421L1186.15 44.3287L1179.02 41.6242Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.21 48.0432L1172.91 49.339L1170.3 53.4541L1178.1 55.9227L1188.28 54.53L1190.81 50.7072L1183.21 48.0432Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.3 53.4554L1160.13 55.5029L1157.86 60.2899L1165.78 62.4381L1175.83 60.1934L1178.1 55.9239L1170.3 53.4554Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.59 53.1256L1142.74 55.8128L1140.32 61.4621L1147.93 63.4816L1157.86 60.2888L1160.13 55.5022L1152.59 53.1256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.86 60.2878L1147.93 63.4802L1145.99 69.2025L1153.91 70.8728L1163.75 67.3866L1165.78 62.436L1157.86 60.2878Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 69.2024L1136.4 73.9791L1134.75 80.9065L1142.52 81.8933L1152.06 76.7427L1153.91 70.8728L1146 69.2024Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.85 72.4914L1119.9 78.5717L1118.4 85.9355L1125.59 86.85L1134.75 80.9058L1136.4 73.9787L1128.85 72.4914Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.4 85.9365L1110.5 91.0935L1108.98 98.0013L1115.36 99.3027L1123.94 93.2218L1125.59 86.851L1118.4 85.9365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.94 93.2212L1115.36 99.3025L1113.57 107.273L1120.14 109.011L1128.94 101.921L1131.07 94.1875L1123.94 93.2212Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.98 98.0008L1101.5 103.885L1099.59 111.906L1105.39 114.069L1113.57 107.273L1115.36 99.3022L1108.98 98.0008Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.56 107.274L1105.38 114.07L1103.38 123.526L1109.59 126.476L1118.05 118.684L1120.14 109.012L1113.56 107.274Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.38 123.527L1095.35 130.481L1093.05 141.235L1099.04 145.734L1107.44 137.869L1109.59 126.477L1103.38 123.527Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.97 127.087L1082.7 132.999L1079.89 142.927L1084.95 147.816L1093.05 141.236L1095.35 130.482L1089.97 127.087Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.05 141.234L1084.95 147.814L1082.25 159.584L1088.09 165.855L1096.68 158.539L1099.03 145.733L1093.05 141.234Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.89 142.927L1072.47 148.208L1069.11 158.768L1073.9 165.285L1082.26 159.586L1084.95 147.816L1079.89 142.927Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.26 159.586L1073.9 165.285L1070.68 177.688L1076.39 185.815L1085.37 179.658L1088.09 165.857L1082.26 159.586Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.68 177.687L1061.94 182.026L1058.06 194.564L1063.6 204.469L1073.13 200.062L1076.39 185.813L1070.68 177.687Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.42 173.892L1049.38 176.826L1044.62 187.535L1048.83 197.113L1058.06 194.564L1061.94 182.027L1057.42 173.892Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.06 194.563L1048.83 197.112L1044.14 209.166L1049.44 220.587L1059.63 218.474L1063.6 204.468L1058.06 194.563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.62 187.533L1036.18 188.863L1030.58 198.891L1034.37 209.56L1044.14 209.165L1048.83 197.111L1044.62 187.533Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.14 209.165L1034.37 209.56L1028.73 220.403L1033.66 232.875L1044.56 233.524L1049.44 220.586L1044.14 209.165Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.73 220.404L1019.11 218.682L1013.07 227.67L1017.32 239.972L1028.32 243.682L1033.66 232.877L1028.73 220.404Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.81 207.584L1007.06 205.842L999.773 213.095L1002.48 223.765L1013.07 227.671L1019.11 218.683L1015.81 207.584Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.07 227.67L1002.48 223.765L994.448 230.155L997.755 241.6L1010.04 247.561L1017.32 239.972L1013.07 227.67Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M994.444 230.154L982.988 224.75L973.486 229.025L975.717 239.251L988.514 246.442L997.751 241.599L994.444 230.154Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M981.064 214.936L970.519 210.508L960.751 214.284L961.807 222.977L973.486 229.026L982.989 224.751L981.064 214.936Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M973.484 229.026L961.803 222.976L951.353 225.71L952.475 234.518L965.136 242.003L975.714 239.252L973.484 229.026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M951.356 225.711L939.986 219.779L929.086 221.602L929.143 228.948L941.141 235.907L952.479 234.519L951.356 225.711Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M939.808 212.333L929.572 207.982L919.099 210.246L918.455 216.45L929.087 221.599L939.987 219.776L939.808 212.333Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M929.087 221.602L918.457 216.453L907.564 218.03L906.655 224.002L917.58 229.729L929.145 228.949L929.087 221.602Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M907.561 218.029L898.006 214.234L887.536 216.255L885.793 221.049L895.333 224.946L906.652 224.001L907.561 218.029Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M969.35 85.2371L963.089 86.1402L957.19 90.5481L958.715 94.2018L966.495 93.1973L971.173 88.6339L969.35 85.2371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.59 53.1256L1142.74 55.8128L1140.32 61.4621L1147.93 63.4816L1157.86 60.2888L1160.13 55.5022L1152.59 53.1256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.68 177.687L1061.94 182.026L1058.06 194.564L1063.6 204.469L1073.13 200.062L1076.39 185.813L1070.68 177.687Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 -20.2319L1398.75 -18.5177L1398.66 -7.57284L1413.98 2.40368L1430.03 1.09358L1429.83 -10.6988L1413.9 -20.2319Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.37 -28.7843L1368.73 -28.1369L1368.36 -17.8958L1382.88 -7.68668L1398.66 -7.57377L1398.75 -18.5178L1383.37 -28.7843Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.66 -7.57408L1382.88 -7.6874L1381.48 1.58604L1395.8 11.2411L1412.53 12.0132L1413.98 2.40243L1398.66 -7.57408Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.36 -17.8953L1353.57 -18.1856L1352.17 -9.15761L1365.55 0.353243L1381.47 1.58642L1382.88 -7.6862L1368.36 -17.8953Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.47 1.58886L1365.55 0.353298L1363.02 8.02919L1376.11 16.7912L1392.95 18.803L1395.8 11.2415L1381.47 1.58886Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.18 -9.1558L1337.58 -9.86717L1335.28 -2.052L1347.37 6.31555L1363.02 8.03137L1365.56 0.354634L1352.18 -9.1558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.02 8.02972L1347.37 6.31432L1343.95 12.5887L1355.72 20.1068L1372.18 22.5887L1376.11 16.7921L1363.02 8.02972Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.28 -2.05193L1321.13 -2.74294L1318.11 3.96533L1328.89 10.946L1343.96 12.5891L1347.38 6.31562L1335.28 -2.05193Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.11 3.96488L1304.6 3.65008L1301.06 9.45962L1310.59 15.0119L1324.85 16.1272L1328.88 10.9456L1318.11 3.96488Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.85 16.1276L1310.59 15.0124L1306.23 19.5215L1315.54 24.3409L1330.29 25.8878L1335.32 22.2634L1324.85 16.1276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.23 19.518L1292.93 19.2862L1288.55 23.6304L1296.9 27.4001L1310.5 27.7624L1315.53 24.3394L1306.23 19.518Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.47 15.0145L1272.56 16.1561L1268.68 21.2118L1276.29 24.5414L1288.55 23.6332L1292.93 19.2866L1284.47 15.0145Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.55 23.6304L1276.28 24.5414L1272.19 29.3401L1279.85 32.5076L1292.22 31.3318L1296.9 27.4L1288.55 23.6304Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.68 21.2119L1257.63 23.2488L1254.06 28.6056L1261.13 31.5392L1272.19 29.3403L1276.29 24.542L1268.68 21.2119Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.19 29.3411L1261.13 31.5392L1258.07 36.6798L1265.43 39.842L1276.05 37.7578L1279.86 32.5085L1272.19 29.3411Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.06 28.6052L1243.96 30.7788L1240.74 35.3949L1247.81 38.3622L1258.07 36.6791L1261.13 31.5388L1254.06 28.6052Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.07 36.6797L1247.81 38.3629L1244.77 42.7872L1252.03 46.0665L1262.4 44.8123L1265.43 39.8419L1258.07 36.6797Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.74 35.3967L1230.55 36.8053L1227.39 40.8139L1234.56 43.8178L1244.77 42.7881L1247.81 38.3636L1240.74 35.3967Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.39 40.8141L1217.14 41.7426L1214.13 45.4256L1221.47 48.4405L1231.63 47.787L1234.56 43.8181L1227.39 40.8141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.63 47.7858L1221.47 48.4397L1218.7 52.2078L1225.98 55.6614L1235.97 55.3158L1238.89 51.1725L1231.63 47.7858Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.12 45.4239L1203.85 46.1794L1201.06 49.8015L1208.59 52.7757L1218.7 52.2074L1221.47 48.4389L1214.12 45.4239Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.7 52.2076L1208.59 52.7759L1206 56.5844L1213.3 60.0359L1223.15 59.731L1225.98 55.6608L1218.7 52.2076Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.99 56.5853L1195.96 57.3799L1193.53 61.4575L1200.8 64.809L1210.51 64.2461L1213.3 60.0368L1205.99 56.5853Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.28 54.5288L1178.1 55.9214L1175.83 60.189L1183.6 62.8063L1193.53 61.4565L1195.96 57.3789L1188.28 54.5288Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.83 60.1917L1165.78 62.4359L1163.75 67.3869L1171.5 69.6247L1181.29 67.3703L1183.6 62.8066L1175.83 60.1917Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.28 67.3694L1171.5 69.6218L1169.23 74.8808L1176.13 77.6089L1185.53 75.5623L1188.43 70.4909L1181.28 67.3694Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.23 74.8835L1159.65 78.4198L1157.32 84.578L1163.79 86.7091L1173 83.3856L1176.13 77.6093L1169.23 74.8835Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.06 76.7429L1142.52 81.8936L1140.54 88.4534L1147.72 89.5559L1157.32 84.5781L1159.65 78.4199L1152.06 76.7429Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.54 88.4538L1131.07 94.1881L1128.94 101.922L1135.55 103.544L1144.72 96.8222L1147.72 89.5563L1140.54 88.4538Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.72 96.8219L1135.55 103.544L1132.92 113.188L1138.53 115.877L1146.94 108.182L1150.64 98.8601L1144.72 96.8219Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.92 113.19L1124.35 121.322L1121.92 133.098L1127.44 136.9L1135.35 127.733L1138.53 115.878L1132.92 113.19Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.06 118.685L1109.6 126.477L1107.45 137.869L1113.59 141.928L1121.92 133.099L1124.35 121.322L1118.06 118.685Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.92 133.098L1113.59 141.927L1111.19 155.51L1116.77 160.789L1124.58 150.934L1127.44 136.9L1121.92 133.098Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.44 137.868L1099.04 145.733L1096.68 158.538L1102.79 164.318L1111.19 155.51L1113.58 141.926L1107.44 137.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.19 155.51L1102.79 164.318L1100.24 179.266L1105.97 186.274L1114 176.547L1116.77 160.788L1111.19 155.51Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.24 179.266L1091.5 187.33L1088.59 203.062L1094.5 211.91L1103.06 203.15L1105.97 186.273L1100.24 179.266Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.37 179.656L1076.39 185.813L1073.14 200.061L1079.28 209.653L1088.59 203.062L1091.5 187.331L1085.37 179.656Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.59 203.062L1079.27 209.653L1075.78 225.42L1081.84 236.048L1091.18 229.12L1094.5 211.911L1088.59 203.062Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.78 225.419L1065.71 229.82L1061.41 244.709L1067.53 256.84L1077.85 252.604L1081.84 236.046L1075.78 225.419Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.63 218.473L1049.44 220.586L1044.57 233.525L1050.48 246.251L1061.41 244.709L1065.72 229.82L1059.63 218.473Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.56 233.524L1033.66 232.876L1028.32 243.681L1033.8 256.954L1045.15 259.198L1050.48 246.251L1044.56 233.524Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.03 247.561L997.749 241.6L988.513 246.443L991.877 257.92L1005.62 265.722L1014.55 260.174L1010.03 247.561Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M981.195 260.785L967.273 252.058L955.511 253.069L957.324 262.57L972.107 272.477L984.243 271.718L981.195 260.785Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M965.139 242.002L952.477 234.517L941.14 235.905L942.066 244.424L955.512 253.069L967.274 252.057L965.139 242.002Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M955.513 253.071L942.067 244.425L929.845 244.448L930.485 252.487L944.489 261.929L957.326 262.571L955.513 253.071Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M929.848 244.445L917.385 236.747L905.249 236.65L904.832 243.339L917.58 251.424L930.488 252.485L929.848 244.445Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M917.578 229.728L906.653 224.001L895.334 224.946L894.148 230.63L905.245 236.653L917.383 236.749L917.578 229.728Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M905.246 236.652L894.148 230.629L882.565 231.28L881.241 236.844L892.384 242.823L904.829 243.34L905.246 236.652Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.03 1.09433L1413.98 2.40445L1412.53 12.0152L1427.07 20.7237L1443.74 19.648L1445.23 9.547L1430.03 1.09433Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.74 19.6504L1427.07 20.7238L1423.86 28.2674L1436.98 34.8419L1453.66 33.2256L1457.42 25.9917L1443.74 19.6504Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M1423.86 28.2676L1406.48 27.0737L1401.96 32.4268L1414.21 38.6342L1431.64 39.391L1433.02 38.8626L1436.98 34.8397L1423.86 28.2676Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.95 18.8012L1376.11 16.7922L1372.19 22.5863L1384.53 29.944L1401.96 32.426L1406.48 27.0734L1392.95 18.8012Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.96 32.4261L1384.53 29.9461L1379.13 33.6291L1390.39 39.1055L1407.88 41.2159L1409.41 41.0298L1414.21 38.6335L1401.96 32.4261Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.18 22.5906L1355.72 20.1087L1351.06 24.5549L1362.17 30.7534L1379.12 33.6313L1384.53 29.9482L1372.18 22.5906Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.06 24.5546L1335.32 22.2636L1330.3 25.8881L1340.27 30.9015L1356.34 33.4066L1362.18 30.7527L1351.06 24.5546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.34 33.4067L1340.26 30.9015L1334.44 33.2598L1343.87 37.0876L1359.93 39.1469L1366.62 38.0178L1356.34 33.4067Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.29 25.8878L1315.54 24.3409L1310.5 27.7631L1319.51 31.7708L1334.44 33.259L1340.27 30.9012L1330.29 25.8878Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.44 33.258L1319.51 31.7702L1314.12 34.6465L1322.91 37.9731L1337.72 38.8146L1343.87 37.0858L1334.44 33.258Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.11 34.6468L1300.51 34.7073L1295.95 39.0156L1304.39 42.32L1317.71 41.2375L1322.9 37.9758L1314.11 34.6468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.22 31.3323L1279.86 32.5085L1276.05 37.7569L1283.92 41.0598L1295.96 39.0157L1300.51 34.7069L1292.22 31.3323Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.96 39.0159L1283.92 41.06L1280.74 46.6956L1288.67 50.4353L1300.54 48.0976L1304.39 42.3202L1295.96 39.0159Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.74 46.6985L1269.88 48.3667L1266.67 53.4411L1273.95 57.6316L1285.07 56.3055L1288.67 50.4381L1280.74 46.6985Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.4 44.8133L1252.03 46.0676L1249.05 50.5057L1256.24 54.3097L1266.67 53.4394L1269.88 48.365L1262.4 44.8133Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.67 53.4388L1256.24 54.3091L1253.02 59.0403L1259.75 63.6706L1270.22 63.1511L1273.96 57.6294L1266.67 53.4388Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.05 50.5059L1238.88 51.1735L1235.98 55.3148L1242.95 59.3474L1253.02 59.0411L1256.24 54.3098L1249.05 50.5059Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.02 59.0419L1242.95 59.3478L1239.7 63.9423L1245.91 68.9721L1255.84 69.0355L1259.75 63.6722L1253.02 59.0419Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.98 55.3177L1225.98 55.6633L1223.15 59.7335L1229.93 63.9347L1239.7 63.9423L1242.96 59.3478L1235.98 55.3177Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.7 63.9417L1229.92 63.9342L1226.59 68.5865L1232.26 73.9415L1241.75 74.3555L1245.91 68.9716L1239.7 63.9417Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.59 68.5845L1217.05 68.5328L1213.55 73.4254L1218.64 79.0014L1227.76 79.5192L1232.26 73.9395L1226.59 68.5845Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.52 64.2457L1200.8 64.8083L1198.01 69.3535L1204.23 73.6131L1213.55 73.426L1217.06 68.5334L1210.52 64.2457Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.55 73.424L1204.24 73.6111L1200.45 78.9111L1204.85 84.5741L1213.67 84.943L1218.64 79.0029L1213.55 73.424Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.01 69.3548L1188.44 70.4922L1185.53 75.564L1191.33 79.6419L1200.45 78.9115L1204.23 73.6139L1198.01 69.3548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.45 78.91L1191.33 79.6409L1187.01 85.4696L1190.69 91.1598L1199.27 91.0311L1204.85 84.5734L1200.45 78.91Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.53 75.563L1176.13 77.6096L1172.99 83.3859L1178.21 87.0997L1187.01 85.4694L1191.33 79.6409L1185.53 75.563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M1173 83.387L1163.79 86.7105L1160 93.4412L1164.49 96.6577L1173.42 93.6693L1178.21 87.1012L1173 83.387Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.41 93.6673L1164.49 96.6557L1159.16 105.319L1161.25 110.115L1170.11 107.306L1176.01 98.7642L1173.41 93.6673Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.99 93.4385L1150.64 98.8573L1146.94 108.182L1151.11 111.517L1159.16 105.318L1164.49 96.655L1159.99 93.4385Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.16 105.32L1151.11 111.518L1146.66 123.097L1148.56 127.889L1155.07 121.408L1161.25 110.116L1159.16 105.32Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.67 123.098L1139.46 131.699L1135.64 145.806L1137.69 151.042L1143.44 141.992L1144.21 139.89L1148.56 127.891L1146.67 123.098Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.35 127.732L1127.44 136.899L1124.58 150.933L1128.8 155.948L1135.64 145.806L1139.45 131.697L1135.35 127.732Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.58 150.934L1116.77 160.788L1114 176.548L1118.49 182.919L1125.37 172.111L1128.8 155.948L1124.58 150.934Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.37 172.112L1118.49 182.921L1115.17 200.517L1117.98 207.579L1123.69 196.171L1127.74 178.143L1125.37 172.112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.01 176.546L1105.97 186.275L1103.06 203.152L1107.87 211.069L1115.17 200.515L1118.49 182.919L1114.01 176.546Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.06 203.15L1094.5 211.91L1091.18 229.12L1096.33 238.604L1104.38 229.286L1107.87 211.067L1103.06 203.15Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.38 229.288L1096.34 238.607L1092.37 256.416L1096.17 265.627L1103.39 255.982L1107.7 237.472L1104.38 229.288Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M944.493 261.929L930.489 252.487L917.58 251.427L918.011 259.028L932.333 268.835L945.935 270.72L944.493 261.929Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M904.782 257.471L891.931 249.408L879.59 249.214L879.434 256.167L892.294 263.919L905.241 264.925L904.782 257.471Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.67 33.2262L1436.98 34.842L1433.03 38.8625L1431.65 39.3909L1445.58 39.3001L1457.76 37.0833L1463.82 33.4773L1453.67 33.2262Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.65 39.3912L1414.21 38.6344L1409.41 41.0307L1407.88 41.2168L1436.18 41.1734L1441.63 39.8292L1431.65 39.3912Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.88 41.2152L1390.38 39.1077L1385.51 40.4233L1383.62 40.5312L1410.46 42.8347L1417.8 42.1806L1407.88 41.2152Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.62 40.5309L1366.62 38.0173L1359.93 39.1465L1369.74 41.5889L1393.5 42.2131L1383.62 40.5309Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.37 42.7698L1369.74 41.5883L1363.2 42.8535L1373.01 45.3668L1389.28 45.7056L1396.05 44.3314L1386.37 42.7698Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.2 42.8531L1347.35 41.9238L1341.71 44.6094L1351.5 47.9166L1367.01 47.816L1373 45.3665L1363.2 42.8531Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.72 38.8138L1322.9 37.9746L1317.71 41.2364L1327.04 44.7998L1341.71 44.6082L1347.36 41.9231L1337.72 38.8138Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.72 41.238L1304.4 42.3204L1300.54 48.0977L1309.36 51.8394L1322.52 49.5531L1327.04 44.8014L1317.72 41.238Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.51 49.5558L1309.35 51.8397L1305.51 58.4407L1314.61 62.5658L1328.15 59.7475L1332.1 53.3739L1322.51 49.5558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.54 48.0978L1288.67 50.4355L1285.07 56.3029L1293.08 60.575L1305.51 58.4404L1309.35 51.8395L1300.54 48.0978Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.51 58.4416L1293.08 60.5753L1289.24 66.6033L1297.79 71.0146L1310.74 69.1361L1314.62 62.5667L1305.51 58.4416Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.24 66.6026L1277.45 67.8822L1273.53 73.516L1281.52 78.1514L1293.98 76.9555L1297.78 71.0139L1289.24 66.6026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.22 63.1515L1259.75 63.6709L1255.84 69.0343L1262.28 74.1787L1273.52 73.5168L1277.44 67.8826L1270.22 63.1515Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.53 73.5161L1262.28 74.1784L1258.21 79.6051L1265.66 84.4288L1277.71 83.6664L1281.52 78.1514L1273.53 73.5161Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.21 79.6066L1247.41 79.8874L1243.09 85.3119L1250.01 90.3026L1261.76 89.7286L1265.66 84.4303L1258.21 79.6066Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.75 74.3543L1232.26 73.9403L1227.76 79.5199L1232.65 85.4284L1243.1 85.3102L1247.42 79.8856L1241.75 74.3543Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.09 85.31L1232.65 85.4282L1227.98 91.0671L1234.36 96.2272L1245.92 95.6086L1250.01 90.3003L1243.09 85.31Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.98 91.0663L1217.78 91.241L1212.66 97.3223L1218.5 102.675L1229.97 101.783L1234.36 96.2265L1227.98 91.0663Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.67 84.9437L1204.85 84.5752L1199.27 91.0328L1202.59 97.7584L1212.66 97.3245L1217.78 91.2412L1213.67 84.9437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.66 97.324L1202.6 97.7579L1197 104.616L1202.13 110.223L1213.7 108.731L1218.5 102.677L1212.66 97.324Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.27 91.0318L1190.69 91.16L1184.26 98.1484L1186.74 105.635L1197 104.615L1202.6 97.7569L1199.27 91.0318Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.01 85.4714L1178.23 87.1253L1173.41 93.6506L1176 98.7664L1184.26 98.1498L1190.69 91.1614L1187.01 85.4714Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.63 113.18L1170.69 114.701L1165.15 124.572L1169.81 130.514L1179.74 126.804L1185.2 119.107L1180.63 113.18Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.15 124.574L1157.27 129.055L1152.96 142.123L1157.17 148.04L1165.92 141.199L1169.8 130.515L1165.15 124.574Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.11 107.307L1161.25 110.117L1155.07 121.409L1157.27 129.055L1165.15 124.573L1170.69 114.758L1170.11 107.307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.08 121.408L1148.56 127.89L1143.45 141.999L1145.8 149.702L1152.96 142.123L1157.27 129.055L1155.08 121.408Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.44 141.998L1137.69 151.039L1133.27 167.447L1135.63 174.973L1142.15 165.115L1145.8 149.701L1143.44 141.998Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.16 165.116L1135.63 174.973L1132.22 192.019L1135.54 197.253L1142.77 185.948L1145.98 170.754L1142.16 165.116Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.27 167.449L1127.74 178.143L1123.69 196.171L1126 203.436L1132.21 192.022L1135.62 174.977L1133.27 167.449Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.69 196.17L1117.98 207.578L1113.97 226.376L1116.23 233.341L1122.44 221.238L1126 203.435L1123.69 196.17Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.45 221.237L1116.23 233.341L1112.19 250.912L1114.46 255.123L1121.29 242.383L1125.24 225.977L1122.45 221.237Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.97 226.377L1107.69 237.471L1103.39 255.982L1105.63 262.662L1112.19 250.914L1116.23 233.342L1113.97 226.377Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.55 42.4674L1412.7 44.3691L1440.59 43.2583L1445.72 42.0711L1436.55 42.4674Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.74 43.7227L1422.29 45.0715L1415.63 46.9102L1425.81 48.1304L1442.2 46.2916L1448.42 43.7055L1438.74 43.7227Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.7 44.369L1396.04 44.3305L1389.28 45.7051L1399.22 47.5534L1415.63 46.9094L1422.29 45.0703L1412.7 44.369Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.63 46.9093L1399.22 47.5529L1393.18 50.1699L1403.75 52.6077L1420.04 51.2561L1425.81 48.1295L1415.63 46.9093Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M1389.28 45.7052L1373.01 45.3664L1367.01 47.8164L1377.18 50.7144L1393.18 50.1701L1399.22 47.5535L1389.28 45.7052Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.01 47.8155L1351.5 47.9185L1346.48 52.0223L1356.7 55.7484L1371.96 54.627L1377.18 50.714L1367.01 47.8155Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.96 54.6274L1356.7 55.7488L1352.45 61.4097L1363.27 65.6758L1378.41 63.6106L1382.77 58.1244L1371.96 54.6274Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.48 52.0229L1332.11 53.3728L1328.15 59.7468L1338.19 63.942L1352.45 61.4103L1356.7 55.749L1346.48 52.0229Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.44 61.4089L1338.19 63.941L1334.3 71.1506L1344.9 75.6661L1359.67 72.8875L1363.27 65.675L1352.44 61.4089Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.15 59.7467L1314.61 62.565L1310.73 69.1344L1320.38 73.4976L1334.29 71.1518L1338.18 63.9419L1328.15 59.7467Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.29 71.1529L1320.38 73.4991L1316.68 79.8665L1327.01 84.4124L1341.31 82.5891L1344.9 75.6685L1334.29 71.1529Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.68 79.8661L1303.24 81.4186L1299.66 87.1478L1309.73 91.6555L1323.63 90.5006L1327.01 84.412L1316.68 79.8661Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.98 76.9545L1281.52 78.1503L1277.71 83.6653L1286.6 88.17L1299.66 87.1463L1303.24 81.417L1293.98 76.9545Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M1299.67 87.147L1286.61 88.1707L1283.06 93.4831L1292.88 97.9123L1306.48 97.1387L1309.74 91.6547L1299.67 87.147Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.06 93.4853L1270.29 94.2466L1266.68 99.3762L1276.26 103.708L1289.66 103.04L1292.88 97.9144L1283.06 93.4853Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.76 89.7275L1250.01 90.3016L1245.92 95.6095L1254.09 100.133L1266.68 99.3778L1270.29 94.2457L1261.76 89.7275Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.69 99.3753L1254.09 100.132L1250.32 105.329L1259.65 109.562L1272.97 108.727L1276.26 103.707L1266.69 99.3753Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.92 95.6084L1234.36 96.2293L1229.97 101.785L1237.78 106.328L1250.31 105.33L1254.09 100.134L1245.92 95.6084Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.32 105.328L1237.79 106.326L1233.73 111.848L1242.83 116.007L1256.19 114.752L1259.65 109.56L1250.32 105.328Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.74 111.847L1221.15 113.327L1216.69 119.449L1225.55 123.582L1239.06 121.653L1242.83 116.007L1233.74 111.847Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.7 108.729L1202.13 110.222L1196.71 117.008L1203.93 121.639L1216.69 119.448L1221.15 113.325L1213.7 108.729Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.69 119.45L1203.93 121.64L1198.92 128.66L1207.53 132.833L1221.35 129.98L1225.55 123.582L1216.69 119.45Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.71 117.009L1185.2 119.108L1179.73 126.806L1186.43 131.664L1198.92 128.66L1203.93 121.642L1196.71 117.009Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M1197 104.614L1186.74 105.634L1180.63 113.18L1185.2 119.107L1196.71 117.008L1202.13 110.221L1197 104.614Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.92 128.659L1186.43 131.663L1182.66 140.256L1190.69 144.447L1203.16 140.146L1207.52 132.833L1198.92 128.659Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.67 140.255L1172.08 145.969L1168.81 157.411L1175.98 161.396L1187.28 154.266L1190.69 144.448L1182.67 140.255Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.92 141.199L1157.17 148.04L1153.83 161.361L1159.3 165.849L1168.81 157.41L1172.08 145.969L1165.92 141.199Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.81 157.41L1159.3 165.849L1156.12 179.391L1162.29 182.985L1172.64 173.547L1175.98 161.395L1168.81 157.41Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.83 161.361L1145.97 170.754L1142.77 185.948L1147.44 189.988L1156.12 179.391L1159.3 165.849L1153.83 161.361Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.77 185.948L1135.54 197.254L1132.12 213.505L1135.91 216.972L1144 204.87L1147.44 189.988L1142.77 185.948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M1144 204.87L1135.92 216.973L1131.93 232.365L1135.87 234.753L1144.95 222.516L1149.09 207.914L1144 204.87Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.12 213.505L1125.23 225.977L1121.29 242.384L1124.19 245.202L1131.93 232.365L1135.91 216.973L1132.12 213.505Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.93 232.365L1124.18 245.202L1119.38 260.197L1122.19 261.882L1130.93 249.378L1135.87 234.753L1131.93 232.365Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.64 50.9578L1431.16 53.2959L1426.41 57.9447L1438.74 61.0076L1455.52 58.2298L1459.6 52.7814L1447.64 50.9578Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M1420.03 51.2569L1403.75 52.6084L1398.63 56.7229L1410.09 59.9619L1426.41 57.9453L1431.16 53.296L1420.03 51.2569Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M1426.42 57.9436L1410.09 59.9607L1405.92 65.6612L1418.44 69.8098L1435.02 67.2471L1438.74 61.0065L1426.42 57.9436Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.63 56.7217L1382.76 58.1243L1378.41 63.6105L1390.02 67.8223L1405.92 65.6616L1410.09 59.9607L1398.63 56.7217Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.92 65.6613L1390.03 67.822L1386.48 74.8194L1398.96 79.7545L1415.11 77.0113L1418.44 69.8099L1405.92 65.6613Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.48 74.822L1371.19 77.674L1367.71 85.2906L1379.96 90.4599L1395.92 87.9571L1398.96 79.7547L1386.48 74.822Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.67 72.8891L1344.9 75.6677L1341.31 82.5884L1352.6 87.3998L1367.71 85.292L1371.19 77.673L1359.67 72.8891Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.71 85.291L1352.61 87.3992L1349.39 94.0058L1361.42 99.1697L1376.89 97.7646L1379.96 90.4607L1367.71 85.291Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.31 82.5909L1327.02 84.4118L1323.64 90.5004L1334.72 95.2571L1349.39 94.0065L1352.6 87.3999L1341.31 82.5909Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M1349.39 94.0054L1334.72 95.254L1331.69 101.085L1343.5 106.175L1358.56 105.539L1361.42 99.1697L1349.39 94.0054Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.63 90.4996L1309.73 91.6546L1306.48 97.139L1317.36 101.784L1331.69 101.086L1334.72 95.254L1323.63 90.4996Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.48 97.1404L1292.88 97.9139L1289.66 103.039L1300.35 107.54L1314.43 107.094L1317.36 101.786L1306.48 97.1404Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.43 107.093L1300.34 107.538L1297.42 112.591L1308.83 117.413L1323.34 117.363L1326.04 112.058L1314.43 107.093Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.66 103.036L1276.25 103.705L1272.97 108.725L1283.47 113.075L1297.42 112.589L1300.35 107.537L1289.66 103.036Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.42 112.592L1283.48 113.077L1280.44 118.157L1291.66 122.839L1306.07 122.619L1308.83 117.415L1297.42 112.592Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.44 118.156L1266.5 118.963L1263.24 124.364L1274.27 128.931L1288.71 128.249L1291.65 122.838L1280.44 118.156Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.18 114.752L1242.83 116.007L1239.06 121.652L1249.2 125.761L1263.24 124.363L1266.5 118.963L1256.18 114.752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.25 124.363L1249.2 125.761L1245.59 131.794L1256.42 136.297L1271.02 134.868L1274.27 128.93L1263.25 124.363Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.58 131.795L1231.29 134.048L1227.17 141.041L1237.81 145.553L1252.71 143.101L1256.41 136.297L1245.58 131.795Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.35 129.98L1207.52 132.833L1203.17 140.146L1212.8 144.255L1227.17 141.04L1231.29 134.048L1221.35 129.98Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.17 141.039L1212.8 144.254L1209.06 152.738L1219.04 157.37L1233.57 153.468L1237.81 145.551L1227.17 141.039Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.06 152.738L1196.01 158.324L1192.38 169.376L1201.36 173.958L1214.98 167.66L1219.04 157.37L1209.06 152.738Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.28 154.266L1175.98 161.396L1172.64 173.548L1180.31 177.349L1192.38 169.379L1196.01 158.327L1187.28 154.266Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.64 173.548L1162.29 182.986L1158.7 196.742L1165.18 200.108L1176.44 190.274L1180.31 177.346L1172.64 173.548Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.44 190.273L1165.18 200.107L1160.81 214.2L1167.41 218.155L1179.64 208.523L1184.29 194.613L1176.44 190.273Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.7 196.741L1149.09 207.913L1144.95 222.514L1150.18 225.319L1160.81 214.2L1165.19 200.107L1158.7 196.741Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.81 214.2L1150.18 225.319L1145.07 239.826L1150.4 243.3L1162.12 232.86L1167.42 218.154L1160.81 214.2Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.07 239.826L1134.9 251.539L1128.88 265.66L1132.94 268.619L1144.29 258.077L1150.4 243.3L1145.07 239.826Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.52 58.2307L1438.74 61.0085L1435.02 67.2491L1448.7 71.4454L1466.04 68.3617L1469.06 61.3236L1455.52 58.2307Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.83 79.1659L1428.73 82.0774L1425.95 90.4926L1440.49 96.2984L1458.61 93.2115L1460.82 84.4648L1445.83 79.1659Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.61 93.2112L1440.49 96.2981L1437.87 105.525L1450.96 112.754L1470.29 108.228L1472.82 99.5581L1458.61 93.2112Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.11 77.0126L1398.96 79.7558L1395.92 87.9577L1409.22 93.4943L1425.96 90.4922L1428.73 82.0774L1415.11 77.0126Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.96 90.4921L1409.22 93.4938L1406.27 101.682L1420.27 107.902C1427.14 106.999 1431 106.428 1437.87 105.526C1438.85 101.935 1439.51 99.8892 1440.49 96.2984L1425.96 90.4921Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.73 115.798L1400.86 116.878L1398 124.058L1409.45 131.661L1425.46 131.656C1426.8 128.374 1427.77 126.407 1429.11 123.126L1417.73 115.798Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.86 139.015L1453.73 137.877L1459.36 128.232L1448.11 121.125C1440.51 122.028 1436.69 122.281 1429.08 123.183C1427.76 126.469 1426.79 128.439 1425.47 131.725L1436.86 139.015Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.27 101.682L1389.89 103.414L1387.14 110.534L1400.83 116.862L1417.73 115.797L1420.26 107.9L1406.27 101.682Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.87 105.525L1420.27 107.901L1417.73 115.797L1429.11 123.125L1448.11 121.125L1450.96 112.755C1445.85 109.931 1442.98 108.349 1437.87 105.525Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.88 97.7651L1361.42 99.1702L1358.55 105.54L1371.27 111.22L1387.14 110.535L1389.89 103.415L1376.88 97.7651Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.14 110.534L1371.27 111.219L1368.64 117.534L1381.99 124.006L1398 124.057L1400.86 116.877L1387.14 110.534Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.56 105.539L1343.5 106.174L1340.77 111.872L1353.2 117.519L1368.65 117.533L1371.27 111.219L1358.56 105.539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.64 117.534L1353.2 117.519L1350.61 123.319L1363.48 129.808L1379.32 130.515L1381.99 124.005L1368.64 117.534Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.77 111.872L1326.04 112.057L1323.34 117.362L1335.5 122.94L1350.61 123.319L1353.2 117.519L1340.77 111.872Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.61 123.321L1335.5 122.941L1332.85 128.533L1345.28 135.129L1360.69 136.111L1363.48 129.809L1350.61 123.321Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.85 128.532L1317.95 128.12L1315.13 133.817L1327.08 140.518L1342.49 141.466C1343.62 139.01 1344.15 137.584 1345.28 135.128L1332.85 128.532Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.69 136.111L1345.28 135.163L1342.49 141.465L1353.86 147.816L1369.83 148.947L1372.74 142.854L1360.69 136.111Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.03 143.592L1372.74 142.853L1369.83 148.946L1380.31 154.917L1397.19 156.693L1400.1 150.6L1388.03 143.592Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.33 151.498L1400.1 150.601L1397.19 156.694L1407.67 162.665L1424.44 164.504L1427.59 158.318L1415.33 151.498Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.44 158.667L1427.6 158.32L1424.44 164.506L1434.39 170.013L1448.14 170.708L1451.22 164.262L1441.44 158.667Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.32 130.518L1363.48 129.81L1360.69 136.112L1372.74 142.855L1388.03 143.594L1390.82 137.292L1379.32 130.518Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.59 137.978L1390.83 137.29L1388.04 143.592L1400.1 150.601L1415.33 151.498L1418.19 145.179L1406.59 137.978Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.98 145.302L1418.19 145.18L1415.33 151.499L1427.6 158.32L1441.44 158.667L1444.52 152.221L1433.98 145.302Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.22 152.69L1444.52 152.221L1441.44 158.667L1451.21 164.262L1467.77 165.708L1470.98 159.483L1460.22 152.69Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M1398 124.058L1381.99 124.007L1379.32 130.517L1390.83 137.292L1406.59 137.98L1409.45 131.661L1398 124.058Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.46 131.654L1409.45 131.659L1406.59 137.977L1418.19 145.178L1433.98 145.3L1436.83 138.981L1425.46 131.654Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.7 137.903L1436.83 138.983L1433.98 145.302L1444.52 152.221L1460.21 152.69L1465.43 145.324L1453.7 137.903Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.07 122.617L1291.65 122.837L1288.71 128.248L1300.33 133.689L1315.13 133.816L1317.95 128.12L1306.07 122.617Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.13 133.817L1300.33 133.69L1297.21 139.828L1308.82 146.575L1323.87 147.06L1327.08 140.518L1315.13 133.817Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.21 154.276L1335.25 154.182L1332.12 160.32L1343.54 166.942L1358.71 167.472L1361.92 160.93L1350.21 154.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.76 161.371L1361.92 160.93L1358.71 167.471L1370.12 174.302L1385.38 174.504L1388.38 168.082L1376.76 161.371Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.49 141.464L1327.08 140.518L1323.86 147.059L1335.28 154.162L1350.21 154.275L1353.75 147.822L1342.49 141.464Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.83 148.947L1353.75 147.822L1350.21 154.275L1361.92 160.929L1376.76 161.371L1380.31 154.918L1369.83 148.947Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M1397.19 156.694L1380.31 154.918L1376.76 161.37L1388.38 168.082L1404.09 168.581L1407.67 162.665L1397.19 156.694Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.44 164.504L1407.67 162.665L1404.09 168.581L1415.13 175.674L1431.37 175.542L1434.39 170.012L1424.44 164.504Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.86 147.06L1308.82 146.596L1305.12 153.997L1316.44 159.877L1332.15 160.376L1335.28 154.163L1323.86 147.06Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.2 139.829L1282.37 140.289L1278.81 147.218L1290.01 154.111L1305.14 153.971L1308.82 146.576L1297.2 139.829Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M1271.02 134.868L1256.42 136.297L1252.71 143.1L1263.8 148.564L1278.81 147.218L1282.37 140.288L1271.02 134.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.81 147.218L1263.79 148.564L1259.65 156.651L1270.49 163.807L1285.74 162.622L1290.02 154.11L1278.81 147.218Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.16 160.375L1316.44 159.876L1312.36 168.299L1323.14 175.761L1338.82 175.723L1343.54 166.941L1332.16 160.375Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.71 167.472L1343.54 166.942L1338.82 175.725L1350.02 182.676L1365.49 182.758L1370.12 174.303L1358.71 167.472Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.37 174.504L1370.11 174.302L1365.49 182.756L1376.66 189.617L1392.13 190.213L1396.71 181.744L1385.37 174.504Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.13 190.213L1376.66 189.617L1372.27 197.391L1380.39 204.221L1396.53 204.437L1401.24 196.189L1392.13 190.213Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.15 181.772L1396.71 181.744L1392.14 190.213L1401.24 196.189L1419.2 195.959L1423.3 189.227L1412.15 181.772Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M1429.9 203.666L1445.21 204.253L1450.07 195.942L1438.73 189.254L1423.3 189.226L1419.2 195.958L1429.9 203.666Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.36 168.299L1296.32 169.65L1291.12 179.538L1301.48 187.24L1318.64 184.424L1323.14 175.761L1312.36 168.299Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.64 184.424L1301.48 187.24L1296.1 196.965L1306.58 204.8L1323.93 201.983L1329.59 190.957L1318.64 184.424Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.93 201.983L1306.59 204.8L1300.23 216.334L1309.38 224.929L1325.25 220.601L1332.6 210.263L1323.93 201.983Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.25 220.601L1309.37 224.929L1301.97 236.182L1309.35 244.308L1326.63 240.355L1333.98 230.017L1325.25 220.601Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.82 175.723L1323.14 175.761L1318.64 184.424L1329.59 190.958L1345.48 190.8L1350.02 182.674L1338.82 175.723Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.49 182.756L1350.02 182.674L1345.48 190.8L1354 198.096L1372.28 197.391L1376.66 189.617L1365.49 182.756Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.28 197.392L1354 198.096L1346.85 207.739L1356.09 215.987L1372.22 214.151L1380.4 204.222L1372.28 197.392Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.48 190.8L1329.59 190.958L1323.93 201.984L1332.59 210.265L1346.85 207.739L1354 198.096L1345.48 190.8Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.98 230.018L1350.4 227.14L1356.08 215.986L1346.85 207.738L1332.59 210.264L1325.25 220.601L1333.98 230.018Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.64 156.654L1244.3 159.105L1239.72 169.002L1250.1 176.504L1265.42 173.85L1270.49 163.805L1259.64 156.654Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.78 162.605L1270.49 163.806L1265.42 173.902L1275.45 181.515L1291.12 179.538L1296.32 169.65L1285.78 162.605Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M1291.12 179.539L1275.45 181.515L1270.01 192.925L1279.2 201.018L1296.1 196.967L1301.48 187.24L1291.12 179.539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.1 196.966L1279.17 201.013L1273.74 212.608L1283.08 220.509L1300.23 216.335L1306.58 204.801L1296.1 196.966Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.23 216.336L1283.07 220.509L1278.29 233.208L1287.24 240.446L1301.96 236.183L1309.37 224.931L1300.23 216.336Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.97 236.181L1287.24 240.444L1281.27 254.693L1288.02 261.715L1303.76 255.115L1309.35 244.308L1301.97 236.181Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.57 153.468L1219.04 157.37L1214.98 167.66L1224.92 173.526L1239.72 169.001L1244.3 159.104L1233.57 153.468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.72 169.002L1224.93 173.527L1220.3 185.843L1230.03 193.81L1245.02 189.223L1250.1 176.505L1239.72 169.002Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.98 167.66L1201.36 173.958L1197.14 186.39L1206.12 192.282L1220.3 185.842L1224.92 173.526L1214.98 167.66Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.02 189.207L1230.02 193.796L1224.75 208.666L1233.63 217.207L1248.26 211.096L1255.03 197.554L1245.02 189.207Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.14 186.389L1184.29 194.611L1179.64 208.521L1187.54 214.286L1201.18 206.393L1206.13 192.281L1197.14 186.389Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.18 206.392L1187.53 214.288L1182.07 229.561L1190.13 237.819L1204.56 230.844L1210.13 214.563L1201.18 206.392Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.75 208.668L1210.15 214.527L1204.59 230.943L1212.24 238.801L1226.55 231.796L1233.64 217.209L1224.75 208.668Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.64 208.523L1167.41 218.156L1162.12 232.859L1168.86 238.385L1182.07 229.564L1187.54 214.287L1179.64 208.523Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.07 229.563L1168.86 238.385L1162.72 254.173L1169.85 262.455L1184.06 255.049L1190.13 237.821L1182.07 229.563Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.64 231.723L1212.24 238.799L1203.5 257.078L1211.18 265.473L1228.26 255.766L1235.89 240.89L1226.64 231.723Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.06 233.113L1235.89 240.89L1228.26 255.765L1236.05 264.097L1252.32 255.895L1259.33 241.929L1250.06 233.113Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.14 186.389L1184.29 194.611L1179.64 208.521L1187.54 214.286L1201.18 206.393L1206.13 192.281L1197.14 186.389Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.31 211.086L1233.63 217.207L1226.64 231.723L1235.89 240.89L1250.06 233.114C1252.89 227.608 1253.74 225.823 1256.57 220.317L1248.31 211.086Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.01 192.925L1255.03 197.556L1248.31 211.087L1256.57 220.317L1273.75 212.609L1279.2 201.018L1270.01 192.925Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.74 212.607L1256.57 220.316L1250.06 233.113L1259.33 241.929L1278.29 233.206L1283.08 220.508C1279.43 217.422 1277.39 215.693 1273.74 212.607Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.29 233.208L1259.33 241.931L1252.31 255.897L1261.36 264.839L1281.28 254.694L1287.24 240.446L1278.29 233.208Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M1457.75 37.0828L1434.6 41.4746L1462.82 37.7326L1466.83 36.2135L1457.75 37.0828Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.83 39.4755L1438.74 43.7227L1464.6 40.9227L1470.99 38.3552L1461.83 39.4755Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.98 5.44458L1097.71 7.27562L1093.03 11.8409L1094.56 15.1522L1101.25 13.8274L1105.85 8.63174L1103.98 5.44458Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.88 3.88211L1089.62 4.78327L1083.72 9.19094L1085.25 12.8462L1093.03 11.8417L1097.71 7.27703L1095.88 3.88211Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.18 -11.8975L1424.18 -10.4332L1420.09 -3.92243L1428.15 0.277357L1443.17 -1.5901L1447.02 -7.85536L1437.18 -11.8975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.17 -1.58971L1428.15 0.277748L1424.23 7.06709L1432.29 11.2669L1450.2 9.23338L1453.77 3.12817L1443.17 -1.58971Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M1450.2 9.23299L1432.28 11.2665L1426.54 17.4962L1433.19 21.8645L1458.52 19.6945L1461.25 14.0694L1450.2 9.23299Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M900.732 115.799L897.345 119.708L894.062 126.042L894.763 128.698L898.679 124.865L901.362 118.522L900.732 115.799Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M898.676 124.865L894.761 128.697L891.482 134.482L892.767 136.942L897.285 133.718L899.85 127.532L898.676 124.865Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M894.065 126.041L888.75 129.768L885.483 134.96L886.79 137.211L891.487 134.482L894.766 128.696L894.065 126.041Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M891.486 134.482L886.788 137.212L882.607 141.886L883.844 144.338L889.317 142.106L892.771 136.942L891.486 134.482Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M885.48 134.961L880.06 137.301L876.244 141.693L877.215 143.364L882.607 141.887L886.788 137.213L885.48 134.961Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M882.608 141.887L877.216 143.365L873.09 147.92L873.993 150.353L879.463 148.438L883.846 144.339L882.608 141.887Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M873.088 147.921L868.637 150.037L864.83 154.864L865.154 157.183L869.894 154.824L873.992 150.354L873.088 147.921Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M864.826 154.864L861.209 157.455L857.493 162.547L857.078 164.69L861.13 161.945L865.15 157.183L864.826 154.864Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M903.712 123.857L899.855 127.532L897.289 133.718L898.944 136.166L903.153 132.743L905.328 126.49L903.712 123.857Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M903.149 132.743L898.94 136.167L896.11 141.703L897.989 144.102L902.611 141.151L904.943 135.338L903.149 132.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M897.288 133.719L892.771 136.942L889.316 142.107L891.003 144.433L896.113 141.703L898.943 136.167L897.288 133.719Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M896.112 141.702L891.002 144.432L887.143 148.976L889.013 151.285L894.757 149.123L897.992 144.102L896.112 141.702Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M887.144 148.975L880.995 150.755L876.614 154.973L878.158 157.291L884.47 155.418L889.014 151.284L887.144 148.975Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M879.466 148.437L873.996 150.353L869.899 154.823L870.949 157.087L876.618 154.975L880.999 150.756L879.466 148.437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M876.614 154.974L870.945 157.087L866.592 161.609L867.557 163.849L873.483 161.681L878.159 157.292L876.614 154.974Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M869.895 154.822L865.154 157.182L861.134 161.944L861.502 164.076L866.591 161.609L870.945 157.087L869.895 154.822Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M861.133 161.944L857.081 164.688L852.942 169.623L852.51 171.575L857.019 168.797L861.501 164.075L861.133 161.944Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M857.021 168.796L852.512 171.574L847.788 176.403L847.251 178.181L852.148 175.625L857.249 170.897L857.021 168.796Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M908.766 131.936L904.946 135.339L902.614 141.151L904.457 143.771L908.514 140.801L910.498 134.785L908.766 131.936Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M908.513 140.8L904.456 143.77L901.716 149.184L903.379 151.97L907.723 149.484L910.12 143.74L908.513 140.8Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M901.718 149.187L896.639 151.603L892.706 156.206L894.328 158.945L899.929 157.108L903.38 151.972L901.718 149.187Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M894.757 149.125L889.014 151.286L884.47 155.42L886.224 157.895L892.705 156.205L896.638 151.602L894.757 149.125Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M892.704 156.206L886.223 157.896L881.275 162.273L882.672 165.069L889.289 163.466L894.327 158.945L892.704 156.206Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M884.47 155.418L878.158 157.292L873.482 161.68L874.808 164.143L881.276 162.271L886.224 157.893L884.47 155.418Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M873.483 161.681L867.557 163.849L862.704 168.444L863.402 170.817L869.599 168.718L874.809 164.144L873.483 161.681Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M869.596 168.718L863.398 170.816L857.894 175.53L858.19 178.202L864.631 176.284L870.522 171.483L869.596 168.718Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M862.705 168.444L857.248 170.897L852.147 175.625L852.098 177.861L857.899 175.531L863.402 170.817L862.705 168.444Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M857.894 175.531L852.094 177.862L846.305 182.673L845.895 185.224L851.972 183.105L858.189 178.203L857.894 175.531Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M852.145 175.624L847.249 178.181L841.817 183.136L840.99 185.223L846.309 182.672L852.097 177.86L852.145 175.624Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M913.589 140.883L910.12 143.743L907.722 149.487L908.967 152.669L912.555 150.226L914.786 144.192L913.589 140.883Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M912.557 150.224L908.97 152.668L905.843 158.284L906.453 161.917L910.065 159.718L913.211 153.843L912.557 150.224Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M905.843 158.283L901.146 160.25L896.625 165.305L897.093 169.066L902.072 167.476L906.453 161.916L905.843 158.283Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M899.931 157.106L894.33 158.943L889.292 163.464L890.412 166.695L896.626 165.306L901.147 160.251L899.931 157.106Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M889.289 163.465L882.672 165.068L877.16 169.744L878.019 173.018L884.691 171.615L890.409 166.696L889.289 163.465Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M884.692 171.615L878.02 173.018L871.799 178.029L871.989 181.951L878.492 180.703L885.131 175.507L884.692 171.615Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M877.161 169.743L870.525 171.484L864.634 176.286L865.027 179.521L871.798 178.028L878.02 173.017L877.161 169.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M871.798 178.027L865.027 179.52L858.397 184.616L858.174 188.503L864.911 187.263L871.988 181.949L871.798 178.027Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M858.397 184.616L851.784 186.257L844.882 191.451L844.169 195.277L850.923 194.024L858.174 188.504L858.397 184.616Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M851.976 183.105L845.899 185.223L839.448 190.224L838.638 193.283L844.884 191.451L851.785 186.257L851.976 183.105Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M844.884 191.451L838.638 193.282L831.636 198.609L830.438 202.383L836.984 201.078L844.17 195.277L844.884 191.451Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M839.445 190.225L833.857 192.55L827.303 197.664L825.922 200.657L831.635 198.609L838.636 193.283L839.445 190.225Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M916.043 151.298L913.213 153.843L910.067 159.719L909.328 162.846L912.371 160.262L915.946 154.574L916.043 151.298Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M910.063 159.72L906.451 161.918L902.069 167.478L900.997 170.681L905.742 167.078L909.324 162.847L910.063 159.72Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M902.071 167.476L897.092 169.067L891.197 174.255L890.014 177.631L894.978 175.803L900.998 170.68L902.071 167.476Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M894.978 175.803L890.013 177.631L882.7 182.368L880.001 185.016L894.16 176.72L894.978 175.803Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M891.196 174.256L885.131 175.506L878.492 180.702L877.209 184.191L882.7 182.368L890.014 177.631L891.196 174.256Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M882.7 182.368L877.209 184.191L869.542 189.225L867.008 192.253L881.03 184.139L882.7 182.368Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M878.49 180.701L871.988 181.949L864.91 187.263L863.705 191.046L869.541 189.225L877.208 184.19L878.49 180.701Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M864.913 187.263L858.177 188.504L850.926 194.025L849.897 198.217L855.953 196.463L863.709 191.047L864.913 187.263Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M855.948 196.461L849.893 198.216L842.264 204.068L840.379 208.25L845.804 205.966L853.712 200.023L855.948 196.461Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M850.924 194.024L844.169 195.277L836.983 201.078L836.151 205.728L842.266 204.07L849.895 198.217L850.924 194.024Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M836.981 201.078L830.436 202.383L823.531 208.521L822.845 213.608L828.827 212.038L836.149 205.727L836.981 201.078Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M828.832 212.037L822.851 213.607L815.974 220.366L814.664 225.776L820.044 223.869L827.279 216.859L828.832 212.037Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M815.972 220.367L810.35 221.893L804.024 229.058L802.803 234.93L807.885 233.218L814.662 225.778L815.972 220.367Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M804.023 229.057L799.019 230.624L793.317 238.116L792.064 244.378L796.329 242.695L802.802 234.929L804.023 229.057Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M914.644 160.871L911.157 163.16L903.586 170.735L907.668 168.717L913.564 163.986L914.644 160.871Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M907.665 168.717L893.436 177.41L905.58 171.511L907.665 168.717Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M858.954 197.629L853.711 200.022L845.804 205.965L843.043 209.674L858.954 197.629Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M847.788 206.733L835.35 216.446L832.478 220.592L847.788 206.733Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M845.806 205.966L840.382 208.25L832.759 214.748L830.447 219.224L835.349 216.444L843.045 209.674L845.806 205.966Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M835.349 216.446L830.446 219.225L823.095 226.589L820.693 231.581L825.218 228.378L835.349 216.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M832.757 214.748L827.275 216.858L820.039 223.868L818.119 229.099L823.092 226.588L830.445 219.224L832.757 214.748Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M823.096 226.588L818.121 229.099L811.15 236.942L809.128 242.735L813.754 239.912L820.694 231.58L823.096 226.588Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M811.146 236.943L806.227 239.117L799.641 247.284L797.839 253.753L802.471 251.423L809.124 242.736L811.146 236.943Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M807.882 233.216L802.799 234.928L796.326 242.694L794.943 249.087L799.641 247.283L806.228 239.116L807.882 233.216Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M910.86 170.385L905.584 171.511L898.134 175.641L895.312 178.264L901.216 177.489L909.359 173.77L910.86 170.385Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M901.212 177.489L895.308 178.264L886.748 182.088L883.702 184.855L890.12 184.326L899.121 180.819L901.212 177.489Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M848.617 206.565L833.703 221.09",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M825.221 228.379L820.696 231.581L813.756 239.914L811.515 245.562L815.841 242.046L825.221 228.379Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M815.843 242.047L811.516 245.563L805.01 254.842L803.096 261.198L807.438 257.521L815.843 242.047Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M895.612 188.539L888.015 187.96L879.011 191.851L877.686 196.333L885.425 196.872L894.384 193.09L895.612 188.539Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M890.121 184.325L883.704 184.855L874.772 188.882L872.24 192.285L879.009 191.851L888.013 187.96L890.121 184.325Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M879.01 191.851L872.241 192.285L863.947 197.254L862.894 201.972L869.783 201.362L877.685 196.333L879.01 191.851Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M874.771 188.881L869.064 190.395L861.167 195.741L858.523 199.213L863.945 197.253L872.239 192.284L874.771 188.881Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M863.948 197.253L858.526 199.213L851.594 205.984L850.35 210.782L856.264 208.743L862.895 201.972L863.948 197.253Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M861.171 195.742L848.785 206.364L846.931 209.189L858.526 199.213L861.171 195.742Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M851.595 205.986L846.932 209.191L840.468 217.226L839.155 222.288L844.351 219.068L850.351 210.784L851.595 205.986Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M840.463 217.224L836.158 221.209L830.07 230.326L828.827 235.826L833.568 231.78L839.15 222.286L840.463 217.224Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M830.073 230.326L825.909 234.729L820.08 244.694L818.97 250.741L823.485 246.229L828.831 235.826L830.073 230.326Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M828.084 229.789L817.757 243.503L815.883 249.17L820.08 244.696L828.084 229.789Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M820.082 244.694L815.885 249.168L810.17 259.695L809.181 266.318L813.669 261.713L818.971 250.741L820.082 244.694Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M892.306 202.434L884.427 201.458L875.721 205.569L874.014 209.695L881.271 210.095L890.868 207.005L892.306 202.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M885.426 196.872L877.688 196.332L869.785 201.362L868.925 206.081L875.723 205.569L884.428 201.458L885.426 196.872Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M875.722 205.568L868.923 206.08L861.381 211.833L859.556 215.891L865.385 214.19L874.015 209.694L875.722 205.568Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M861.383 211.835L855.475 213.838L848.487 221.066L846.472 225.227L859.558 215.893L861.383 211.835Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M856.264 208.743L850.349 210.781L844.35 219.065L843.346 224.332L848.484 221.065L855.472 213.837L856.264 208.743Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M848.486 221.065L843.347 224.331L834.664 236.991L846.471 225.224L848.486 221.065Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M833.572 231.781L828.831 235.827L823.485 246.23L822.065 251.642L832.359 237.146L833.572 231.781Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M892.306 202.434L884.427 201.458L875.721 205.569L874.014 209.695L881.271 210.095L890.868 207.005L892.306 202.434Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M875.722 205.568L868.923 206.08L861.381 211.833L859.556 215.891L865.385 214.19L874.015 209.694L875.722 205.568Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M899.365 209.141L890.87 207.005L881.273 210.096L879.314 214.309L887.528 216.255L897.998 214.234L899.365 209.141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M887.526 216.254L879.311 214.308L869.775 217.621L867.217 221.416L875.128 222.951L885.782 221.048L887.526 216.254Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M881.268 210.096L874.01 209.696L865.38 214.192L863.087 217.717L869.773 217.622L879.309 214.309L881.268 210.096Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M865.383 214.191L859.555 215.892L851.689 222.129L849.018 225.68L863.089 217.717L865.383 214.191Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M869.775 217.622L863.09 217.717L854.523 222.957L851.671 226.43L867.368 221.214L869.775 217.622Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M854.523 222.956L849.019 225.679L837.791 235.734L851.672 226.429L854.523 222.956Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M851.688 222.129L846.467 225.226L836.273 236.241L849.017 225.681L851.688 222.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M882.55 231.276L873.102 227.558L862.484 229.843L860.418 234.605L869.694 237.817L881.226 236.84L882.55 231.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M875.127 222.951L867.216 221.417L857.606 225.112L854.912 229L862.485 229.845L873.104 227.56L875.127 222.951Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M862.49 229.843L854.916 228.999L845.638 233.866L842.997 238.241L850.199 238.06L860.423 234.605L862.49 229.843Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M845.636 233.868L839.82 236.185L831.405 243.078L828.502 247.464L834.29 245.005L842.995 238.243L845.636 233.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M831.406 243.076L815.42 258.636L820.445 255.305L828.504 247.462L831.406 243.076Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M892.38 242.823L881.238 236.845L869.706 237.82L868.526 243.669L879.587 249.214L891.929 249.407L892.38 242.823Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M879.59 249.213L868.529 243.669L857.494 245.876L856.87 252.661L867.819 257.515L879.434 256.165L879.59 249.213Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M857.494 245.875L848.461 243.552L839.112 249.272L838.181 256.341L846.945 257.428L856.869 252.66L857.494 245.875Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M850.209 238.058L843.005 238.237L834.3 244.998L832.189 250.563L839.115 249.271L848.463 243.552L850.209 238.058Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M834.298 244.998L828.51 247.456L820.45 255.3L818.077 260.935L824.064 258.739L832.188 250.563L834.298 244.998Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M870.093 140.693L864.935 140.971L860.547 142.42L861.665 143.678L866.859 142.949L870.986 141.395L870.093 140.693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M867.789 143.905L871.737 144.254L876.242 141.693L875.356 141.456L870.844 141.427L866.86 142.95L867.789 143.905Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M866.866 142.949L861.672 143.678L857.125 145.521L858.659 146.873L863.973 145.705L867.795 143.903L866.866 142.949Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M860.551 142.42L855.198 142.233L850.699 143.77L851.769 145.658L857.122 145.521L861.669 143.678L860.551 142.42Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M857.124 145.522L851.771 145.659L847.398 147.607L848.738 149.707L854.349 149.145L858.658 146.873L857.124 145.522Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M850.699 143.77L845.181 143.325L840.589 145.086L841.731 147.437L847.397 147.606L851.77 145.657L850.699 143.77Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M847.397 147.608L841.731 147.438L837.266 149.653L838.682 152.342L844.491 152.278L848.737 149.707L847.397 147.608Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M840.588 145.087L834.935 144.633L830.258 146.709L831.442 149.321L837.264 149.652L841.73 147.437L840.588 145.087Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M837.265 149.652L831.442 149.321L826.874 151.807L828.326 154.841L834.314 155.111L838.681 152.342L837.265 149.652Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M830.261 146.71L824.506 146.536L819.377 149.271L820.439 151.999L826.876 151.807L831.445 149.321L830.261 146.71Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M819.372 149.27L813.629 150.325L809.166 154.699L809.917 157.648L815.392 156.03L820.434 151.998L819.372 149.27Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M815.394 156.031L809.919 157.649L805.908 162.95L806.888 166.256L812.029 164.215L816.571 159.265L815.394 156.031Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M809.17 154.7L804.617 156.942L800.935 162.55L801.52 165.585L805.91 162.949L809.921 157.648L809.17 154.7Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M805.909 162.95L801.519 165.586L798.292 171.808L799.205 175.069L803.373 172.173L806.889 166.256L805.909 162.95Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M800.931 162.55L797.21 165.735L794.088 172.21L794.618 175.23L798.289 171.807L801.516 165.585L800.931 162.55Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M798.292 171.807L794.621 175.23L791.928 182.041L792.872 185.17L796.444 181.636L799.206 175.068L798.292 171.807Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M794.09 172.21L790.878 176.069L788.089 183.056L788.638 185.995L791.927 182.041L794.62 175.23L794.09 172.21Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M791.93 182.042L788.641 185.997L786.227 193.062L787.258 196.008L790.589 192.082L792.873 185.171L791.93 182.042Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M788.092 183.057L785.092 187.289L782.398 194.429L783.007 197.255L786.228 193.061L788.641 185.997L788.092 183.057Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M786.225 193.059L783.003 197.252L780.596 204.235L781.739 206.983L785.159 202.951L787.256 196.006L786.225 193.059Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M782.398 194.426L779.332 198.689L776.491 205.779L777.19 208.433L780.599 204.234L783.006 197.252L782.398 194.426Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M870.569 144.176L865.145 146.445L861.115 149.179L862.931 150.37L868.323 147.696L871.737 144.253L870.569 144.176Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M868.446 147.609L862.935 150.371L859.238 154.325L860.934 155.955L866.569 152.559L869.537 148.842L868.446 147.609Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M876.244 141.693L871.739 144.254L868.444 147.608L869.534 148.841L873.117 147.917L877.214 143.364L876.244 141.693Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M863.966 145.705L858.652 146.873L854.344 149.145L855.837 150.812L861.115 149.178L865.263 146.357L863.966 145.705Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M861.118 149.179L855.84 150.814L851.818 153.918L853.538 156.068L859.237 154.324L862.933 150.371L861.118 149.179Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M851.818 153.918L846.074 154.777L841.908 158.025L843.677 160.995L849.569 159.948L853.538 156.068L851.818 153.918Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M844.489 152.278L838.68 152.342L834.313 155.111L835.951 158.236L841.907 158.025L846.073 154.776L844.489 152.278Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M841.906 158.026L835.949 158.237L831.608 161.502L833.38 165.042L839.496 164.813L843.675 160.995L841.906 158.026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M834.317 155.11L828.329 154.84L823.103 158.271L824.638 161.728L831.614 161.5L835.955 158.235L834.317 155.11Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M823.101 158.272L816.572 159.265L812.03 164.216L813.309 167.769L819.334 166.304L824.635 161.729L823.101 158.272Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M819.336 166.303L813.312 167.767L809.301 173.344L810.642 177.071L816.112 175.248L820.845 170.029L819.336 166.303Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M809.3 173.344L804.549 175.684L801.53 181.966L802.838 185.573L807.156 183.04L810.64 177.072L809.3 173.344Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M803.373 172.172L799.206 175.067L796.443 181.635L797.63 185.003L801.529 181.966L804.548 175.684L803.373 172.172Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M801.53 181.966L797.631 185.004L795.305 191.703L796.679 195.102L800.278 192.024L802.838 185.573L801.53 181.966Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M795.304 191.704L791.863 195.235L789.922 202.07L791.423 205.205L794.713 201.778L796.678 195.103L795.304 191.704Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M790.588 192.08L787.258 196.006L785.161 202.951L786.571 205.854L789.922 202.069L791.865 195.233L790.588 192.08Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M789.921 202.069L786.57 205.854L784.684 212.541L786.34 215.396L789.708 211.846L791.423 205.204L789.921 202.069Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M785.162 202.951L781.741 206.984L779.564 213.742L781.148 216.447L784.687 212.541L786.572 205.854L785.162 202.951Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M859.237 154.325L853.537 156.068L849.568 159.947L851.281 162.552L857.278 160.625L860.932 155.955L859.237 154.325Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M847.416 167.129L841.353 168.207L837.024 172.318L838.826 175.929L845.027 174.998L849.406 170.286L847.416 167.129Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M857.274 160.626L851.277 162.552L847.425 167.111L849.402 170.288L854.351 167.845L858.73 163.133L857.274 160.626Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M839.495 164.813L833.379 165.041L827.933 169.057L829.628 172.835L837.021 172.317L841.35 168.207L839.495 164.813Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M837.024 172.318L829.631 172.836L823.921 177.696L825.413 181.548L832.835 180.447L838.826 175.931L837.024 172.318Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M827.933 169.058L820.839 170.031L816.106 175.25L817.543 179.108L823.919 177.696L829.629 172.835L827.933 169.058Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M823.922 177.695L817.547 179.107L813.366 184.753L814.658 188.645L820.28 186.877L825.414 181.546L823.922 177.695Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M813.361 184.752L808.485 186.838L805.479 193.021L806.71 196.828L810.966 194.558L814.653 188.644L813.361 184.752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M807.156 183.04L802.838 185.572L800.278 192.023L801.628 195.656L805.484 193.022L808.49 186.839L807.156 183.04Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M805.482 193.024L801.626 195.658L799.442 202.142L800.711 205.775L804.091 203.114L806.712 196.831L805.482 193.024Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M799.442 202.141L796.159 205.171L794.433 211.726L795.804 215.132L798.772 212.22L800.712 205.775L799.442 202.141Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M794.712 201.776L791.422 205.203L789.707 211.846L791.294 214.967L794.432 211.725L796.158 205.17L794.712 201.776Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M794.432 211.726L791.295 214.969L789.643 221.367L791.139 224.528L794.143 221.539L795.803 215.132L794.432 211.726Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M789.71 211.848L786.341 215.397L784.51 221.752L786.193 224.649L789.645 221.367L791.296 214.969L789.71 211.848Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M794.14 221.538L791.137 224.528L789.331 230.699L790.425 233.822L793.48 231.344L795.254 225.018L794.14 221.538Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M842.234 183.019L834.455 184.024L828.091 189.065L829.192 192.636L837.359 190.948L843.764 186.331L842.234 183.019Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M832.838 180.446L825.415 181.546L820.281 186.877L821.488 190.711L828.092 189.063L834.457 184.022L832.838 180.446Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M845.028 175L838.828 175.93L832.837 180.447L834.497 183.95L841.865 183.096L847.251 178.183L845.028 175Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M828.09 189.064L821.485 190.711L816.86 196.374L817.672 200.145L823.958 198.178L829.191 192.635L828.09 189.064Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M816.861 196.374L812.013 198.43L808.717 204.519L809.377 208.362L814.134 206.119L817.674 200.145L816.861 196.374Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M810.971 194.558L806.715 196.828L804.095 203.111L805.093 206.912L808.718 204.518L812.014 198.429L810.971 194.558Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M808.716 204.519L805.091 206.912L802.714 213.244L803.32 217.07L806.928 214.589L809.376 208.362L808.716 204.519Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M802.713 213.244L799.805 215.877L797.927 222.276L798.539 226.032L801.414 223.392L803.318 217.069L802.713 213.244Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M798.77 212.218L795.801 215.13L794.141 221.537L795.254 225.017L797.927 222.275L799.805 215.876L798.77 212.218Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M797.927 222.276L795.256 225.019L793.482 231.344L794.135 235.049L796.675 232.314L798.539 226.032L797.927 222.276Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M793.484 231.345L790.429 233.823L788.189 240.284L788.961 243.55L792.017 241.072L794.137 235.05L793.484 231.345Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M823.961 198.178L817.676 200.145L814.136 206.119L817.115 210.556L823.774 209.107L827.214 202.676L823.961 198.178Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M814.133 206.118L809.376 208.362L806.928 214.589L809.312 218.804L814.582 217.04L817.112 210.555L814.133 206.118Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M806.928 214.59L803.32 217.071L801.415 223.393L803.006 227.293L807.159 225.214L809.311 218.805L806.928 214.59Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M801.415 223.393L798.541 226.032L796.675 232.314L797.397 235.874L800.764 233.523L803.006 227.292L801.415 223.393Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M802.713 213.244L799.805 215.877L797.927 222.276L798.539 226.032L801.414 223.392L803.318 217.069L802.713 213.244Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M774.517 214.943L770.574 218.294L767.224 224.303L768.509 226.763L772.947 223.602L775.738 217.3L774.517 214.943Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M780.535 204.311L777.187 208.433L774.517 214.943L775.738 217.3L779.561 213.741L781.777 206.933L780.535 204.311Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M776.486 205.78L772.535 209.4L769.784 215.969L770.573 218.294L774.516 214.943L777.186 208.433L776.486 205.78Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M769.784 215.969L765.863 218.987L761.781 224.402L762.48 227.055L767.224 224.304L770.574 218.295L769.784 215.969Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M767.228 224.304L762.531 227.034L758.392 231.601L759.587 234.161L765.059 231.929L768.513 226.764L767.228 224.304Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M758.39 231.6L752.935 233.313L748.828 237.741L749.731 240.174L755.201 238.258L759.584 234.159L758.39 231.6Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M752.449 230.541L748.296 232.206L744.522 237.315L744.528 239.905L748.829 237.742L752.937 233.314L752.449 230.541Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M761.784 224.402L756.935 227.159L752.449 230.541L752.937 233.314L758.392 231.6L762.484 227.056L761.784 224.402Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M748.83 237.741L744.528 239.904L741.113 243.698L742.689 245.766L745.662 244.63L749.734 240.174L748.83 237.741Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M772.945 223.604L775.736 217.302L779.558 213.742L781.133 216.454L778.974 222.396",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M772.951 223.603L768.513 226.763L765.059 231.928L766.745 234.254L771.856 231.524L774.686 225.988L772.951 223.603Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M771.855 231.523L766.744 234.253L762.885 238.796L764.756 241.105L770.499 238.943L773.734 233.922L771.855 231.523Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M762.886 238.795L756.737 240.575L752.356 244.794L753.9 247.112L760.212 245.238L764.756 241.105L762.886 238.795Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M755.2 238.26L749.731 240.175L745.634 244.645L746.684 246.909L752.353 244.797L756.734 240.578L755.2 238.26Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M762.886 238.795L756.737 240.575L752.356 244.794L753.9 247.112L760.212 245.238L764.756 241.105L762.886 238.795Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M784.364 230.705L780.197 233.592L777.457 239.006L779.12 241.792L783.464 239.306L785.861 233.562L784.364 230.705Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M778.356 230.973L773.735 233.924L770.5 238.946L772.381 241.423L777.46 239.008L780.2 233.593L778.356 230.973Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M777.46 239.007L772.381 241.423L768.448 246.026L770.07 248.765L775.671 246.928L779.123 241.793L777.46 239.007Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M768.446 246.026L761.966 247.716L757.018 252.093L758.414 254.889L765.031 253.286L770.069 248.765L768.446 246.026Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M760.208 245.241L753.896 247.114L749.25 251.67L750.544 253.898L757.015 252.093L761.962 247.716L760.208 245.241Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M788.183 240.183L784.707 242.488L781.58 248.105L782.19 251.738L785.802 249.539L788.958 243.549L788.183 240.183Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M796.326 242.695L792.061 244.378L788.208 250.644L788.418 254.23L792.301 252.172L795.41 246.921L796.326 242.695Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M783.449 239.269L784.723 242.428L781.568 248.104L777.109 250.084L775.625 247.045",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M789.325 230.66L785.939 233.416L783.449 239.27L784.723 242.429L788.186 240.183L790.429 233.822L789.325 230.66Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M778.974 222.395L774.68 225.988L771.85 231.524L773.73 233.924L778.351 230.972L780.683 225.16L778.974 222.395Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M784.496 221.754L780.764 224.985L778.395 231.047L780.18 233.639L784.365 230.705L786.191 224.674L784.496 221.754Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M792.015 241.07L788.96 243.548L785.793 249.586L785.276 252.682L788.211 250.643L792.063 244.378L792.015 241.07Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M745.905 230.701L740.747 230.979L736.359 232.428L737.342 233.737L742.623 233.007L746.799 231.402L745.905 230.701Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M742.624 233.008L737.342 233.738L733.062 235.469L734.296 236.819L739.696 235.641L743.74 233.537L742.624 233.008Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M736.356 232.43L731.003 232.242L726.504 233.78L727.574 235.668L733.058 235.469L737.339 233.738L736.356 232.43Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M733.06 235.468L727.576 235.667L723.203 237.615L724.543 239.715L730.154 239.153L734.294 236.818L733.06 235.468Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M726.504 233.78L720.986 233.335L716.394 235.096L717.536 237.447L723.202 237.616L727.575 235.667L726.504 233.78Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M723.202 237.615L717.536 237.445L713.071 239.66L714.486 242.35L720.296 242.286L724.541 239.715L723.202 237.615Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M745.882 233.206L741.779 235.168L737.174 239.24L738.891 240.515L744.523 237.314L746.811 234.16L745.882 233.206Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M730.152 239.154L724.541 239.715L720.295 242.286L721.88 244.785L727.624 243.926L731.646 240.822L730.152 239.154Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M720.301 242.285L714.492 242.35L710.125 245.119L711.763 248.244L717.72 248.033L721.886 244.784L720.301 242.285Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M953.037 82.5721C953.197 82.2061 953.626 82.0375 953.996 82.1952C954.366 82.3532 954.536 82.7779 954.377 83.1437C954.217 83.5097 953.788 83.6783 953.418 83.5207C953.048 83.3626 952.878 82.9384 953.037 82.5721Z",
    stroke: "white"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M753.045 246.896C753.205 246.53 753.634 246.362 754.004 246.519C754.374 246.677 754.544 247.102 754.385 247.468C754.225 247.834 753.795 248.002 753.426 247.845C753.079 247.697 752.907 247.315 753.019 246.965L753.045 246.896Z",
    stroke: "white"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M772.982 233.9C773.142 233.534 773.572 233.366 773.941 233.523C774.311 233.681 774.482 234.106 774.322 234.472C774.162 234.838 773.733 235.007 773.363 234.849C773.016 234.701 772.845 234.318 772.956 233.969L772.982 233.9Z",
    stroke: "white"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M746.498 231.756C746.658 231.39 747.087 231.221 747.457 231.379C747.827 231.537 747.997 231.961 747.838 232.327C747.678 232.693 747.248 232.862 746.879 232.704C746.509 232.547 746.338 232.122 746.498 231.756Z",
    stroke: "white"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M952.85 102.989C952.806 102.618 953.055 102.279 953.416 102.2L953.49 102.188C953.864 102.145 954.207 102.391 954.287 102.748L954.299 102.821C954.342 103.192 954.093 103.53 953.732 103.609L953.659 103.621L953.584 103.626C953.239 103.631 952.936 103.395 952.862 103.061L952.85 102.989Z",
    stroke: "white"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M917.864 145.218C917.749 144.862 917.927 144.482 918.265 144.336L918.336 144.31L918.335 144.309C918.695 144.195 919.079 144.372 919.227 144.707L919.253 144.776C919.376 145.155 919.165 145.562 918.782 145.684L918.782 145.683C918.422 145.798 918.039 145.622 917.89 145.287L917.864 145.218Z",
    stroke: "white"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M936.935 94.9891C936.819 94.6334 936.997 94.2537 937.336 94.1073L937.406 94.0812C937.765 93.967 938.149 94.143 938.297 94.478L938.323 94.5471L938.324 94.5472C938.447 94.9263 938.236 95.333 937.852 95.4552L937.852 95.4547C937.492 95.5691 937.109 95.3931 936.961 95.0582L936.935 94.9891Z",
    stroke: "white"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M911.001 106.042C911.072 105.649 911.451 105.388 911.847 105.458C912.244 105.528 912.507 105.903 912.437 106.295C912.366 106.688 911.987 106.949 911.59 106.879C911.194 106.809 910.93 106.434 911.001 106.042Z",
    stroke: "white"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M894.154 148.939C894.314 148.573 894.743 148.405 895.113 148.562C895.483 148.72 895.653 149.145 895.494 149.511C895.334 149.877 894.905 150.045 894.535 149.888C894.188 149.74 894.017 149.357 894.128 149.008L894.154 148.939Z",
    stroke: "white"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M965.873 130.752C966.033 130.386 966.462 130.217 966.832 130.375C967.202 130.533 967.372 130.958 967.213 131.323C967.053 131.689 966.624 131.858 966.254 131.7C965.907 131.552 965.736 131.17 965.847 130.821L965.873 130.752Z",
    stroke: "white"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M891.201 206.644C891.361 206.278 891.79 206.11 892.16 206.267C892.53 206.426 892.7 206.85 892.541 207.216C892.381 207.582 891.952 207.751 891.582 207.593C891.212 207.435 891.042 207.01 891.201 206.644Z",
    stroke: "white"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M857.678 184.648C857.837 184.282 858.267 184.114 858.636 184.271C859.006 184.429 859.177 184.854 859.017 185.22C858.857 185.586 858.428 185.754 858.058 185.597C857.689 185.439 857.518 185.015 857.678 184.648Z",
    stroke: "white"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M833.67 183.871C833.83 183.505 834.259 183.336 834.629 183.494C834.999 183.652 835.169 184.077 835.01 184.442C834.85 184.809 834.42 184.977 834.051 184.819C833.704 184.671 833.532 184.289 833.644 183.94L833.67 183.871Z",
    stroke: "white"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M872.889 161.58C873.048 161.214 873.478 161.045 873.847 161.203C874.217 161.361 874.388 161.786 874.228 162.152C874.068 162.518 873.639 162.686 873.269 162.528C872.9 162.371 872.729 161.946 872.889 161.58Z",
    stroke: "white"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M899.006 177.798C899.166 177.433 899.595 177.264 899.965 177.422C900.335 177.58 900.505 178.004 900.345 178.37C900.186 178.736 899.756 178.905 899.386 178.747C899.017 178.589 898.846 178.165 899.006 177.798Z",
    stroke: "white"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M868.279 205.805C868.439 205.439 868.868 205.27 869.238 205.428C869.608 205.586 869.778 206.01 869.619 206.376C869.459 206.742 869.03 206.911 868.66 206.753C868.313 206.605 868.142 206.223 868.253 205.874L868.279 205.805Z",
    stroke: "white"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M806.592 238.652C806.752 238.286 807.181 238.118 807.551 238.275C807.921 238.433 808.091 238.858 807.931 239.224C807.772 239.59 807.342 239.758 806.972 239.601C806.602 239.443 806.432 239.018 806.592 238.652Z",
    stroke: "white"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M880.756 236.271C880.916 235.905 881.345 235.737 881.715 235.894C882.085 236.052 882.255 236.477 882.096 236.843C881.936 237.209 881.506 237.377 881.137 237.22C880.79 237.072 880.618 236.69 880.73 236.34L880.756 236.271Z",
    stroke: "white"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M910.068 201.467C910.228 201.101 910.657 200.932 911.027 201.09C911.397 201.248 911.567 201.672 911.408 202.038C911.248 202.404 910.819 202.573 910.449 202.415C910.102 202.267 909.931 201.885 910.042 201.536L910.068 201.467Z",
    stroke: "white"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.79 141.551C1112.95 141.185 1113.38 141.016 1113.75 141.174C1114.12 141.332 1114.29 141.756 1114.13 142.122C1113.97 142.488 1113.54 142.657 1113.17 142.499C1112.82 142.351 1112.65 141.969 1112.76 141.62L1112.79 141.551Z",
    stroke: "white"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M894.905 224.9C895.064 224.534 895.493 224.366 895.863 224.523C896.233 224.681 896.403 225.106 896.244 225.472C896.084 225.838 895.655 226.006 895.285 225.849C894.938 225.701 894.767 225.318 894.878 224.969L894.905 224.9Z",
    stroke: "white"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M928.592 228.445C928.751 228.079 929.181 227.911 929.55 228.068C929.92 228.226 930.091 228.651 929.931 229.017C929.771 229.383 929.343 229.552 928.972 229.394C928.626 229.246 928.454 228.863 928.565 228.515L928.592 228.445Z",
    stroke: "white"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M950.819 225.445C950.978 225.079 951.407 224.911 951.777 225.068C952.147 225.226 952.317 225.651 952.158 226.017C951.998 226.383 951.569 226.551 951.199 226.394C950.829 226.236 950.659 225.811 950.819 225.445Z",
    stroke: "white"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.9 240.781C1235.06 240.415 1235.49 240.247 1235.86 240.404C1236.23 240.562 1236.4 240.987 1236.24 241.353C1236.08 241.719 1235.65 241.888 1235.29 241.73C1234.94 241.582 1234.77 241.199 1234.88 240.85L1234.9 240.781Z",
    stroke: "white"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.97 193.656C1230.13 193.29 1230.56 193.122 1230.93 193.279C1231.3 193.437 1231.47 193.862 1231.31 194.228C1231.15 194.594 1230.73 194.763 1230.36 194.605C1230.01 194.457 1229.84 194.074 1229.95 193.725L1229.97 193.656Z",
    stroke: "white"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.2 195.881C1279.36 195.515 1279.79 195.346 1280.16 195.504C1280.53 195.662 1280.7 196.086 1280.54 196.452C1280.38 196.818 1279.95 196.987 1279.58 196.829C1279.24 196.681 1279.06 196.299 1279.18 195.95L1279.2 195.881Z",
    stroke: "white"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M969.897 183.48C970.056 183.114 970.485 182.946 970.855 183.104C971.225 183.262 971.395 183.686 971.236 184.052C971.076 184.418 970.647 184.587 970.277 184.429C969.931 184.281 969.759 183.898 969.87 183.55L969.897 183.48Z",
    stroke: "white"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M969.857 202.767C970.017 202.402 970.446 202.233 970.816 202.391C971.186 202.549 971.356 202.973 971.197 203.339C971.037 203.705 970.608 203.874 970.238 203.716C969.892 203.568 969.72 203.186 969.831 202.837L969.857 202.767Z",
    stroke: "white"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M965.974 170.246C966.134 169.88 966.564 169.711 966.933 169.869C967.303 170.027 967.474 170.452 967.314 170.818C967.154 171.184 966.725 171.352 966.355 171.194C965.985 171.036 965.815 170.612 965.974 170.246Z",
    stroke: "white"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M949.459 155.613C949.619 155.247 950.048 155.079 950.418 155.236C950.788 155.394 950.958 155.819 950.799 156.185C950.639 156.551 950.209 156.719 949.84 156.562C949.493 156.414 949.321 156.031 949.433 155.682L949.459 155.613Z",
    stroke: "white"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M940.881 120.549C941.041 120.183 941.47 120.014 941.84 120.172C942.21 120.33 942.38 120.754 942.22 121.12C942.061 121.486 941.631 121.655 941.262 121.497C940.892 121.339 940.721 120.915 940.881 120.549Z",
    stroke: "white"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M973.76 117.002C973.919 116.636 974.349 116.467 974.719 116.625C975.088 116.783 975.259 117.208 975.099 117.573C974.939 117.939 974.51 118.108 974.14 117.95C973.77 117.792 973.6 117.368 973.76 117.002Z",
    stroke: "white"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M940.232 177.111C940.392 176.745 940.821 176.577 941.191 176.734C941.561 176.892 941.731 177.317 941.572 177.683C941.412 178.049 940.983 178.217 940.613 178.06C940.243 177.902 940.073 177.477 940.232 177.111Z",
    stroke: "white"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M993.592 139.568C993.752 139.202 994.181 139.034 994.551 139.191C994.921 139.349 995.091 139.774 994.931 140.14C994.772 140.506 994.342 140.675 993.972 140.517C993.603 140.359 993.432 139.934 993.592 139.568Z",
    stroke: "white"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.41 116.639C1002.57 116.273 1003 116.104 1003.37 116.262C1003.74 116.42 1003.91 116.844 1003.75 117.21C1003.59 117.576 1003.16 117.745 1002.79 117.587C1002.42 117.429 1002.25 117.005 1002.41 116.639Z",
    stroke: "white"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M995.959 88.1327C996.119 87.7667 996.548 87.5981 996.918 87.7557C997.288 87.9138 997.458 88.3384 997.299 88.7042C997.139 89.0703 996.71 89.2393 996.34 89.0812C995.97 88.9232 995.8 88.4989 995.959 88.1327Z",
    stroke: "white"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.32 65.6151C1005.48 65.2491 1005.91 65.0805 1006.28 65.2381C1006.65 65.3962 1006.82 65.8209 1006.66 66.1867C1006.5 66.5527 1006.07 66.7217 1005.7 66.5636C1005.33 66.4056 1005.16 65.9813 1005.32 65.6151Z",
    stroke: "white"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.07 55.8046C1038.23 55.4385 1038.66 55.27 1039.03 55.4276C1039.4 55.5857 1039.57 56.0103 1039.41 56.3761C1039.25 56.7421 1038.82 56.9111 1038.45 56.7531C1038.08 56.595 1037.91 56.1708 1038.07 55.8046Z",
    stroke: "white"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.19 14.3964C1064.35 14.0303 1064.78 13.8618 1065.15 14.0194C1065.52 14.1775 1065.69 14.6021 1065.53 14.9679C1065.37 15.3339 1064.94 15.5029 1064.57 15.3449C1064.2 15.1868 1064.03 14.7626 1064.19 14.3964Z",
    stroke: "white"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.46 27.7577C1090.62 27.3917 1091.05 27.2231 1091.42 27.3807C1091.79 27.5388 1091.96 27.9634 1091.8 28.3292C1091.64 28.6953 1091.21 28.8643 1090.84 28.7062C1090.47 28.5482 1090.3 28.1239 1090.46 27.7577Z",
    stroke: "white"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.11 53.7655C1069.27 53.3995 1069.7 53.2309 1070.07 53.3885C1070.44 53.5466 1070.61 53.9713 1070.45 54.3371C1070.29 54.7031 1069.86 54.8721 1069.49 54.714C1069.12 54.556 1068.95 54.1317 1069.11 53.7655Z",
    stroke: "white"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.15 72.6249C1067.31 72.2589 1067.74 72.0903 1068.11 72.2479C1068.48 72.406 1068.65 72.8306 1068.49 73.1964C1068.33 73.5625 1067.9 73.7315 1067.53 73.5734C1067.17 73.4153 1066.99 72.9911 1067.15 72.6249Z",
    stroke: "white"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.22 107.215C1050.38 106.849 1050.81 106.68 1051.18 106.838C1051.55 106.996 1051.72 107.42 1051.56 107.786C1051.4 108.152 1050.98 108.321 1050.61 108.163C1050.24 108.005 1050.07 107.581 1050.22 107.215Z",
    stroke: "white"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.84 130.408C1033 130.042 1033.43 129.873 1033.8 130.031C1034.17 130.189 1034.34 130.614 1034.18 130.98C1034.02 131.346 1033.59 131.515 1033.22 131.357C1032.85 131.199 1032.68 130.774 1032.84 130.408Z",
    stroke: "white"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.74 83.8671C1032.9 83.501 1033.33 83.3325 1033.7 83.4901C1034.07 83.6482 1034.24 84.0728 1034.08 84.4386C1033.92 84.8046 1033.49 84.9736 1033.12 84.8156C1032.75 84.6575 1032.58 84.2333 1032.74 83.8671Z",
    stroke: "white"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M939.967 199.01C940.126 198.644 940.556 198.475 940.925 198.633C941.295 198.791 941.466 199.216 941.306 199.581C941.146 199.947 940.717 200.116 940.347 199.958C940.001 199.81 939.829 199.428 939.94 199.079L939.967 199.01Z",
    stroke: "white"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M915.205 177.469C915.365 177.103 915.794 176.934 916.164 177.092C916.534 177.25 916.704 177.674 916.545 178.04C916.385 178.406 915.956 178.575 915.586 178.417C915.239 178.269 915.068 177.887 915.179 177.538L915.205 177.469Z",
    stroke: "white"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M822.514 212.957C822.673 212.591 823.103 212.422 823.472 212.58C823.842 212.738 824.013 213.163 823.853 213.528C823.693 213.894 823.264 214.063 822.894 213.905C822.524 213.747 822.354 213.323 822.514 212.957Z",
    stroke: "white"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M862.06 229.867C862.22 229.501 862.65 229.332 863.019 229.49C863.389 229.648 863.56 230.073 863.4 230.439C863.24 230.805 862.811 230.973 862.441 230.816C862.071 230.658 861.901 230.233 862.06 229.867Z",
    stroke: "white"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M852.211 148.34L852.247 148.276C852.449 147.961 852.858 147.854 853.189 148.017L853.254 148.053C853.573 148.253 853.681 148.658 853.515 148.985L853.479 149.049C853.276 149.365 852.868 149.472 852.537 149.308L852.472 149.272C852.154 149.072 852.045 148.668 852.211 148.34Z",
    stroke: "white"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.72 183.086C1161.88 182.719 1162.31 182.55 1162.68 182.709C1163.05 182.866 1163.22 183.292 1163.06 183.657C1162.9 184.022 1162.47 184.191 1162.1 184.034C1161.73 183.877 1161.56 183.452 1161.72 183.086Z",
    stroke: "white"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.02 2.65388C1159.18 2.2888 1159.61 2.12022 1159.98 2.27691C1160.35 2.43401 1160.52 2.85965 1160.36 3.22472C1160.2 3.59219 1159.77 3.76077 1159.4 3.60169C1159.06 3.45491 1158.88 3.07255 1159 2.72352L1159.02 2.65388Z",
    stroke: "white"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.74 16.3615C1141.9 15.9964 1142.33 15.8278 1142.7 15.9845C1143.07 16.1416 1143.24 16.5672 1143.08 16.9323C1142.92 17.2998 1142.49 17.4684 1142.13 17.3093C1141.75 17.1522 1141.59 16.7265 1141.74 16.3615Z",
    stroke: "white"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.1 42.431C1168.26 42.066 1168.69 41.8974 1169.06 42.0545C1169.43 42.2136 1169.6 42.6368 1169.44 43.0043C1169.28 43.3694 1168.85 43.5379 1168.48 43.3788C1168.11 43.2217 1167.94 42.7989 1168.1 42.431Z",
    stroke: "white"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.51 63.0053C1147.67 62.6402 1148.1 62.4716 1148.47 62.6287C1148.84 62.7878 1149.01 63.211 1148.85 63.5785C1148.69 63.9436 1148.26 64.1126 1147.9 63.9531C1147.52 63.7964 1147.35 63.3731 1147.51 63.0053Z",
    stroke: "white"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.16 80.5816C1134.32 80.2165 1134.75 80.0479 1135.12 80.205C1135.49 80.3641 1135.66 80.7874 1135.5 81.1548C1135.34 81.5199 1134.91 81.6885 1134.54 81.5294C1134.2 81.3826 1134.02 81.0002 1134.14 80.6516L1134.16 80.5816Z",
    stroke: "white"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.12 44.0075C1133.28 43.642 1133.71 43.4735 1134.08 43.6306C1134.45 43.7897 1134.62 44.2129 1134.46 44.5804C1134.3 44.9454 1133.87 45.1144 1133.51 44.9549C1133.13 44.7982 1132.96 44.375 1133.12 44.0075Z",
    stroke: "white"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.01 186.307C1141.96 185.935 1142.21 185.598 1142.57 185.518L1142.65 185.506C1143.02 185.464 1143.36 185.709 1143.44 186.067L1143.46 186.139C1143.5 186.51 1143.25 186.847 1142.89 186.928L1142.82 186.939L1142.74 186.944C1142.4 186.949 1142.09 186.714 1142.02 186.379L1142.01 186.307Z",
    stroke: "white"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.41 35.4887C1212.3 35.131 1212.47 34.7514 1212.81 34.6063L1212.88 34.5807C1213.24 34.4661 1213.62 34.6428 1213.77 34.9769L1213.8 35.0451C1213.92 35.4261 1213.71 35.8311 1213.33 35.9531C1212.97 36.0677 1212.59 35.8905 1212.44 35.5564L1212.41 35.4887Z",
    stroke: "white"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.48 213.296C1131.55 212.904 1131.93 212.642 1132.33 212.713C1132.72 212.781 1132.99 213.157 1132.92 213.549C1132.84 213.943 1132.47 214.202 1132.07 214.134C1131.67 214.063 1131.41 213.688 1131.48 213.296Z",
    stroke: "white"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.09 6.58578C1234.25 6.21975 1234.68 6.05119 1235.05 6.20883C1235.42 6.36689 1235.59 6.79154 1235.43 7.15733C1235.27 7.52337 1234.84 7.69196 1234.47 7.53431C1234.13 7.38634 1233.95 7.00398 1234.07 6.65495L1234.09 6.58578Z",
    stroke: "white"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.53 27.9454C1236.69 27.5804 1237.12 27.4118 1237.49 27.5685C1237.86 27.7256 1238.03 28.1512 1237.87 28.5163C1237.71 28.8838 1237.28 29.0523 1236.91 28.8933C1236.54 28.7362 1236.37 28.3105 1236.53 27.9454Z",
    stroke: "white"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.6 14.7007C1309.76 14.3357 1310.19 14.1671 1310.56 14.3238C1310.93 14.4833 1311.1 14.9065 1310.94 15.274C1310.78 15.6391 1310.35 15.8076 1309.98 15.6486C1309.63 15.5018 1309.46 15.1194 1309.57 14.7704L1309.6 14.7007Z",
    stroke: "white"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.81 34.5001C1313.97 34.1351 1314.4 33.9665 1314.77 34.1232C1315.14 34.2827 1315.31 34.7059 1315.15 35.0734C1314.99 35.4385 1314.56 35.607 1314.19 35.4479C1313.82 35.2908 1313.65 34.8652 1313.81 34.5001Z",
    stroke: "white"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.11 10.8368C1328.27 10.4718 1328.7 10.3032 1329.07 10.4598C1329.44 10.6193 1329.61 11.0422 1329.45 11.41C1329.29 11.7751 1328.86 11.9437 1328.49 11.7866C1328.12 11.6275 1327.95 11.2043 1328.11 10.8368Z",
    stroke: "white"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M1426.51 20.9215C1426.66 20.5564 1427.09 20.3878 1427.47 20.5445C1427.84 20.7016 1428.01 21.1272 1427.85 21.4923C1427.68 21.8598 1427.26 22.0288 1426.89 21.8693C1426.54 21.7225 1426.37 21.3401 1426.48 20.9911L1426.51 20.9215Z",
    stroke: "white"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.01 11.4097C1412.17 11.0447 1412.6 10.8761 1412.97 11.0328C1413.34 11.1899 1413.51 11.6155 1413.36 11.9806C1413.19 12.3481 1412.76 12.517 1412.4 12.3575C1412.05 12.2108 1411.88 11.8284 1411.99 11.4794L1412.01 11.4097Z",
    stroke: "white"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M1430 62.3785C1430.16 62.0134 1430.59 61.8448 1430.96 62.0015C1431.33 62.1586 1431.5 62.5843 1431.34 62.9493C1431.18 63.3168 1430.75 63.4858 1430.38 63.3263C1430.03 63.1795 1429.86 62.7972 1429.97 62.4481L1430 62.3785Z",
    stroke: "white"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.35 42.6441C1398.5 42.279 1398.93 42.1105 1399.31 42.2671C1399.68 42.4242 1399.85 42.8499 1399.69 43.215C1399.52 43.5824 1399.1 43.7514 1398.73 43.5919C1398.38 43.4451 1398.21 43.0628 1398.32 42.7138L1398.35 42.6441Z",
    stroke: "white"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.52 0.12833C1364.68 -0.236744 1365.11 -0.40532 1365.48 -0.248634C1365.84 -0.0891343 1366.02 0.334108 1365.85 0.701578C1365.7 1.06665 1365.27 1.23523 1364.9 1.07614C1364.53 0.91904 1364.36 0.496217 1364.52 0.12833Z",
    stroke: "white"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.23 63.3439C1378.39 62.9788 1378.82 62.8102 1379.19 62.9669C1379.56 63.124 1379.73 63.5497 1379.57 63.9147C1379.41 64.2822 1378.98 64.4508 1378.61 64.2917C1378.24 64.135 1378.07 63.709 1378.23 63.3439Z",
    stroke: "white"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.71 53.1642C1169.87 52.7967 1170.3 52.6282 1170.67 52.7872C1171.04 52.9443 1171.21 53.3699 1171.05 53.735C1170.9 54.1001 1170.47 54.2687 1170.09 54.112C1169.72 53.9549 1169.55 53.5297 1169.71 53.1642Z",
    stroke: "white"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.14 38.34C1275.3 37.9749 1275.73 37.8063 1276.1 37.963C1276.46 38.1225 1276.64 38.5458 1276.47 38.9132C1276.32 39.2783 1275.89 39.4469 1275.52 39.2878C1275.15 39.1307 1274.98 38.705 1275.14 38.34Z",
    stroke: "white"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.93 157.233C1218.09 156.867 1218.52 156.699 1218.89 156.856C1219.27 157.013 1219.43 157.438 1219.28 157.803C1219.11 158.171 1218.68 158.339 1218.32 158.18C1217.95 158.023 1217.78 157.598 1217.93 157.233Z",
    stroke: "white"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.48 192.045C1205.64 191.68 1206.07 191.511 1206.44 191.668C1206.81 191.825 1206.98 192.251 1206.82 192.616C1206.66 192.983 1206.23 193.152 1205.86 192.993C1205.49 192.836 1205.32 192.41 1205.48 192.045Z",
    stroke: "white"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.5 228.977C1181.66 228.612 1182.08 228.443 1182.46 228.6C1182.83 228.757 1183 229.182 1182.84 229.548C1182.68 229.915 1182.25 230.084 1181.88 229.925C1181.51 229.767 1181.34 229.342 1181.5 228.977Z",
    stroke: "white"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.25 240.166C1144.41 239.801 1144.83 239.632 1145.21 239.789C1145.58 239.946 1145.75 240.372 1145.59 240.737C1145.43 241.104 1145 241.273 1144.63 241.114C1144.26 240.957 1144.09 240.531 1144.25 240.166Z",
    stroke: "white"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.15 173.106C1265.31 172.741 1265.74 172.572 1266.11 172.729C1266.48 172.886 1266.65 173.311 1266.49 173.676C1266.33 174.044 1265.9 174.212 1265.54 174.053C1265.16 173.896 1265 173.471 1265.15 173.106Z",
    stroke: "white"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.89 167.621C1312.05 167.256 1312.48 167.088 1312.85 167.244C1313.22 167.401 1313.39 167.827 1313.23 168.192C1313.07 168.56 1312.64 168.728 1312.27 168.569C1311.9 168.412 1311.73 167.986 1311.89 167.621Z",
    stroke: "white"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.29 201.336C1323.45 200.971 1323.88 200.802 1324.25 200.959C1324.62 201.116 1324.79 201.542 1324.64 201.907C1324.47 202.274 1324.04 202.443 1323.68 202.284C1323.3 202.127 1323.14 201.701 1323.29 201.336Z",
    stroke: "white"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.98 147.594C1353.14 147.229 1353.57 147.06 1353.94 147.217C1354.31 147.374 1354.48 147.8 1354.32 148.165C1354.16 148.532 1353.73 148.701 1353.36 148.542C1352.99 148.385 1352.82 147.959 1352.98 147.594Z",
    stroke: "white"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.59 143.453C1387.75 143.088 1388.18 142.92 1388.55 143.076C1388.92 143.233 1389.09 143.659 1388.93 144.024C1388.77 144.392 1388.34 144.56 1387.97 144.401C1387.6 144.244 1387.43 143.818 1387.59 143.453Z",
    stroke: "white"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.81 150.727C1414.97 150.362 1415.4 150.193 1415.77 150.35C1416.14 150.507 1416.31 150.932 1416.15 151.298C1415.99 151.665 1415.56 151.834 1415.19 151.675C1414.82 151.517 1414.65 151.092 1414.81 150.727Z",
    stroke: "white"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.48 182.649C1365.64 182.283 1366.07 182.115 1366.44 182.272C1366.81 182.429 1366.98 182.854 1366.82 183.219C1366.66 183.587 1366.23 183.755 1365.86 183.596C1365.49 183.439 1365.32 183.014 1365.48 182.649Z",
    stroke: "white"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.69 32.2045C1295.85 31.8394 1296.28 31.6709 1296.65 31.8275C1297.02 31.987 1297.19 32.4103 1297.03 32.7778C1296.87 33.1428 1296.44 33.3114 1296.08 33.1523C1295.7 32.9952 1295.53 32.5724 1295.69 32.2045Z",
    stroke: "white"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.29 45.631C1251.44 45.2659 1251.87 45.0973 1252.25 45.254C1252.61 45.4135 1252.79 45.8368 1252.62 46.2042C1252.47 46.5693 1252.04 46.7379 1251.67 46.5788C1251.3 46.4217 1251.13 45.9961 1251.29 45.631Z",
    stroke: "white"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M1302.39 81.4865C1302.55 81.1214 1302.98 80.9528 1303.35 81.1095C1303.72 81.2666 1303.89 81.6922 1303.73 82.0573C1303.57 82.4248 1303.14 82.5934 1302.77 82.4343C1302.4 82.2772 1302.23 81.8519 1302.39 81.4865Z",
    stroke: "white"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.29 63.2729C1259.45 62.9078 1259.88 62.7392 1260.25 62.8959C1260.61 63.055 1260.79 63.4786 1260.62 63.8457C1260.47 64.2112 1260.04 64.3798 1259.67 64.2203C1259.3 64.0636 1259.13 63.6403 1259.29 63.2729Z",
    stroke: "white"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.76 6.74427C1288.92 6.3792 1289.35 6.21062 1289.72 6.36731C1290.09 6.52681 1290.26 6.95005 1290.1 7.31752C1289.94 7.68259 1289.51 7.85117 1289.14 7.69208C1288.77 7.53498 1288.6 7.10935 1288.76 6.74427Z",
    stroke: "white"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.05 136.096L1256.08 136.032C1256.29 135.716 1256.69 135.609 1257.03 135.773L1257.09 135.809C1257.41 136.009 1257.52 136.414 1257.35 136.74L1257.32 136.805C1257.11 137.121 1256.7 137.228 1256.37 137.064L1256.31 137.028C1255.99 136.828 1255.88 136.422 1256.05 136.096Z",
    stroke: "white"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.47 60.4725L1292.51 60.4088C1292.71 60.0928 1293.12 59.9853 1293.45 60.1491L1293.51 60.1874C1293.83 60.3852 1293.94 60.7907 1293.77 61.1169L1293.73 61.1834C1293.54 61.497 1293.13 61.6041 1292.8 61.4403L1292.73 61.4048C1292.41 61.2042 1292.3 60.8011 1292.47 60.4725Z",
    stroke: "white"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.73 114.082L1255.77 114.019C1255.97 113.703 1256.38 113.595 1256.71 113.759L1256.78 113.795C1257.1 113.996 1257.2 114.401 1257.04 114.727L1257 114.79C1256.8 115.106 1256.39 115.214 1256.06 115.05L1255.99 115.015C1255.68 114.814 1255.57 114.409 1255.73 114.082Z",
    stroke: "white"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.51 123.343C1350.43 122.953 1350.67 122.567 1351.07 122.481C1351.46 122.394 1351.85 122.64 1351.93 123.029C1352.02 123.417 1351.78 123.802 1351.38 123.889C1350.99 123.978 1350.6 123.733 1350.51 123.343Z",
    stroke: "white"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.37 79.6078L1398.4 79.5441C1398.61 79.2281 1399.02 79.1206 1399.35 79.2844L1399.41 79.3203C1399.73 79.5209 1399.84 79.926 1399.67 80.2522L1399.64 80.3159C1399.43 80.6318 1399.02 80.7393 1398.69 80.5755L1398.63 80.5401C1398.31 80.3394 1398.2 79.9339 1398.37 79.6078Z",
    stroke: "white"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.3 128.6L1319.33 128.536C1319.54 128.22 1319.94 128.113 1320.28 128.277L1320.34 128.312C1320.66 128.513 1320.77 128.919 1320.6 129.244L1320.57 129.308C1320.36 129.624 1319.95 129.731 1319.62 129.568L1319.56 129.532C1319.24 129.332 1319.13 128.926 1319.3 128.6Z",
    stroke: "white"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.94 62.6878L1313.98 62.6241C1314.18 62.3082 1314.59 62.2007 1314.92 62.3644L1314.99 62.4003C1315.33 62.6154 1315.43 63.0604 1315.21 63.3964C1315.01 63.7123 1314.6 63.8194 1314.27 63.6556L1314.21 63.6202C1313.89 63.4195 1313.78 63.014 1313.94 62.6878Z",
    stroke: "white"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.34 94.5359C1408.17 94.177 1408.32 93.7475 1408.69 93.5757C1409.06 93.4043 1409.49 93.5596 1409.66 93.9181C1409.83 94.2794 1409.68 94.7093 1409.31 94.8808C1408.95 95.0502 1408.52 94.8972 1408.34 94.5359Z",
    stroke: "white"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.76 87.2386L1351.79 87.1749C1352 86.859 1352.41 86.7514 1352.74 86.9152L1352.8 86.9511C1353.12 87.1514 1353.23 87.5568 1353.06 87.883L1353.03 87.9471C1352.82 88.2631 1352.41 88.3702 1352.08 88.2064L1352.02 88.171C1351.7 87.9703 1351.59 87.5648 1351.76 87.2386Z",
    stroke: "white"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.87 101.524L1316.9 101.46C1317.11 101.144 1317.52 101.037 1317.85 101.2L1317.91 101.236C1318.23 101.437 1318.34 101.842 1318.17 102.168L1318.14 102.232C1317.93 102.548 1317.52 102.655 1317.19 102.492L1317.13 102.456C1316.81 102.255 1316.7 101.85 1316.87 101.524Z",
    stroke: "white"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.85 110.006L1386.89 109.942C1387.09 109.627 1387.5 109.519 1387.83 109.683L1387.9 109.719C1388.21 109.919 1388.32 110.324 1388.16 110.651L1388.12 110.715C1387.92 111.031 1387.51 111.138 1387.18 110.974L1387.11 110.939C1386.79 110.738 1386.69 110.332 1386.85 110.006Z",
    stroke: "white"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.15 115.68L1417.19 115.616C1417.39 115.3 1417.8 115.193 1418.13 115.357L1418.2 115.393C1418.51 115.593 1418.62 115.998 1418.46 116.324L1418.42 116.389C1418.22 116.705 1417.81 116.812 1417.48 116.648L1417.41 116.612C1417.09 116.412 1416.99 116.006 1417.15 115.68Z",
    stroke: "white"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.86 169.25L1191.89 169.187C1192.1 168.871 1192.51 168.763 1192.84 168.927L1192.9 168.963C1193.22 169.163 1193.33 169.569 1193.16 169.895L1193.13 169.959C1192.93 170.275 1192.52 170.382 1192.19 170.218L1192.12 170.183C1191.8 169.982 1191.7 169.577 1191.86 169.25Z",
    stroke: "white"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.28 123.188C1290.19 122.798 1290.44 122.412 1290.83 122.326C1291.22 122.239 1291.61 122.484 1291.7 122.872C1291.79 123.262 1291.54 123.647 1291.15 123.734C1290.75 123.821 1290.37 123.575 1290.28 123.188Z",
    stroke: "white"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.95 98.8421L1265.99 98.7784C1266.19 98.4625 1266.6 98.355 1266.93 98.5187L1267 98.5546C1267.32 98.7549 1267.42 99.1604 1267.26 99.4865L1267.22 99.5507C1267.02 99.8666 1266.61 99.9737 1266.28 99.8099L1266.21 99.7745C1265.9 99.5738 1265.79 99.1683 1265.95 98.8421Z",
    stroke: "white"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.17 61.4643C1193.33 61.0992 1193.76 60.9306 1194.13 61.0873C1194.5 61.2468 1194.67 61.67 1194.51 62.0375C1194.35 62.4026 1193.92 62.5712 1193.55 62.4121C1193.18 62.2554 1193.01 61.8317 1193.17 61.4643Z",
    stroke: "white"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.06 103.373C1135.22 103.008 1135.65 102.84 1136.02 102.996C1136.39 103.153 1136.56 103.579 1136.4 103.944C1136.24 104.311 1135.81 104.48 1135.44 104.321C1135.07 104.164 1134.9 103.739 1135.06 103.373Z",
    stroke: "white"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.33 92.84C1123.49 92.4749 1123.92 92.3063 1124.29 92.463C1124.66 92.6201 1124.83 93.0458 1124.67 93.4108C1124.51 93.7783 1124.08 93.9469 1123.72 93.7878C1123.34 93.6307 1123.18 93.2055 1123.33 92.84Z",
    stroke: "white"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.55 93.3123L1159.58 93.2486C1159.79 92.9327 1160.2 92.8252 1160.53 92.9889L1160.59 93.0272C1160.91 93.2251 1161.02 93.6306 1160.85 93.9567L1160.81 94.0233C1160.61 94.3368 1160.2 94.4439 1159.87 94.2801L1159.81 94.2447C1159.49 94.044 1159.38 93.6409 1159.55 93.3123Z",
    stroke: "white"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.53 147.77L1156.56 147.706C1156.77 147.39 1157.18 147.283 1157.51 147.446L1157.57 147.482C1157.89 147.683 1158 148.089 1157.83 148.414L1157.8 148.478C1157.59 148.794 1157.18 148.901 1156.85 148.738L1156.79 148.702C1156.47 148.502 1156.36 148.096 1156.53 147.77Z",
    stroke: "white"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.09 110.291C1201 109.901 1201.25 109.516 1201.64 109.429C1202.03 109.343 1202.42 109.588 1202.51 109.975C1202.6 110.365 1202.35 110.751 1201.96 110.837C1201.57 110.924 1201.18 110.679 1201.09 110.291Z",
    stroke: "white"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.58 90.7018L1227.61 90.6377C1227.82 90.3218 1228.23 90.2147 1228.56 90.3784L1228.62 90.4143C1228.94 90.6146 1229.05 91.0177 1228.88 91.3463L1228.85 91.41C1228.64 91.7259 1228.23 91.833 1227.9 91.6696L1227.84 91.6337C1227.52 91.4335 1227.41 91.028 1227.58 90.7018Z",
    stroke: "white"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.82 153.809L1186.86 153.745C1187.06 153.429 1187.47 153.322 1187.8 153.486L1187.86 153.521C1188.18 153.722 1188.29 154.128 1188.13 154.453L1188.09 154.517C1187.89 154.833 1187.48 154.94 1187.15 154.777L1187.08 154.741C1186.76 154.541 1186.66 154.135 1186.82 153.809Z",
    stroke: "white"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.98 114.185L1170.02 114.122C1170.22 113.806 1170.63 113.698 1170.96 113.862L1171.03 113.9C1171.37 114.113 1171.47 114.558 1171.25 114.896C1171.05 115.21 1170.64 115.317 1170.31 115.153L1170.25 115.118C1169.93 114.917 1169.82 114.514 1169.98 114.185Z",
    stroke: "white"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.33 85.1241C1204.16 84.7628 1204.32 84.3333 1204.68 84.1615C1205.04 83.9925 1205.48 84.1454 1205.65 84.5063C1205.83 84.8652 1205.67 85.2951 1205.31 85.4666C1204.94 85.6384 1204.51 85.483 1204.33 85.1241Z",
    stroke: "white"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.16 73.6873L1231.19 73.6236C1231.4 73.3077 1231.8 73.2002 1232.14 73.3639L1232.2 73.4022C1232.52 73.6001 1232.63 74.0056 1232.46 74.3317L1232.42 74.3983C1232.22 74.7118 1231.81 74.8189 1231.48 74.6551L1231.42 74.6197C1231.1 74.419 1230.99 74.0159 1231.16 73.6873Z",
    stroke: "white"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.68 43.8528C1233.59 43.4649 1233.84 43.0775 1234.23 42.9895C1234.63 42.8987 1235.02 43.1432 1235.11 43.531C1235.2 43.9189 1234.95 44.3063 1234.56 44.3943C1234.16 44.4851 1233.77 44.2406 1233.68 43.8528Z",
    stroke: "white"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.37 77.1033L1175.41 77.0396C1175.61 76.7237 1176.02 76.6162 1176.35 76.78L1176.41 76.8182C1176.73 77.0165 1176.84 77.4216 1176.68 77.7478L1176.64 77.8143C1176.44 78.1278 1176.03 78.2349 1175.7 78.0711L1175.63 78.0357C1175.31 77.835 1175.2 77.4319 1175.37 77.1033Z",
    stroke: "white"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.91 129.442L1220.94 129.378C1221.15 129.062 1221.55 128.955 1221.88 129.118L1221.95 129.154C1222.27 129.354 1222.38 129.76 1222.21 130.086L1222.18 130.15C1221.97 130.466 1221.56 130.573 1221.23 130.41L1221.17 130.374C1220.85 130.173 1220.74 129.768 1220.91 129.442Z",
    stroke: "white"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.04 123.178L1146.07 123.114C1146.28 122.798 1146.69 122.691 1147.02 122.855L1147.08 122.891C1147.4 123.091 1147.51 123.496 1147.34 123.822L1147.31 123.887C1147.1 124.203 1146.7 124.31 1146.37 124.146L1146.3 124.11C1145.98 123.91 1145.87 123.504 1146.04 123.178Z",
    stroke: "white"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.66 121.923C1123.57 121.533 1123.82 121.148 1124.21 121.061C1124.61 120.974 1125 121.22 1125.08 121.61C1125.17 121.997 1124.92 122.382 1124.53 122.469C1124.14 122.558 1123.75 122.313 1123.66 121.923Z",
    stroke: "white"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.67 -8.20838L1052.28 -5.57417L1049.05 0.648858L1049.96 3.91033L1054.13 1.01477L1057.65 -4.90341L1056.67 -8.20838Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.7 -8.6078L1047.97 -5.42118L1044.85 1.05444L1045.38 4.07415L1049.05 0.650611L1052.28 -5.57242L1051.7 -8.6078Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.85 1.05254L1041.64 4.9108L1038.85 11.8965L1039.4 14.8372L1042.69 10.8821L1045.38 4.07226L1044.85 1.05254Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.69 10.8831L1039.4 14.8383L1036.99 21.9015L1038.02 24.8499L1041.35 20.9245L1043.63 14.013L1042.69 10.8831Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.85 11.8982L1035.85 16.1301L1033.16 23.2706L1033.76 26.0969L1036.99 21.9021L1039.4 14.8389L1038.85 11.8982Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.37 -9.65836L1075.39 -9.42926L1070.09 -4.85381L1071.6 -1.12921L1078.7 -2.10033L1084.14 -6.11743L1082.37 -9.65836Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.1 -4.85586L1064.07 -3.39102L1060.06 2.18752L1061.4 5.91525L1066.87 4.09197L1071.61 -1.12889L1070.1 -4.85586Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.06 2.18829L1055.31 4.52738L1052.29 10.8099L1053.6 14.4164L1057.91 11.8841L1061.4 5.91602L1060.06 2.18829Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.13 1.01675L1049.96 3.91231L1047.2 10.4795L1048.39 13.8469L1052.29 10.811L1055.31 4.52892L1054.13 1.01675Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.21 10.4779L1043.63 14.0125L1041.35 20.9239L1042.63 24.075L1046.06 20.5466L1048.39 13.8453L1047.21 10.4779Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.04 -10.6011L1102.21 -8.52979L1098.18 -4.02814L1100.1 -0.888905L1106.13 -2.95797L1110.04 -8.2223L1108.04 -10.6011Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.18 -4.02751L1092.12 -2.95061L1087.78 1.16128L1089.59 4.80386L1095.85 3.90267L1100.1 -0.888276L1098.18 -4.02751Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.78 1.16133L1080.39 1.68003L1074.68 6.53928L1076.17 10.3912L1083.69 9.21154L1089.59 4.80391L1087.78 1.16133Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.7 -2.09896L1071.6 -1.12734L1066.87 4.09113L1068.31 7.9515L1074.68 6.53913L1080.39 1.67698L1078.7 -2.09896Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.94 -13.1573L1118.03 -9.1497L1114.22 -3.09218L1116.39 -0.295045L1122.75 -4.08898L1126.38 -10.9187L1123.94 -13.1573Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.86 -11.339L1110.04 -8.22263L1106.13 -2.95826L1108.15 -0.0620147L1114.23 -3.09112L1118.03 -9.14868L1115.86 -11.339Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.23 -3.09231L1108.15 -0.0632454L1103.95 5.46387L1105.82 8.65107L1112.32 5.90241L1116.4 -0.295217L1114.23 -3.09231Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.46 -15.5992L1136.38 -11.8548L1133.6 -3.77814L1138.62 1.54776L1146.3 -1.3057L1148.41 -10.3309L1143.46 -15.5992Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.66 -15.3869L1126.38 -10.9184L1122.76 -4.08861L1126.3 -0.44781L1133.6 -3.77919L1136.37 -11.8533L1132.66 -15.3869Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.6 -3.77886L1126.3 -0.447475L1123.22 7.13196L1128.28 12.5344L1136.33 10.2274L1138.62 1.54663L1133.6 -3.77886Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.76 -4.08752L1116.4 -0.293585L1112.33 5.90409L1115.66 9.69388L1123.23 7.13283L1126.31 -0.446599L1122.76 -4.08752Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.32 5.90411L1105.82 8.65273L1101.21 13.8485L1104.31 17.8599L1112.19 16.4509L1115.65 9.69386L1112.32 5.90411Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.1 -21.431L1170.17 -19.0009L1168.6 -9.39268L1174.3 -1.91284L1181.17 -4.15514L1182.43 -14.0254L1177.1 -21.431Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.6 -9.3911L1161.34 -6.82071L1159.74 2.85259L1165.75 10.3589L1173.64 8.60455L1174.3 -1.91127L1168.6 -9.3911Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.77 -13.4236L1148.4 -10.3329L1146.3 -1.30766L1152.11 5.323L1159.74 2.85153L1161.34 -6.82177L1155.77 -13.4236Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.3 -1.30697L1138.62 1.54649L1136.33 10.2277L1142.33 16.8892L1150.38 14.7857L1152.11 5.3241L1146.3 -1.30697Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M849.569 159.948L843.677 160.995L839.498 164.813L841.354 168.207L847.416 167.129L851.281 162.552L849.569 159.948Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.09 168.582L1388.38 168.083L1385.38 174.504L1396.71 181.745L1412.15 181.773L1415.13 175.675L1404.09 168.582Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.37 175.542L1415.13 175.674L1412.15 181.772L1423.3 189.227L1438.74 189.255L1441.82 182.809L1431.37 175.542Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.28 182.551L1441.82 182.809L1438.74 189.255L1450.08 196.014L1465.07 196.296L1468.28 190.071L1458.28 182.551Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M1419.2 195.958L1401.24 196.188L1396.54 204.436L1406.28 211.515L1425.36 212.702L1429.9 203.665L1419.2 195.958Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.54 204.437L1380.4 204.221L1372.22 214.15L1381.24 222.524L1397.76 221.351L1406.28 211.516L1396.54 204.437Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.14 236.557L1375.56 233.679L1381.24 222.525L1372.22 214.15L1356.08 215.986L1350.41 227.14L1359.14 236.557Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.42 243.317L1400.84 240.439L1406.53 229.284L1397.76 221.351L1381.23 222.525L1375.55 233.679L1384.42 243.317Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.19 257.127L1378.61 254.249L1384.29 243.095L1375.55 233.678L1359.13 236.556L1351.91 247.114L1362.19 257.127Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.71 249.868L1351.91 247.115L1359.13 236.557L1350.4 227.142L1333.97 230.02L1326.63 240.357L1335.71 249.868Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.73 269.814L1351.77 268.381L1360.35 255.522L1351.91 247.116L1335.71 249.867L1326.36 259.294L1335.73 269.814Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.64 240.356L1309.36 244.308L1303.77 255.116L1311.98 261.599L1326.36 259.294L1335.72 249.867L1326.64 240.356Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.13 170.71L1434.38 170.014L1431.37 175.544L1441.82 182.811C1448.22 182.714 1451.87 182.648 1458.27 182.552L1460.49 177.183L1448.13 170.71Z",
    stroke: "white",
    strokeWidth: 0.1651,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26527_261466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 134) scale(516.364 567.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0055FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07122C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmLandingPageNewBg);
export default __webpack_public_path__ + "static/media/DM-Landing-Page-New-BG.6e49807fe53aff22a925f97b14a15c75.svg";
export { ForwardRef as ReactComponent };